// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/vision_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";
import { CameraIntrinsics, protoMetadata as protoMetadata3 } from "./camera_bot_service";
import { Point, Point2D, protoMetadata as protoMetadata2 } from "./geometry";
import { CartesianPose, protoMetadata as protoMetadata4 } from "./teleop_bot_service";

export const protobufPackage = "visionbot";

/**
 * Why a taught contour did not yield a usable orientation frame. The two
 * failures have different remedies, so the UI must be able to tell them apart:
 * a symmetric part can never work, while an inconsistent scene usually means
 * the segmentation needs better lighting or a tighter ROI before re-teaching.
 */
export enum OrientationReferenceRejection {
  ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED = 0,
  /** ORIENTATION_REFERENCE_REJECTION_SYMMETRIC - The shape is rotationally ambiguous (near-square, circular). */
  ORIENTATION_REFERENCE_REJECTION_SYMMETRIC = 1,
  /** ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT - The teach scene's own matches could not be registered to the primary. */
  ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT = 2,
  UNRECOGNIZED = -1,
}

export function orientationReferenceRejectionFromJSON(object: any): OrientationReferenceRejection {
  switch (object) {
    case 0:
    case "ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED":
      return OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED;
    case 1:
    case "ORIENTATION_REFERENCE_REJECTION_SYMMETRIC":
      return OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_SYMMETRIC;
    case 2:
    case "ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT":
      return OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrientationReferenceRejection.UNRECOGNIZED;
  }
}

export function orientationReferenceRejectionToJSON(object: OrientationReferenceRejection): string {
  switch (object) {
    case OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED:
      return "ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED";
    case OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_SYMMETRIC:
      return "ORIENTATION_REFERENCE_REJECTION_SYMMETRIC";
    case OrientationReferenceRejection.ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT:
      return "ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT";
    case OrientationReferenceRejection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ErrorCode {
  UNKNOWN_ERROR = 0,
  MODEL_NOT_FOUND = 1,
  INVALID_IMAGE = 2,
  INFERENCE_FAILED = 3,
  INVALID_MODEL_TYPE = 4,
  INVALID_THRESHOLDING_PARAMS = 5,
  MISSING_DEPTH_IMAGE = 6,
  PLANE_ESTIMATION_FAILED = 7,
  INVALID_CAMERA_PARAMS = 8,
  NOT_IMPLEMENTED = 9,
  TEMPLATE_TOO_SMALL = 10,
  INVALID_BLOB_DETECTION_PARAMS = 11,
  CALIBRATION_FAILED = 12,
  INVALID_OBJECT_REFERENCE = 13,
  POSE_ESTIMATION_FAILED = 14,
  SCENE_PLANE_NOT_FOUND = 15,
  INVALID_REGION_MASK = 16,
  /** ROBOFLOW_UNAVAILABLE - inference container not reachable */
  ROBOFLOW_UNAVAILABLE = 17,
  /** ROBOFLOW_NOT_PRELOADED - not cached and no network to fetch (offline miss) */
  ROBOFLOW_NOT_PRELOADED = 18,
  UNRECOGNIZED = -1,
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "UNKNOWN_ERROR":
      return ErrorCode.UNKNOWN_ERROR;
    case 1:
    case "MODEL_NOT_FOUND":
      return ErrorCode.MODEL_NOT_FOUND;
    case 2:
    case "INVALID_IMAGE":
      return ErrorCode.INVALID_IMAGE;
    case 3:
    case "INFERENCE_FAILED":
      return ErrorCode.INFERENCE_FAILED;
    case 4:
    case "INVALID_MODEL_TYPE":
      return ErrorCode.INVALID_MODEL_TYPE;
    case 5:
    case "INVALID_THRESHOLDING_PARAMS":
      return ErrorCode.INVALID_THRESHOLDING_PARAMS;
    case 6:
    case "MISSING_DEPTH_IMAGE":
      return ErrorCode.MISSING_DEPTH_IMAGE;
    case 7:
    case "PLANE_ESTIMATION_FAILED":
      return ErrorCode.PLANE_ESTIMATION_FAILED;
    case 8:
    case "INVALID_CAMERA_PARAMS":
      return ErrorCode.INVALID_CAMERA_PARAMS;
    case 9:
    case "NOT_IMPLEMENTED":
      return ErrorCode.NOT_IMPLEMENTED;
    case 10:
    case "TEMPLATE_TOO_SMALL":
      return ErrorCode.TEMPLATE_TOO_SMALL;
    case 11:
    case "INVALID_BLOB_DETECTION_PARAMS":
      return ErrorCode.INVALID_BLOB_DETECTION_PARAMS;
    case 12:
    case "CALIBRATION_FAILED":
      return ErrorCode.CALIBRATION_FAILED;
    case 13:
    case "INVALID_OBJECT_REFERENCE":
      return ErrorCode.INVALID_OBJECT_REFERENCE;
    case 14:
    case "POSE_ESTIMATION_FAILED":
      return ErrorCode.POSE_ESTIMATION_FAILED;
    case 15:
    case "SCENE_PLANE_NOT_FOUND":
      return ErrorCode.SCENE_PLANE_NOT_FOUND;
    case 16:
    case "INVALID_REGION_MASK":
      return ErrorCode.INVALID_REGION_MASK;
    case 17:
    case "ROBOFLOW_UNAVAILABLE":
      return ErrorCode.ROBOFLOW_UNAVAILABLE;
    case 18:
    case "ROBOFLOW_NOT_PRELOADED":
      return ErrorCode.ROBOFLOW_NOT_PRELOADED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.UNKNOWN_ERROR:
      return "UNKNOWN_ERROR";
    case ErrorCode.MODEL_NOT_FOUND:
      return "MODEL_NOT_FOUND";
    case ErrorCode.INVALID_IMAGE:
      return "INVALID_IMAGE";
    case ErrorCode.INFERENCE_FAILED:
      return "INFERENCE_FAILED";
    case ErrorCode.INVALID_MODEL_TYPE:
      return "INVALID_MODEL_TYPE";
    case ErrorCode.INVALID_THRESHOLDING_PARAMS:
      return "INVALID_THRESHOLDING_PARAMS";
    case ErrorCode.MISSING_DEPTH_IMAGE:
      return "MISSING_DEPTH_IMAGE";
    case ErrorCode.PLANE_ESTIMATION_FAILED:
      return "PLANE_ESTIMATION_FAILED";
    case ErrorCode.INVALID_CAMERA_PARAMS:
      return "INVALID_CAMERA_PARAMS";
    case ErrorCode.NOT_IMPLEMENTED:
      return "NOT_IMPLEMENTED";
    case ErrorCode.TEMPLATE_TOO_SMALL:
      return "TEMPLATE_TOO_SMALL";
    case ErrorCode.INVALID_BLOB_DETECTION_PARAMS:
      return "INVALID_BLOB_DETECTION_PARAMS";
    case ErrorCode.CALIBRATION_FAILED:
      return "CALIBRATION_FAILED";
    case ErrorCode.INVALID_OBJECT_REFERENCE:
      return "INVALID_OBJECT_REFERENCE";
    case ErrorCode.POSE_ESTIMATION_FAILED:
      return "POSE_ESTIMATION_FAILED";
    case ErrorCode.SCENE_PLANE_NOT_FOUND:
      return "SCENE_PLANE_NOT_FOUND";
    case ErrorCode.INVALID_REGION_MASK:
      return "INVALID_REGION_MASK";
    case ErrorCode.ROBOFLOW_UNAVAILABLE:
      return "ROBOFLOW_UNAVAILABLE";
    case ErrorCode.ROBOFLOW_NOT_PRELOADED:
      return "ROBOFLOW_NOT_PRELOADED";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * In-plane grasp orientation reference for plane projection. OBJECT aligns the
 * grasp X to the detection's principal axis (with a square-deadband fallback to
 * plane X); PLANE aligns to the plane's X axis; WORLD aligns to base-frame X
 * projected onto the plane. Approach (Z) is always the plane normal.
 */
export enum GraspFrame {
  OBJECT = 0,
  PLANE = 1,
  WORLD = 2,
  UNRECOGNIZED = -1,
}

export function graspFrameFromJSON(object: any): GraspFrame {
  switch (object) {
    case 0:
    case "OBJECT":
      return GraspFrame.OBJECT;
    case 1:
    case "PLANE":
      return GraspFrame.PLANE;
    case 2:
    case "WORLD":
      return GraspFrame.WORLD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GraspFrame.UNRECOGNIZED;
  }
}

export function graspFrameToJSON(object: GraspFrame): string {
  switch (object) {
    case GraspFrame.OBJECT:
      return "OBJECT";
    case GraspFrame.PLANE:
      return "PLANE";
    case GraspFrame.WORLD:
      return "WORLD";
    case GraspFrame.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ExtrinsicsKind {
  BASE = 0,
  TCP = 1,
  UNRECOGNIZED = -1,
}

export function extrinsicsKindFromJSON(object: any): ExtrinsicsKind {
  switch (object) {
    case 0:
    case "BASE":
      return ExtrinsicsKind.BASE;
    case 1:
    case "TCP":
      return ExtrinsicsKind.TCP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExtrinsicsKind.UNRECOGNIZED;
  }
}

export function extrinsicsKindToJSON(object: ExtrinsicsKind): string {
  switch (object) {
    case ExtrinsicsKind.BASE:
      return "BASE";
    case ExtrinsicsKind.TCP:
      return "TCP";
    case ExtrinsicsKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PoseEstimationMethod {
  /** OBB_DEPTH - oriented bounding box from depth point cloud (no CAD, zero-config) */
  OBB_DEPTH = 0,
  /** ICP - point cloud registration against CAD model */
  ICP = 1,
  /** FOUNDATION_POSE - (M2) FoundationPose 6DoF pose estimation */
  FOUNDATION_POSE = 2,
  /** OBB_ICP - OBB initial guess + ICP refinement against primitive mesh or CAD */
  OBB_ICP = 3,
  /** FPFH_ICP - FPFH feature-based global registration + ICP refinement (no initial guess; */
  FPFH_ICP = 4,
  UNRECOGNIZED = -1,
}

export function poseEstimationMethodFromJSON(object: any): PoseEstimationMethod {
  switch (object) {
    case 0:
    case "OBB_DEPTH":
      return PoseEstimationMethod.OBB_DEPTH;
    case 1:
    case "ICP":
      return PoseEstimationMethod.ICP;
    case 2:
    case "FOUNDATION_POSE":
      return PoseEstimationMethod.FOUNDATION_POSE;
    case 3:
    case "OBB_ICP":
      return PoseEstimationMethod.OBB_ICP;
    case 4:
    case "FPFH_ICP":
      return PoseEstimationMethod.FPFH_ICP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PoseEstimationMethod.UNRECOGNIZED;
  }
}

export function poseEstimationMethodToJSON(object: PoseEstimationMethod): string {
  switch (object) {
    case PoseEstimationMethod.OBB_DEPTH:
      return "OBB_DEPTH";
    case PoseEstimationMethod.ICP:
      return "ICP";
    case PoseEstimationMethod.FOUNDATION_POSE:
      return "FOUNDATION_POSE";
    case PoseEstimationMethod.OBB_ICP:
      return "OBB_ICP";
    case PoseEstimationMethod.FPFH_ICP:
      return "FPFH_ICP";
    case PoseEstimationMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PrimitiveShapeType {
  BOX = 0,
  CYLINDER = 1,
  UNRECOGNIZED = -1,
}

export function primitiveShapeTypeFromJSON(object: any): PrimitiveShapeType {
  switch (object) {
    case 0:
    case "BOX":
      return PrimitiveShapeType.BOX;
    case 1:
    case "CYLINDER":
      return PrimitiveShapeType.CYLINDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PrimitiveShapeType.UNRECOGNIZED;
  }
}

export function primitiveShapeTypeToJSON(object: PrimitiveShapeType): string {
  switch (object) {
    case PrimitiveShapeType.BOX:
      return "BOX";
    case PrimitiveShapeType.CYLINDER:
      return "CYLINDER";
    case PrimitiveShapeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CadModelUnits {
  CAD_MODEL_UNITS_UNSPECIFIED = 0,
  CAD_MODEL_UNITS_METERS = 1,
  CAD_MODEL_UNITS_MILLIMETERS = 2,
  CAD_MODEL_UNITS_CENTIMETERS = 3,
  CAD_MODEL_UNITS_INCHES = 4,
  UNRECOGNIZED = -1,
}

export function cadModelUnitsFromJSON(object: any): CadModelUnits {
  switch (object) {
    case 0:
    case "CAD_MODEL_UNITS_UNSPECIFIED":
      return CadModelUnits.CAD_MODEL_UNITS_UNSPECIFIED;
    case 1:
    case "CAD_MODEL_UNITS_METERS":
      return CadModelUnits.CAD_MODEL_UNITS_METERS;
    case 2:
    case "CAD_MODEL_UNITS_MILLIMETERS":
      return CadModelUnits.CAD_MODEL_UNITS_MILLIMETERS;
    case 3:
    case "CAD_MODEL_UNITS_CENTIMETERS":
      return CadModelUnits.CAD_MODEL_UNITS_CENTIMETERS;
    case 4:
    case "CAD_MODEL_UNITS_INCHES":
      return CadModelUnits.CAD_MODEL_UNITS_INCHES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CadModelUnits.UNRECOGNIZED;
  }
}

export function cadModelUnitsToJSON(object: CadModelUnits): string {
  switch (object) {
    case CadModelUnits.CAD_MODEL_UNITS_UNSPECIFIED:
      return "CAD_MODEL_UNITS_UNSPECIFIED";
    case CadModelUnits.CAD_MODEL_UNITS_METERS:
      return "CAD_MODEL_UNITS_METERS";
    case CadModelUnits.CAD_MODEL_UNITS_MILLIMETERS:
      return "CAD_MODEL_UNITS_MILLIMETERS";
    case CadModelUnits.CAD_MODEL_UNITS_CENTIMETERS:
      return "CAD_MODEL_UNITS_CENTIMETERS";
    case CadModelUnits.CAD_MODEL_UNITS_INCHES:
      return "CAD_MODEL_UNITS_INCHES";
    case CadModelUnits.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Segmentation/refinement backend used to turn box prompts + the DINO heatmap
 * into a pixel mask. SAM2 is the prompt-based zero-shot segmenter; the two
 * filters are CPU-only edge-aware refiners that sharpen the dense heatmap to
 * image edges (no GPU, no model download).
 */
export enum SegmentationMethod {
  /** SEGMENTATION_METHOD_SAM2 - default == existing behavior */
  SEGMENTATION_METHOD_SAM2 = 0,
  SEGMENTATION_METHOD_GUIDED_FILTER = 1,
  SEGMENTATION_METHOD_BILATERAL_SOLVER = 2,
  /**
   * SEGMENTATION_METHOD_HEATMAP_THRESHOLD - Model-free: trace the object contour directly where the dense DINO heatmap
   * crosses `heatmap_threshold` (cv2.findContours on the binarized heatmap).
   * Requires `heatmap_dense` like the filter methods; ignores `heatmap_samples`
   * and per-box `points`.
   */
  SEGMENTATION_METHOD_HEATMAP_THRESHOLD = 3,
  UNRECOGNIZED = -1,
}

export function segmentationMethodFromJSON(object: any): SegmentationMethod {
  switch (object) {
    case 0:
    case "SEGMENTATION_METHOD_SAM2":
      return SegmentationMethod.SEGMENTATION_METHOD_SAM2;
    case 1:
    case "SEGMENTATION_METHOD_GUIDED_FILTER":
      return SegmentationMethod.SEGMENTATION_METHOD_GUIDED_FILTER;
    case 2:
    case "SEGMENTATION_METHOD_BILATERAL_SOLVER":
      return SegmentationMethod.SEGMENTATION_METHOD_BILATERAL_SOLVER;
    case 3:
    case "SEGMENTATION_METHOD_HEATMAP_THRESHOLD":
      return SegmentationMethod.SEGMENTATION_METHOD_HEATMAP_THRESHOLD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SegmentationMethod.UNRECOGNIZED;
  }
}

export function segmentationMethodToJSON(object: SegmentationMethod): string {
  switch (object) {
    case SegmentationMethod.SEGMENTATION_METHOD_SAM2:
      return "SEGMENTATION_METHOD_SAM2";
    case SegmentationMethod.SEGMENTATION_METHOD_GUIDED_FILTER:
      return "SEGMENTATION_METHOD_GUIDED_FILTER";
    case SegmentationMethod.SEGMENTATION_METHOD_BILATERAL_SOLVER:
      return "SEGMENTATION_METHOD_BILATERAL_SOLVER";
    case SegmentationMethod.SEGMENTATION_METHOD_HEATMAP_THRESHOLD:
      return "SEGMENTATION_METHOD_HEATMAP_THRESHOLD";
    case SegmentationMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum LocateHeadKind {
  LOCATE_HEAD_KIND_UNSPECIFIED = 0,
  LOCATE_HEAD_KIND_MLP = 1,
  LOCATE_HEAD_KIND_LOGISTIC = 2,
  UNRECOGNIZED = -1,
}

export function locateHeadKindFromJSON(object: any): LocateHeadKind {
  switch (object) {
    case 0:
    case "LOCATE_HEAD_KIND_UNSPECIFIED":
      return LocateHeadKind.LOCATE_HEAD_KIND_UNSPECIFIED;
    case 1:
    case "LOCATE_HEAD_KIND_MLP":
      return LocateHeadKind.LOCATE_HEAD_KIND_MLP;
    case 2:
    case "LOCATE_HEAD_KIND_LOGISTIC":
      return LocateHeadKind.LOCATE_HEAD_KIND_LOGISTIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LocateHeadKind.UNRECOGNIZED;
  }
}

export function locateHeadKindToJSON(object: LocateHeadKind): string {
  switch (object) {
    case LocateHeadKind.LOCATE_HEAD_KIND_UNSPECIFIED:
      return "LOCATE_HEAD_KIND_UNSPECIFIED";
    case LocateHeadKind.LOCATE_HEAD_KIND_MLP:
      return "LOCATE_HEAD_KIND_MLP";
    case LocateHeadKind.LOCATE_HEAD_KIND_LOGISTIC:
      return "LOCATE_HEAD_KIND_LOGISTIC";
    case LocateHeadKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A post-segmentation instance: precise contour + mask. No bounding box —
 * center/extents are derived from the contour by consumers. See Detection2D
 * for the pre-segmentation detector box.
 */
export interface Blob2D {
  score: number;
  contour: Point2D[];
  area?: number | undefined;
  classId?: number | undefined;
  className?:
    | string
    | undefined;
  /** RLE-encoded dense segmentation mask (from SAM2) */
  maskRle?:
    | Uint8Array
    | undefined;
  /** mask dimensions (matches source image dimensions) */
  maskWidth?: number | undefined;
  maskHeight?: number | undefined;
}

/**
 * A pre-segmentation detector result: the coarse (optionally oriented) box a
 * detector emits. Used as the SAM2 prompt and as the fallback shape when
 * segmentation is off or produces no contour.
 */
export interface Detection2D {
  x: number;
  y: number;
  width: number;
  height: number;
  /** radians */
  rotation: number;
  score: number;
  classId?: number | undefined;
  className?: string | undefined;
}

/**
 * Pairs a detector result with its optional segmentation. `segment` is unset
 * when segmentation is disabled or returns no contour.
 */
export interface LocateMatch {
  detection: Detection2D | undefined;
  segment?: Blob2D | undefined;
}

/**
 * A persisted canonical orientation frame for a taught locate target. The
 * reference_contour is normalized (centroid-centered, sqrt(area)-scaled,
 * PCA-rotated, arc-length-resampled to a fixed point count). Its pose encodes
 * the canonical frame; inference registers detected contours against it.
 */
export interface OrientationReference {
  referenceContour: Point2D[];
}

export interface Contour2D {
  points: Point2D[];
}

export interface ComputeOrientationReferenceRequest {
  /** Taught-instance contour in image-pixel space (the primary match segment). */
  contour: Point2D[];
  /**
   * The teach scene's OTHER matches, same space as `contour`. The primary is
   * accepted as a reference only if every one of these registers to it, which
   * is how a too-noisy segmentation gets caught at teach time instead of
   * flapping at inference. Empty (a single-match scene, or an older client)
   * reproduces the previous behaviour exactly.
   */
  siblingContours: Contour2D[];
}

export interface ComputeOrientationReferenceData {
  /** True when the taught shape supports a stable, non-symmetric frame. */
  isReliable: boolean;
  /** Present (populated) only when is_reliable is true. */
  reference:
    | OrientationReference
    | undefined;
  /** Set only when is_reliable is false. */
  rejection: OrientationReferenceRejection;
}

export interface ComputeOrientationReferenceResponse {
  data?: ComputeOrientationReferenceData | undefined;
  error?: Error | undefined;
}

/** Available model information */
export interface Model {
  modelPath: string;
}

export interface ModelList {
  models: Model[];
}

/** Request to run inference on an image */
export interface RunCheckpointBasedInferenceRequest {
  /** Image data as bytes */
  image: Uint8Array;
  /** Path to the model checkpoint file */
  modelPath: string;
  /** Type of model to determine preprocessing/postprocessing */
  modelType: string;
  /** Model-specific thresholding parameters */
  thresholdingParams: { [key: string]: string };
  /** When true, include RLE-encoded SAM2 segmentation masks in each Blob2D */
  includeMasks?: boolean | undefined;
}

export interface RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
  key: string;
  value: string;
}

/** Response from inference */
export interface RunCheckpointBasedInferenceResponse {
  /** Successful inference result */
  data?:
    | CheckpointBasedInferenceResult
    | undefined;
  /** Error information */
  error?: Error | undefined;
}

/** Successful inference result */
export interface CheckpointBasedInferenceResult {
  /** Detected matches (detector box + contour, optionally a mask) */
  blobs: LocateMatch[];
  /** Processing time in milliseconds */
  processingTimeMs?:
    | number
    | undefined;
  /** Model path */
  modelPath?: string | undefined;
}

/** Error information */
export interface Error {
  code: ErrorCode;
  message: string;
}

/** Request to compute 3D poses from 2D detections */
export interface RunPlaneProjectionRequest {
  /** from any detection method (YOLO, text prompt, manual, etc) */
  detections: LocateMatch[];
  /** RGB image */
  image: Uint8Array;
  /** required for GeometricPlane, optional for ManualPlane */
  depthImage?:
    | Uint8Array
    | undefined;
  /** extrinsics/intrinsics */
  cameraParams:
    | CameraParams
    | undefined;
  /** ManualPlane, GeometricPlane, LearnedPlane */
  planeMethod: PlaneDetectionMethod | undefined;
  includeDebugVisualization?:
    | boolean
    | undefined;
  /** in-plane grasp orientation reference (default OBJECT) */
  graspFrame: GraspFrame;
  /**
   * Canonical orientation frame from teach time (when reliable). When present
   * and grasp_frame == OBJECT, ManualPlane registers each detected contour
   * against this instead of bare PCA, resolving the 180° flip.
   */
  orientationReference?: OrientationReference | undefined;
}

/** Camera intrinsics/extrinsics needed for 2D→3D conversion */
export interface CameraParams {
  intrinsics: CameraIntrinsics | undefined;
  extrinsics: CartesianPose | undefined;
  extrinsicsKind: ExtrinsicsKind;
  /** robot ee pose in base frame */
  robotPose?: CartesianPose | undefined;
}

export interface PlaneDetectionMethod {
  manual?: ManualPlane | undefined;
  geometric?: GeometricPlane | undefined;
  learned?: LearnedPlane | undefined;
}

/** Fixed plane defined by three points */
export interface ManualPlane {
  origin: Point | undefined;
  plusX: Point | undefined;
  plusY:
    | Point
    | undefined;
  /** Offset along plane normal (meters) */
  objectHeight?: number | undefined;
}

/** RANSAC plane fitting on local depth within each detection's bounding box */
export interface GeometricPlane {
  /** RANSAC iterations (default: 1000) */
  maxIterations?:
    | number
    | undefined;
  /** Inlier distance threshold in meters (default: 0.01) */
  distanceThreshold?:
    | number
    | undefined;
  /** Minimum points for plane fit (default: 3) */
  minSamples?:
    | number
    | undefined;
  /** Max tilt from base-frame Z-axis in degrees (default: no filtering) */
  maxTiltAngle?: number | undefined;
}

/** Learned surface normal estimation (M2 placeholder) */
export interface LearnedPlane {
  modelPath: string;
}

export interface RunPlaneProjectionResponse {
  data?: PlaneProjectionResult | undefined;
  error?: Error | undefined;
}

export interface PlaneProjectionResult {
  /** 3D detections with 6D poses */
  detections: Detection3D[];
  processingTimeMs?:
    | number
    | undefined;
  /** colorized depth map with overlays */
  debugVisualization?: Uint8Array | undefined;
}

export interface Detection3D {
  /** original 2D detection for debugging */
  blob2d:
    | Detection2D
    | undefined;
  /** 6D pose in base frame */
  pose:
    | CartesianPose
    | undefined;
  /** Surface normal at detection point (in base frame) */
  surfaceNormal:
    | Point
    | undefined;
  /** 2D detection confidence score */
  score: number;
  /** RANSAC plane fit quality, GeometricPlane only */
  inlierRatio?:
    | number
    | undefined;
  /** OBB half-extents in meters (x=largest, y=medium, z=smallest) */
  extents?:
    | Point
    | undefined;
  /**
   * SAM2 segmentation echoed back from the input LocateMatch.segment so callers
   * can render the contour (not just the detector box). Unset when the input
   * match had no segment.
   */
  segment?: Blob2D | undefined;
}

export interface BlobDetectionParams {
  minThreshold: number;
  maxThreshold: number;
  minArea: number;
  maxArea: number;
  filterByCircularity: boolean;
  filterByConvexity: boolean;
  filterByInertia: boolean;
  minCircularity: number;
  maxCircularity: number;
  invertImage: boolean;
}

export interface DetectBlobsRequest {
  image: Uint8Array;
  params: BlobDetectionParams | undefined;
}

export interface DetectBlobsResponse {
  data?: BlobList | undefined;
  error?: Error | undefined;
}

export interface BlobList {
  /** OpenCV/template/text-prompt: detector box + contour */
  blobs: LocateMatch[];
}

export interface ShapeDetectionParams {
  minScale: number;
  maxScale: number;
  maxRotation: number;
  matchThreshold: number;
  filterIntersections: boolean;
  rejectOnEdge: boolean;
}

export interface DetectShapesRequest {
  templateImage: Uint8Array;
  targetImage: Uint8Array;
  params: ShapeDetectionParams | undefined;
}

export interface DetectShapesResponse {
  data?: BlobList | undefined;
  error?: Error | undefined;
}

export interface TextPromptDetectionParams {
  prompt: string;
  useSam: boolean;
  boxThreshold: number;
  textThreshold: number;
}

export interface DetectTextPromptRequest {
  image: Uint8Array;
  params: TextPromptDetectionParams | undefined;
}

export interface DetectTextPromptResponse {
  data?: BlobList | undefined;
  error?: Error | undefined;
}

export interface ClassifyRequest {
  encodedFrame: Uint8Array;
  encodedTemplateImages: Uint8Array[];
}

export interface ClassifyResponse {
  data?: ClassifyResult | undefined;
  error?: Error | undefined;
}

export interface ClassifyResult {
  scores: number[];
}

export interface Chessboard {
  kind: string;
  numRows: number;
  numCols: number;
  squareSize: number;
  arucoDict?: string | undefined;
  markerSize?: number | undefined;
}

export interface CameraIntrinsicsMsg {
  fx: number;
  fy: number;
  ppx: number;
  ppy: number;
  width: number;
  height: number;
  error?: number | undefined;
}

export interface CameraIntrinsicsExtendedMsg {
  fx: number;
  fy: number;
  ppx: number;
  ppy: number;
  width: number;
  height: number;
  distortionCoefficients: number[];
  distortionModel: string;
  error?: number | undefined;
}

export interface GetChessboardCornersRequest {
  image: Uint8Array;
  chessboard: Chessboard | undefined;
}

export interface GetChessboardCornersResponse {
  data?: ChessboardCornersResult | undefined;
  error?: Error | undefined;
}

export interface ChessboardCornersResult {
  isDetected: boolean;
  corners: Point2D[];
}

export interface GetCameraChessboardTransformRequest {
  image: Uint8Array;
  chessboard: Chessboard | undefined;
  intrinsics: CameraIntrinsicsMsg | undefined;
}

export interface GetCameraChessboardTransformResponse {
  data?: CartesianPose | undefined;
  error?: Error | undefined;
}

export interface CalibrateCameraRequest {
  images: Uint8Array[];
  chessboard: Chessboard | undefined;
  poses: CartesianPose[];
}

export interface CalibrateCameraResponse {
  data?: IntrinsicCalibrationResult | undefined;
  error?: Error | undefined;
}

export interface IntrinsicCalibrationResult {
  intrinsics: CameraIntrinsicsMsg | undefined;
  gripperToCam?: CartesianPose | undefined;
}

export interface CalibrateCameraIntrinsicsRequest {
  images: Uint8Array[];
  chessboard: Chessboard | undefined;
}

export interface CalibrateCameraIntrinsicsResponse {
  data?: CameraIntrinsicsExtendedMsg | undefined;
  error?: Error | undefined;
}

export interface CalibrateCameraExtrinsicsRequest {
  images: Uint8Array[];
  poses: CartesianPose[];
  chessboard: Chessboard | undefined;
  intrinsics: CameraIntrinsicsExtendedMsg | undefined;
  mountType: string;
}

export interface CalibrateCameraExtrinsicsResponse {
  data?: CartesianPose | undefined;
  error?: Error | undefined;
}

export interface AssessCalibrationCoverageRequest {
  images: Uint8Array[];
  chessboard: Chessboard | undefined;
  calibrationType: string;
  poses: CartesianPose[];
  intrinsics: CameraIntrinsicsExtendedMsg | undefined;
}

export interface CoverageBucketMsg {
  key: string;
  filled: boolean;
}

export interface QualityIssueMsg {
  index: number;
  issue: string;
}

export interface CalibrationRecommendationMsg {
  kind: string;
  detail: string;
}

export interface CalibrationCoverageResultMsg {
  coverageBuckets: CoverageBucketMsg[];
  perViewErrors: number[];
  reprojectionError?: number | undefined;
  qualityIssues: QualityIssueMsg[];
  converged: boolean;
  recommendation: CalibrationRecommendationMsg | undefined;
}

export interface AssessCalibrationCoverageResponse {
  data?: CalibrationCoverageResultMsg | undefined;
  error?: Error | undefined;
}

export interface PrimitiveShape {
  shapeType: PrimitiveShapeType;
  /** box: length (m), cylinder: diameter (m) */
  dimX: number;
  /** box: width (m), cylinder: unused */
  dimY: number;
  /** box: height (m), cylinder: height (m) */
  dimZ: number;
}

/**
 * CAD model shipped inline as bytes (matches encoded_template_images pattern).
 * Vision-bot writes to a temp file, loads via Open3D, and caches by content_hash.
 */
export interface CadModelFile {
  /** raw file bytes */
  data: Uint8Array;
  /** "stl" | "obj" | "ply" */
  format: string;
  /** sha256 of data; vision-bot cache key */
  contentHash: string;
  /**
   * Native units of the mesh — STL/OBJ don't encode units, so the user
   * tells us at upload time. Vision-bot rescales to meters before ICP
   * fitting; the visualizer applies the same factor when rendering.
   */
  units: CadModelUnits;
}

export interface ObjectReference {
  /** context (not used for detection — that's done in step 1) */
  textPrompt?:
    | string
    | undefined;
  /** filesystem path (dev/debug only) */
  cadModelPath?:
    | string
    | undefined;
  /** for FoundationPose model-free */
  referenceImages?:
    | ReferenceImageSet
    | undefined;
  /** server generates mesh from primitive dims */
  primitiveShape?:
    | PrimitiveShape
    | undefined;
  /** user-uploaded CAD shipped inline */
  cadModelFile?: CadModelFile | undefined;
}

export interface ReferenceImageSet {
  rgbImages: Uint8Array[];
  depthImages: Uint8Array[];
  cameraPoses: CartesianPose[];
}

export interface Run3DPoseEstimationRequest {
  /** pre-detected matches (box + optional mask) from 2D step */
  detections: LocateMatch[];
  /** uint16 depth (mm), full frame */
  depthImage: Uint8Array;
  cameraParams:
    | CameraParams
    | undefined;
  /** how to estimate 6DoF per detection */
  poseMethod: PoseEstimationMethod;
  /** CAD model path / context */
  objectReference?:
    | ObjectReference
    | undefined;
  /** min score (default: 0.5) */
  confidenceThreshold?:
    | number
    | undefined;
  /** limit results (default: 10) */
  maxDetections?: number | undefined;
  includeDebugVisualization?:
    | boolean
    | undefined;
  /** percentile to clip from each end of depth projections (default: 2 → 2nd/98th) */
  depthOutlierPercentile?:
    | number
    | undefined;
  /** FPFH_ICP: RANSAC+ICP attempts; keep best ICP fit (default: 4) */
  ransacRestarts?:
    | number
    | undefined;
  /** FPFH_ICP: downsampling + FPFH feature voxel size in meters (default: 0.003) */
  voxelSize?: number | undefined;
}

export interface Run3DPoseEstimationResponse {
  data?: PoseEstimation3DResult | undefined;
  error?: Error | undefined;
}

export interface PoseEstimation3DResult {
  detections: Detection3D[];
  processingTimeMs?: number | undefined;
  debugVisualization?: Uint8Array | undefined;
}

export interface ComputeDinoEmbeddingsRequest {
  image: Uint8Array;
  modelVersion: string;
  /** "fast" | "standard" | "fine" */
  precision: string;
  /**
   * When set, vision-bot forward-scores the patch grid with this head and
   * returns DinoEmbeddingsTensor.heatmap_fp16. The learned locate path
   * never needs the raw tensor — set omit_tensor to skip the ~1MB payload.
   */
  locateHead?: LocateHeadProto | undefined;
  omitTensor: boolean;
}

export interface ComputeDinoEmbeddingsResponse {
  data?: DinoEmbeddingsTensor | undefined;
  error?: Error | undefined;
}

export interface DinoEmbeddingsTensor {
  gridH: number;
  gridW: number;
  embeddingDim: number;
  /** float16 row-major, L2-normalized per patch; empty when */
  values: Uint8Array;
  /** the request set omit_tensor */
  modelVersion: string;
  /** letterboxed dims fed to the model, for un-letterboxing */
  inputH: number;
  inputW: number;
  paddingTop: number;
  paddingLeft: number;
  /**
   * Sigmoid scores per grid cell, float16 row-major, grid_h*grid_w entries.
   * Present iff the request carried locate_head.
   */
  heatmapFp16?: Uint8Array | undefined;
}

export interface ComputeDinoImageEmbeddingRequest {
  image: Uint8Array;
  modelVersion: string;
  /** "fast" | "standard" | "fine" */
  precision: string;
}

export interface ComputeDinoImageEmbeddingResponse {
  data?: DinoImageEmbedding | undefined;
  error?: Error | undefined;
}

export interface DinoImageEmbedding {
  embeddingDim: number;
  /** float16, L2-normalized */
  values: Uint8Array;
  /**
   * Model version string carries an "-img" suffix relative to the patch
   * RPC's version so stored embeddings can't accidentally cross between
   * the two RPCs' embedding spaces.
   */
  modelVersion: string;
}

/** A single SAM2 point prompt, in the same pixel space as the enclosing box. */
export interface PointPrompt {
  x: number;
  y: number;
  /** true = object (label 1), false = exclude (label 0) */
  positive: boolean;
}

export interface Box2DXyxy {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  /**
   * SAM2-only: optional point prompts for this box. Empty = box-only prompt.
   * Ignored when method is GUIDED_FILTER or BILATERAL_SOLVER.
   */
  points: PointPrompt[];
}

/**
 * A DINO heatmap sample in the same cropped-image pixel space as the boxes:
 * the patch-grid similarity score at a patch center. Used to score SAM2
 * multimask candidates (see SegmentMaskRequest).
 */
export interface HeatmapSample {
  x: number;
  y: number;
  score: number;
}

export interface SegmentMaskRequest {
  image: Uint8Array;
  boxes: Box2DXyxy[];
  /** SAM2-only: multimask candidate selection (see SegmentMask docstring). */
  heatmapSamples: HeatmapSample[];
  /**
   * DINO score threshold separating object from background. Used by every
   * method to binarize the refined map / score multimask candidates.
   */
  heatmapThreshold: number;
  /** Which backend to run. Default 0 = SAM2. */
  method: SegmentationMethod;
  /**
   * Dense DINO heatmap, float16 row-major, at the SAME resolution and pixel
   * space as `image` (cropped-ROI). Required for the filter methods (it is
   * their input); optional for SAM2, which when present gates masks back to
   * the heatmap's foreground support (excising cast-shadow bleed).
   */
  heatmapDense: Uint8Array;
  heatmapWidth?: number | undefined;
  heatmapHeight?: number | undefined;
}

export interface SegmentMaskResponse {
  data?: MaskSegmentationResult | undefined;
  error?: Error | undefined;
}

export interface MaskSegmentationResult {
  blobs: Blob2D[];
  wasSegmented: boolean[];
  processingTimeMs?: number | undefined;
}

export interface LocateClick {
  /** normalized [0,1] in source-image space */
  nx: number;
  ny: number;
  positive: boolean;
}

export interface ReferenceVector {
  /** embedding_dim floats */
  values: number[];
}

export interface MlpLocateHeadProto {
  inputDim: number;
  hidden: number;
  /** hidden * input_dim, row-major */
  w1: number[];
  /** hidden */
  b1: number[];
  /** hidden */
  w2: number[];
  b2: number;
}

export interface LogisticLocateHeadProto {
  inputDim: number;
  /** input_dim */
  w: number[];
  b: number;
}

export interface LocateHeadProto {
  mlp?: MlpLocateHeadProto | undefined;
  logistic?: LogisticLocateHeadProto | undefined;
}

export interface TrainLocateHeadRequest {
  /** one per teach session; new id on GPU-runner switch */
  sessionId: string;
  /** monotonic per session */
  seq: number;
  image: Uint8Array;
  modelVersion: string;
  /** "fast" | "standard" | "fine" */
  precision: string;
  /** pending session clicks, on this frame */
  clicks: LocateClick[];
  /**
   * Reference embeddings from clicks committed in prior teach sessions
   * (persisted in the skill by the client; their source frames are gone).
   */
  committedPositives: ReferenceVector[];
  committedNegatives: ReferenceVector[];
  headKind: LocateHeadKind;
}

export interface LocateHeatmap {
  gridH: number;
  gridW: number;
  /** float16 row-major sigmoid scores, grid_h*grid_w entries */
  values: Uint8Array;
  /** letterbox meta for client-side rasterization */
  inputH: number;
  inputW: number;
  paddingTop: number;
  paddingLeft: number;
  modelVersion: string;
}

export interface TrainLocateHeadResult {
  seq: number;
  /** true ⇒ no other fields set; a newer seq already arrived */
  superseded: boolean;
  head: LocateHeadProto | undefined;
  heatmap:
    | LocateHeatmap
    | undefined;
  /**
   * Parallel to request.clicks: the embedding under each click, for the
   * client to persist as committed references on save.
   */
  clickEmbeddings: ReferenceVector[];
}

export interface TrainLocateHeadResponse {
  data?: TrainLocateHeadResult | undefined;
  error?: Error | undefined;
}

export interface DetectScenePlaneRequest {
  /** uint16 mm, aligned to color */
  depthImage: Uint8Array;
  cameraParams:
    | CameraParams
    | undefined;
  /** distance_threshold = threshold at 1 m */
  ransac:
    | GeometricPlane
    | undefined;
  /** disable depth-adaptive scaling */
  fixedThreshold?:
    | boolean
    | undefined;
  /** reserved for future text-prompt mode */
  region?:
    | Blob2D
    | undefined;
  /** clicked points, color-frame px */
  seedPoints: Point2D[];
  /** default 4; preview uses 8 */
  downsampleStride?:
    | number
    | undefined;
  /** camera-Z band, default 0.25 */
  minDepthM?:
    | number
    | undefined;
  /** default 2.5 */
  maxDepthM?:
    | number
    | undefined;
  /** default 1 */
  maxCandidates?: number | undefined;
  includeInlierMask?: boolean | undefined;
}

export interface ScenePlane {
  /** base frame, canonical axes */
  planePose:
    | CartesianPose
    | undefined;
  /** base frame, toward camera */
  surfaceNormal: Point | undefined;
  inlierRatio: number;
  inlierCount: number;
  rmsErrorM: number;
  /** vs base +Z */
  tiltAngleDeg: number;
  medianDepthM?:
    | number
    | undefined;
  /** RLE at strided resolution */
  inlierMaskRle?: Uint8Array | undefined;
  maskWidth?: number | undefined;
  maskHeight?: number | undefined;
}

/**
 * Per-click outline of the valid-depth pixels sampled in that click's window.
 * Lets the UI show users exactly which pixels each click contributes to the
 * fit (so a click straddling a border/object is visible). One per accepted
 * seed; clicks with no usable depth (see ignored_seed_indices) have none.
 */
export interface SeedWindow {
  /** indexes into request seed_points */
  seedIndex: number;
  /** boundary tracing the sampled pixels, full-res color-frame px */
  contourPoints: Point2D[];
}

export interface ScenePlaneResult {
  /** quality-ordered */
  candidates: ScenePlane[];
  /** clicks with no usable depth */
  ignoredSeedIndices: number[];
  processingTimeMs?:
    | number
    | undefined;
  /** per-click sampled-pixel outlines */
  seedWindows: SeedWindow[];
}

export interface DetectScenePlaneResponse {
  data?: ScenePlaneResult | undefined;
  error?: Error | undefined;
}

export interface PreloadRoboflowModelRequest {
  /** "<project>/<version>", e.g. "adient-seat-inspection/16" */
  modelId: string;
  /** Roboflow workspace/enterprise key (per-request) */
  apiKey: string;
}

export interface PreloadRoboflowModelResult {
  modelId: string;
  loadTimeMs?: number | undefined;
}

export interface PreloadRoboflowModelResponse {
  data?: PreloadRoboflowModelResult | undefined;
  error?: Error | undefined;
}

export interface PreloadRoboflowWorkflowRequest {
  workspaceName: string;
  workflowId: string;
  apiKey: string;
}

export interface PreloadRoboflowWorkflowResult {
  workspaceName: string;
  workflowId: string;
  loadTimeMs?: number | undefined;
}

export interface PreloadRoboflowWorkflowResponse {
  data?: PreloadRoboflowWorkflowResult | undefined;
  error?: Error | undefined;
}

export interface RunRoboflowDetectionRequest {
  modelId: string;
  apiKey: string;
  /** encoded image bytes (png/jpg) */
  image: Uint8Array;
  /**
   * Applied by vision-bot AFTER a raw (unfiltered) inference so filtering matches
   * the checkpoint path (confidence / nms_threshold / max_detections) rather than
   * the Roboflow model's built-in thresholds.
   */
  thresholdingParams: { [key: string]: string };
}

export interface RunRoboflowDetectionRequest_ThresholdingParamsEntry {
  key: string;
  value: string;
}

/**
 * Object-detection run: each prediction is mapped to a LocateMatch (detector
 * box, segment unset) so the result feeds the locate pipeline exactly like
 * CheckpointBasedInferenceResult. Non-detection models are rejected (guarded)
 * rather than producing degenerate boxes.
 */
export interface RunRoboflowDetectionResult {
  blobs: LocateMatch[];
  processingTimeMs?: number | undefined;
}

export interface RunRoboflowDetectionResponse {
  data?: RunRoboflowDetectionResult | undefined;
  error?: Error | undefined;
}

export interface RunRoboflowWorkflowRequest {
  workspaceName: string;
  workflowId: string;
  apiKey: string;
  /** encoded image bytes; bound to the workflow's image input */
  image: Uint8Array;
}

export interface RunRoboflowWorkflowResult {
  /** Workflow outputs vary per workflow, so return them as a JSON string in v1. */
  outputsJson: string;
  processingTimeMs?: number | undefined;
}

export interface RunRoboflowWorkflowResponse {
  data?: RunRoboflowWorkflowResult | undefined;
  error?: Error | undefined;
}

function createBaseBlob2D(): Blob2D {
  return {
    score: 0,
    contour: [],
    area: undefined,
    classId: undefined,
    className: undefined,
    maskRle: undefined,
    maskWidth: undefined,
    maskHeight: undefined,
  };
}

export const Blob2D: MessageFns<Blob2D> = {
  encode(message: Blob2D, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.score !== 0) {
      writer.uint32(53).float(message.score);
    }
    for (const v of message.contour) {
      Point2D.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.area !== undefined) {
      writer.uint32(65).double(message.area);
    }
    if (message.classId !== undefined) {
      writer.uint32(72).int32(message.classId);
    }
    if (message.className !== undefined) {
      writer.uint32(82).string(message.className);
    }
    if (message.maskRle !== undefined) {
      writer.uint32(90).bytes(message.maskRle);
    }
    if (message.maskWidth !== undefined) {
      writer.uint32(96).int32(message.maskWidth);
    }
    if (message.maskHeight !== undefined) {
      writer.uint32(104).int32(message.maskHeight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Blob2D {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlob2D();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.score = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.contour.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.area = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.classId = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.className = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.maskRle = reader.bytes();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maskWidth = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maskHeight = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Blob2D {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      contour: globalThis.Array.isArray(object?.contour) ? object.contour.map((e: any) => Point2D.fromJSON(e)) : [],
      area: isSet(object.area) ? globalThis.Number(object.area) : undefined,
      classId: isSet(object.classId) ? globalThis.Number(object.classId) : undefined,
      className: isSet(object.className) ? globalThis.String(object.className) : undefined,
      maskRle: isSet(object.maskRle) ? bytesFromBase64(object.maskRle) : undefined,
      maskWidth: isSet(object.maskWidth) ? globalThis.Number(object.maskWidth) : undefined,
      maskHeight: isSet(object.maskHeight) ? globalThis.Number(object.maskHeight) : undefined,
    };
  },

  toJSON(message: Blob2D): unknown {
    const obj: any = {};
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.contour?.length) {
      obj.contour = message.contour.map((e) => Point2D.toJSON(e));
    }
    if (message.area !== undefined) {
      obj.area = message.area;
    }
    if (message.classId !== undefined) {
      obj.classId = Math.round(message.classId);
    }
    if (message.className !== undefined) {
      obj.className = message.className;
    }
    if (message.maskRle !== undefined) {
      obj.maskRle = base64FromBytes(message.maskRle);
    }
    if (message.maskWidth !== undefined) {
      obj.maskWidth = Math.round(message.maskWidth);
    }
    if (message.maskHeight !== undefined) {
      obj.maskHeight = Math.round(message.maskHeight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Blob2D>, I>>(base?: I): Blob2D {
    return Blob2D.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Blob2D>, I>>(object: I): Blob2D {
    const message = createBaseBlob2D();
    message.score = object.score ?? 0;
    message.contour = object.contour?.map((e) => Point2D.fromPartial(e)) || [];
    message.area = object.area ?? undefined;
    message.classId = object.classId ?? undefined;
    message.className = object.className ?? undefined;
    message.maskRle = object.maskRle ?? undefined;
    message.maskWidth = object.maskWidth ?? undefined;
    message.maskHeight = object.maskHeight ?? undefined;
    return message;
  },
};

function createBaseDetection2D(): Detection2D {
  return { x: 0, y: 0, width: 0, height: 0, rotation: 0, score: 0, classId: undefined, className: undefined };
}

export const Detection2D: MessageFns<Detection2D> = {
  encode(message: Detection2D, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.width !== 0) {
      writer.uint32(25).double(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(33).double(message.height);
    }
    if (message.rotation !== 0) {
      writer.uint32(45).float(message.rotation);
    }
    if (message.score !== 0) {
      writer.uint32(53).float(message.score);
    }
    if (message.classId !== undefined) {
      writer.uint32(56).int32(message.classId);
    }
    if (message.className !== undefined) {
      writer.uint32(66).string(message.className);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Detection2D {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetection2D();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.width = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rotation = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.score = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.classId = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.className = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Detection2D {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      rotation: isSet(object.rotation) ? globalThis.Number(object.rotation) : 0,
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      classId: isSet(object.classId) ? globalThis.Number(object.classId) : undefined,
      className: isSet(object.className) ? globalThis.String(object.className) : undefined,
    };
  },

  toJSON(message: Detection2D): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.rotation !== 0) {
      obj.rotation = message.rotation;
    }
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.classId !== undefined) {
      obj.classId = Math.round(message.classId);
    }
    if (message.className !== undefined) {
      obj.className = message.className;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Detection2D>, I>>(base?: I): Detection2D {
    return Detection2D.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Detection2D>, I>>(object: I): Detection2D {
    const message = createBaseDetection2D();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.rotation = object.rotation ?? 0;
    message.score = object.score ?? 0;
    message.classId = object.classId ?? undefined;
    message.className = object.className ?? undefined;
    return message;
  },
};

function createBaseLocateMatch(): LocateMatch {
  return { detection: undefined, segment: undefined };
}

export const LocateMatch: MessageFns<LocateMatch> = {
  encode(message: LocateMatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.detection !== undefined) {
      Detection2D.encode(message.detection, writer.uint32(10).fork()).join();
    }
    if (message.segment !== undefined) {
      Blob2D.encode(message.segment, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocateMatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocateMatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detection = Detection2D.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.segment = Blob2D.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocateMatch {
    return {
      detection: isSet(object.detection) ? Detection2D.fromJSON(object.detection) : undefined,
      segment: isSet(object.segment) ? Blob2D.fromJSON(object.segment) : undefined,
    };
  },

  toJSON(message: LocateMatch): unknown {
    const obj: any = {};
    if (message.detection !== undefined) {
      obj.detection = Detection2D.toJSON(message.detection);
    }
    if (message.segment !== undefined) {
      obj.segment = Blob2D.toJSON(message.segment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocateMatch>, I>>(base?: I): LocateMatch {
    return LocateMatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocateMatch>, I>>(object: I): LocateMatch {
    const message = createBaseLocateMatch();
    message.detection = (object.detection !== undefined && object.detection !== null)
      ? Detection2D.fromPartial(object.detection)
      : undefined;
    message.segment = (object.segment !== undefined && object.segment !== null)
      ? Blob2D.fromPartial(object.segment)
      : undefined;
    return message;
  },
};

function createBaseOrientationReference(): OrientationReference {
  return { referenceContour: [] };
}

export const OrientationReference: MessageFns<OrientationReference> = {
  encode(message: OrientationReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.referenceContour) {
      Point2D.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrientationReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrientationReference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.referenceContour.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrientationReference {
    return {
      referenceContour: globalThis.Array.isArray(object?.referenceContour)
        ? object.referenceContour.map((e: any) => Point2D.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrientationReference): unknown {
    const obj: any = {};
    if (message.referenceContour?.length) {
      obj.referenceContour = message.referenceContour.map((e) => Point2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrientationReference>, I>>(base?: I): OrientationReference {
    return OrientationReference.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrientationReference>, I>>(object: I): OrientationReference {
    const message = createBaseOrientationReference();
    message.referenceContour = object.referenceContour?.map((e) => Point2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseContour2D(): Contour2D {
  return { points: [] };
}

export const Contour2D: MessageFns<Contour2D> = {
  encode(message: Contour2D, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      Point2D.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Contour2D {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContour2D();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.points.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Contour2D {
    return {
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => Point2D.fromJSON(e)) : [],
    };
  },

  toJSON(message: Contour2D): unknown {
    const obj: any = {};
    if (message.points?.length) {
      obj.points = message.points.map((e) => Point2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Contour2D>, I>>(base?: I): Contour2D {
    return Contour2D.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Contour2D>, I>>(object: I): Contour2D {
    const message = createBaseContour2D();
    message.points = object.points?.map((e) => Point2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseComputeOrientationReferenceRequest(): ComputeOrientationReferenceRequest {
  return { contour: [], siblingContours: [] };
}

export const ComputeOrientationReferenceRequest: MessageFns<ComputeOrientationReferenceRequest> = {
  encode(message: ComputeOrientationReferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.contour) {
      Point2D.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.siblingContours) {
      Contour2D.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeOrientationReferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeOrientationReferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.contour.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.siblingContours.push(Contour2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeOrientationReferenceRequest {
    return {
      contour: globalThis.Array.isArray(object?.contour) ? object.contour.map((e: any) => Point2D.fromJSON(e)) : [],
      siblingContours: globalThis.Array.isArray(object?.siblingContours)
        ? object.siblingContours.map((e: any) => Contour2D.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ComputeOrientationReferenceRequest): unknown {
    const obj: any = {};
    if (message.contour?.length) {
      obj.contour = message.contour.map((e) => Point2D.toJSON(e));
    }
    if (message.siblingContours?.length) {
      obj.siblingContours = message.siblingContours.map((e) => Contour2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeOrientationReferenceRequest>, I>>(
    base?: I,
  ): ComputeOrientationReferenceRequest {
    return ComputeOrientationReferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeOrientationReferenceRequest>, I>>(
    object: I,
  ): ComputeOrientationReferenceRequest {
    const message = createBaseComputeOrientationReferenceRequest();
    message.contour = object.contour?.map((e) => Point2D.fromPartial(e)) || [];
    message.siblingContours = object.siblingContours?.map((e) => Contour2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseComputeOrientationReferenceData(): ComputeOrientationReferenceData {
  return { isReliable: false, reference: undefined, rejection: 0 };
}

export const ComputeOrientationReferenceData: MessageFns<ComputeOrientationReferenceData> = {
  encode(message: ComputeOrientationReferenceData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isReliable !== false) {
      writer.uint32(8).bool(message.isReliable);
    }
    if (message.reference !== undefined) {
      OrientationReference.encode(message.reference, writer.uint32(18).fork()).join();
    }
    if (message.rejection !== 0) {
      writer.uint32(24).int32(message.rejection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeOrientationReferenceData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeOrientationReferenceData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isReliable = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reference = OrientationReference.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rejection = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeOrientationReferenceData {
    return {
      isReliable: isSet(object.isReliable) ? globalThis.Boolean(object.isReliable) : false,
      reference: isSet(object.reference) ? OrientationReference.fromJSON(object.reference) : undefined,
      rejection: isSet(object.rejection) ? orientationReferenceRejectionFromJSON(object.rejection) : 0,
    };
  },

  toJSON(message: ComputeOrientationReferenceData): unknown {
    const obj: any = {};
    if (message.isReliable !== false) {
      obj.isReliable = message.isReliable;
    }
    if (message.reference !== undefined) {
      obj.reference = OrientationReference.toJSON(message.reference);
    }
    if (message.rejection !== 0) {
      obj.rejection = orientationReferenceRejectionToJSON(message.rejection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeOrientationReferenceData>, I>>(base?: I): ComputeOrientationReferenceData {
    return ComputeOrientationReferenceData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeOrientationReferenceData>, I>>(
    object: I,
  ): ComputeOrientationReferenceData {
    const message = createBaseComputeOrientationReferenceData();
    message.isReliable = object.isReliable ?? false;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? OrientationReference.fromPartial(object.reference)
      : undefined;
    message.rejection = object.rejection ?? 0;
    return message;
  },
};

function createBaseComputeOrientationReferenceResponse(): ComputeOrientationReferenceResponse {
  return { data: undefined, error: undefined };
}

export const ComputeOrientationReferenceResponse: MessageFns<ComputeOrientationReferenceResponse> = {
  encode(message: ComputeOrientationReferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      ComputeOrientationReferenceData.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeOrientationReferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeOrientationReferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = ComputeOrientationReferenceData.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeOrientationReferenceResponse {
    return {
      data: isSet(object.data) ? ComputeOrientationReferenceData.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: ComputeOrientationReferenceResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = ComputeOrientationReferenceData.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeOrientationReferenceResponse>, I>>(
    base?: I,
  ): ComputeOrientationReferenceResponse {
    return ComputeOrientationReferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeOrientationReferenceResponse>, I>>(
    object: I,
  ): ComputeOrientationReferenceResponse {
    const message = createBaseComputeOrientationReferenceResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? ComputeOrientationReferenceData.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseModel(): Model {
  return { modelPath: "" };
}

export const Model: MessageFns<Model> = {
  encode(message: Model, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelPath !== "") {
      writer.uint32(10).string(message.modelPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Model {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Model {
    return { modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : "" };
  },

  toJSON(message: Model): unknown {
    const obj: any = {};
    if (message.modelPath !== "") {
      obj.modelPath = message.modelPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Model>, I>>(base?: I): Model {
    return Model.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Model>, I>>(object: I): Model {
    const message = createBaseModel();
    message.modelPath = object.modelPath ?? "";
    return message;
  },
};

function createBaseModelList(): ModelList {
  return { models: [] };
}

export const ModelList: MessageFns<ModelList> = {
  encode(message: ModelList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.models) {
      Model.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.models.push(Model.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelList {
    return { models: globalThis.Array.isArray(object?.models) ? object.models.map((e: any) => Model.fromJSON(e)) : [] };
  },

  toJSON(message: ModelList): unknown {
    const obj: any = {};
    if (message.models?.length) {
      obj.models = message.models.map((e) => Model.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelList>, I>>(base?: I): ModelList {
    return ModelList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelList>, I>>(object: I): ModelList {
    const message = createBaseModelList();
    message.models = object.models?.map((e) => Model.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceRequest(): RunCheckpointBasedInferenceRequest {
  return { image: new Uint8Array(0), modelPath: "", modelType: "", thresholdingParams: {}, includeMasks: undefined };
}

export const RunCheckpointBasedInferenceRequest: MessageFns<RunCheckpointBasedInferenceRequest> = {
  encode(message: RunCheckpointBasedInferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.modelPath !== "") {
      writer.uint32(18).string(message.modelPath);
    }
    if (message.modelType !== "") {
      writer.uint32(26).string(message.modelType);
    }
    Object.entries(message.thresholdingParams).forEach(([key, value]) => {
      RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).join();
    });
    if (message.includeMasks !== undefined) {
      writer.uint32(40).bool(message.includeMasks);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCheckpointBasedInferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.thresholdingParams[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.includeMasks = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : "",
      modelType: isSet(object.modelType) ? globalThis.String(object.modelType) : "",
      thresholdingParams: isObject(object.thresholdingParams)
        ? Object.entries(object.thresholdingParams).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      includeMasks: isSet(object.includeMasks) ? globalThis.Boolean(object.includeMasks) : undefined,
    };
  },

  toJSON(message: RunCheckpointBasedInferenceRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.modelPath !== "") {
      obj.modelPath = message.modelPath;
    }
    if (message.modelType !== "") {
      obj.modelType = message.modelType;
    }
    if (message.thresholdingParams) {
      const entries = Object.entries(message.thresholdingParams);
      if (entries.length > 0) {
        obj.thresholdingParams = {};
        entries.forEach(([k, v]) => {
          obj.thresholdingParams[k] = v;
        });
      }
    }
    if (message.includeMasks !== undefined) {
      obj.includeMasks = message.includeMasks;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceRequest {
    return RunCheckpointBasedInferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceRequest {
    const message = createBaseRunCheckpointBasedInferenceRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.modelPath = object.modelPath ?? "";
    message.modelType = object.modelType ?? "";
    message.thresholdingParams = Object.entries(object.thresholdingParams ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.includeMasks = object.includeMasks ?? undefined;
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry(): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
  return { key: "", value: "" };
}

export const RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry: MessageFns<
  RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry
> = {
  encode(
    message: RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    return RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    const message = createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceResponse(): RunCheckpointBasedInferenceResponse {
  return { data: undefined, error: undefined };
}

export const RunCheckpointBasedInferenceResponse: MessageFns<RunCheckpointBasedInferenceResponse> = {
  encode(message: RunCheckpointBasedInferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CheckpointBasedInferenceResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCheckpointBasedInferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CheckpointBasedInferenceResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceResponse {
    return {
      data: isSet(object.data) ? CheckpointBasedInferenceResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: RunCheckpointBasedInferenceResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CheckpointBasedInferenceResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceResponse>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceResponse {
    return RunCheckpointBasedInferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceResponse>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceResponse {
    const message = createBaseRunCheckpointBasedInferenceResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CheckpointBasedInferenceResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCheckpointBasedInferenceResult(): CheckpointBasedInferenceResult {
  return { blobs: [], processingTimeMs: undefined, modelPath: undefined };
}

export const CheckpointBasedInferenceResult: MessageFns<CheckpointBasedInferenceResult> = {
  encode(message: CheckpointBasedInferenceResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blobs) {
      LocateMatch.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    if (message.modelPath !== undefined) {
      writer.uint32(26).string(message.modelPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckpointBasedInferenceResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckpointBasedInferenceResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blobs.push(LocateMatch.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckpointBasedInferenceResult {
    return {
      blobs: globalThis.Array.isArray(object?.blobs) ? object.blobs.map((e: any) => LocateMatch.fromJSON(e)) : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
      modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : undefined,
    };
  },

  toJSON(message: CheckpointBasedInferenceResult): unknown {
    const obj: any = {};
    if (message.blobs?.length) {
      obj.blobs = message.blobs.map((e) => LocateMatch.toJSON(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    if (message.modelPath !== undefined) {
      obj.modelPath = message.modelPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckpointBasedInferenceResult>, I>>(base?: I): CheckpointBasedInferenceResult {
    return CheckpointBasedInferenceResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckpointBasedInferenceResult>, I>>(
    object: I,
  ): CheckpointBasedInferenceResult {
    const message = createBaseCheckpointBasedInferenceResult();
    message.blobs = object.blobs?.map((e) => LocateMatch.fromPartial(e)) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    message.modelPath = object.modelPath ?? undefined;
    return message;
  },
};

function createBaseError(): Error {
  return { code: 0, message: "" };
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Error {
    return {
      code: isSet(object.code) ? errorCodeFromJSON(object.code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = errorCodeToJSON(message.code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError();
    message.code = object.code ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseRunPlaneProjectionRequest(): RunPlaneProjectionRequest {
  return {
    detections: [],
    image: new Uint8Array(0),
    depthImage: undefined,
    cameraParams: undefined,
    planeMethod: undefined,
    includeDebugVisualization: undefined,
    graspFrame: 0,
    orientationReference: undefined,
  };
}

export const RunPlaneProjectionRequest: MessageFns<RunPlaneProjectionRequest> = {
  encode(message: RunPlaneProjectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.detections) {
      LocateMatch.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.image.length !== 0) {
      writer.uint32(18).bytes(message.image);
    }
    if (message.depthImage !== undefined) {
      writer.uint32(26).bytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      CameraParams.encode(message.cameraParams, writer.uint32(34).fork()).join();
    }
    if (message.planeMethod !== undefined) {
      PlaneDetectionMethod.encode(message.planeMethod, writer.uint32(42).fork()).join();
    }
    if (message.includeDebugVisualization !== undefined) {
      writer.uint32(48).bool(message.includeDebugVisualization);
    }
    if (message.graspFrame !== 0) {
      writer.uint32(56).int32(message.graspFrame);
    }
    if (message.orientationReference !== undefined) {
      OrientationReference.encode(message.orientationReference, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunPlaneProjectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunPlaneProjectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detections.push(LocateMatch.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.depthImage = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cameraParams = CameraParams.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.planeMethod = PlaneDetectionMethod.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.includeDebugVisualization = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.graspFrame = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.orientationReference = OrientationReference.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunPlaneProjectionRequest {
    return {
      detections: globalThis.Array.isArray(object?.detections)
        ? object.detections.map((e: any) => LocateMatch.fromJSON(e))
        : [],
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      depthImage: isSet(object.depthImage) ? bytesFromBase64(object.depthImage) : undefined,
      cameraParams: isSet(object.cameraParams) ? CameraParams.fromJSON(object.cameraParams) : undefined,
      planeMethod: isSet(object.planeMethod) ? PlaneDetectionMethod.fromJSON(object.planeMethod) : undefined,
      includeDebugVisualization: isSet(object.includeDebugVisualization)
        ? globalThis.Boolean(object.includeDebugVisualization)
        : undefined,
      graspFrame: isSet(object.graspFrame) ? graspFrameFromJSON(object.graspFrame) : 0,
      orientationReference: isSet(object.orientationReference)
        ? OrientationReference.fromJSON(object.orientationReference)
        : undefined,
    };
  },

  toJSON(message: RunPlaneProjectionRequest): unknown {
    const obj: any = {};
    if (message.detections?.length) {
      obj.detections = message.detections.map((e) => LocateMatch.toJSON(e));
    }
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.depthImage !== undefined) {
      obj.depthImage = base64FromBytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      obj.cameraParams = CameraParams.toJSON(message.cameraParams);
    }
    if (message.planeMethod !== undefined) {
      obj.planeMethod = PlaneDetectionMethod.toJSON(message.planeMethod);
    }
    if (message.includeDebugVisualization !== undefined) {
      obj.includeDebugVisualization = message.includeDebugVisualization;
    }
    if (message.graspFrame !== 0) {
      obj.graspFrame = graspFrameToJSON(message.graspFrame);
    }
    if (message.orientationReference !== undefined) {
      obj.orientationReference = OrientationReference.toJSON(message.orientationReference);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunPlaneProjectionRequest>, I>>(base?: I): RunPlaneProjectionRequest {
    return RunPlaneProjectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunPlaneProjectionRequest>, I>>(object: I): RunPlaneProjectionRequest {
    const message = createBaseRunPlaneProjectionRequest();
    message.detections = object.detections?.map((e) => LocateMatch.fromPartial(e)) || [];
    message.image = object.image ?? new Uint8Array(0);
    message.depthImage = object.depthImage ?? undefined;
    message.cameraParams = (object.cameraParams !== undefined && object.cameraParams !== null)
      ? CameraParams.fromPartial(object.cameraParams)
      : undefined;
    message.planeMethod = (object.planeMethod !== undefined && object.planeMethod !== null)
      ? PlaneDetectionMethod.fromPartial(object.planeMethod)
      : undefined;
    message.includeDebugVisualization = object.includeDebugVisualization ?? undefined;
    message.graspFrame = object.graspFrame ?? 0;
    message.orientationReference = (object.orientationReference !== undefined && object.orientationReference !== null)
      ? OrientationReference.fromPartial(object.orientationReference)
      : undefined;
    return message;
  },
};

function createBaseCameraParams(): CameraParams {
  return { intrinsics: undefined, extrinsics: undefined, extrinsicsKind: 0, robotPose: undefined };
}

export const CameraParams: MessageFns<CameraParams> = {
  encode(message: CameraParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intrinsics !== undefined) {
      CameraIntrinsics.encode(message.intrinsics, writer.uint32(10).fork()).join();
    }
    if (message.extrinsics !== undefined) {
      CartesianPose.encode(message.extrinsics, writer.uint32(18).fork()).join();
    }
    if (message.extrinsicsKind !== 0) {
      writer.uint32(24).int32(message.extrinsicsKind);
    }
    if (message.robotPose !== undefined) {
      CartesianPose.encode(message.robotPose, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intrinsics = CameraIntrinsics.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.extrinsics = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.extrinsicsKind = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.robotPose = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraParams {
    return {
      intrinsics: isSet(object.intrinsics) ? CameraIntrinsics.fromJSON(object.intrinsics) : undefined,
      extrinsics: isSet(object.extrinsics) ? CartesianPose.fromJSON(object.extrinsics) : undefined,
      extrinsicsKind: isSet(object.extrinsicsKind) ? extrinsicsKindFromJSON(object.extrinsicsKind) : 0,
      robotPose: isSet(object.robotPose) ? CartesianPose.fromJSON(object.robotPose) : undefined,
    };
  },

  toJSON(message: CameraParams): unknown {
    const obj: any = {};
    if (message.intrinsics !== undefined) {
      obj.intrinsics = CameraIntrinsics.toJSON(message.intrinsics);
    }
    if (message.extrinsics !== undefined) {
      obj.extrinsics = CartesianPose.toJSON(message.extrinsics);
    }
    if (message.extrinsicsKind !== 0) {
      obj.extrinsicsKind = extrinsicsKindToJSON(message.extrinsicsKind);
    }
    if (message.robotPose !== undefined) {
      obj.robotPose = CartesianPose.toJSON(message.robotPose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraParams>, I>>(base?: I): CameraParams {
    return CameraParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraParams>, I>>(object: I): CameraParams {
    const message = createBaseCameraParams();
    message.intrinsics = (object.intrinsics !== undefined && object.intrinsics !== null)
      ? CameraIntrinsics.fromPartial(object.intrinsics)
      : undefined;
    message.extrinsics = (object.extrinsics !== undefined && object.extrinsics !== null)
      ? CartesianPose.fromPartial(object.extrinsics)
      : undefined;
    message.extrinsicsKind = object.extrinsicsKind ?? 0;
    message.robotPose = (object.robotPose !== undefined && object.robotPose !== null)
      ? CartesianPose.fromPartial(object.robotPose)
      : undefined;
    return message;
  },
};

function createBasePlaneDetectionMethod(): PlaneDetectionMethod {
  return { manual: undefined, geometric: undefined, learned: undefined };
}

export const PlaneDetectionMethod: MessageFns<PlaneDetectionMethod> = {
  encode(message: PlaneDetectionMethod, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manual !== undefined) {
      ManualPlane.encode(message.manual, writer.uint32(10).fork()).join();
    }
    if (message.geometric !== undefined) {
      GeometricPlane.encode(message.geometric, writer.uint32(18).fork()).join();
    }
    if (message.learned !== undefined) {
      LearnedPlane.encode(message.learned, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlaneDetectionMethod {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaneDetectionMethod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.manual = ManualPlane.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.geometric = GeometricPlane.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.learned = LearnedPlane.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaneDetectionMethod {
    return {
      manual: isSet(object.manual) ? ManualPlane.fromJSON(object.manual) : undefined,
      geometric: isSet(object.geometric) ? GeometricPlane.fromJSON(object.geometric) : undefined,
      learned: isSet(object.learned) ? LearnedPlane.fromJSON(object.learned) : undefined,
    };
  },

  toJSON(message: PlaneDetectionMethod): unknown {
    const obj: any = {};
    if (message.manual !== undefined) {
      obj.manual = ManualPlane.toJSON(message.manual);
    }
    if (message.geometric !== undefined) {
      obj.geometric = GeometricPlane.toJSON(message.geometric);
    }
    if (message.learned !== undefined) {
      obj.learned = LearnedPlane.toJSON(message.learned);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaneDetectionMethod>, I>>(base?: I): PlaneDetectionMethod {
    return PlaneDetectionMethod.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaneDetectionMethod>, I>>(object: I): PlaneDetectionMethod {
    const message = createBasePlaneDetectionMethod();
    message.manual = (object.manual !== undefined && object.manual !== null)
      ? ManualPlane.fromPartial(object.manual)
      : undefined;
    message.geometric = (object.geometric !== undefined && object.geometric !== null)
      ? GeometricPlane.fromPartial(object.geometric)
      : undefined;
    message.learned = (object.learned !== undefined && object.learned !== null)
      ? LearnedPlane.fromPartial(object.learned)
      : undefined;
    return message;
  },
};

function createBaseManualPlane(): ManualPlane {
  return { origin: undefined, plusX: undefined, plusY: undefined, objectHeight: undefined };
}

export const ManualPlane: MessageFns<ManualPlane> = {
  encode(message: ManualPlane, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.origin !== undefined) {
      Point.encode(message.origin, writer.uint32(10).fork()).join();
    }
    if (message.plusX !== undefined) {
      Point.encode(message.plusX, writer.uint32(18).fork()).join();
    }
    if (message.plusY !== undefined) {
      Point.encode(message.plusY, writer.uint32(26).fork()).join();
    }
    if (message.objectHeight !== undefined) {
      writer.uint32(37).float(message.objectHeight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManualPlane {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManualPlane();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.origin = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plusX = Point.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plusY = Point.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.objectHeight = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManualPlane {
    return {
      origin: isSet(object.origin) ? Point.fromJSON(object.origin) : undefined,
      plusX: isSet(object.plusX) ? Point.fromJSON(object.plusX) : undefined,
      plusY: isSet(object.plusY) ? Point.fromJSON(object.plusY) : undefined,
      objectHeight: isSet(object.objectHeight) ? globalThis.Number(object.objectHeight) : undefined,
    };
  },

  toJSON(message: ManualPlane): unknown {
    const obj: any = {};
    if (message.origin !== undefined) {
      obj.origin = Point.toJSON(message.origin);
    }
    if (message.plusX !== undefined) {
      obj.plusX = Point.toJSON(message.plusX);
    }
    if (message.plusY !== undefined) {
      obj.plusY = Point.toJSON(message.plusY);
    }
    if (message.objectHeight !== undefined) {
      obj.objectHeight = message.objectHeight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManualPlane>, I>>(base?: I): ManualPlane {
    return ManualPlane.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManualPlane>, I>>(object: I): ManualPlane {
    const message = createBaseManualPlane();
    message.origin = (object.origin !== undefined && object.origin !== null)
      ? Point.fromPartial(object.origin)
      : undefined;
    message.plusX = (object.plusX !== undefined && object.plusX !== null) ? Point.fromPartial(object.plusX) : undefined;
    message.plusY = (object.plusY !== undefined && object.plusY !== null) ? Point.fromPartial(object.plusY) : undefined;
    message.objectHeight = object.objectHeight ?? undefined;
    return message;
  },
};

function createBaseGeometricPlane(): GeometricPlane {
  return { maxIterations: undefined, distanceThreshold: undefined, minSamples: undefined, maxTiltAngle: undefined };
}

export const GeometricPlane: MessageFns<GeometricPlane> = {
  encode(message: GeometricPlane, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxIterations !== undefined) {
      writer.uint32(8).int32(message.maxIterations);
    }
    if (message.distanceThreshold !== undefined) {
      writer.uint32(21).float(message.distanceThreshold);
    }
    if (message.minSamples !== undefined) {
      writer.uint32(24).int32(message.minSamples);
    }
    if (message.maxTiltAngle !== undefined) {
      writer.uint32(37).float(message.maxTiltAngle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GeometricPlane {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometricPlane();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.maxIterations = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.distanceThreshold = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.minSamples = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.maxTiltAngle = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeometricPlane {
    return {
      maxIterations: isSet(object.maxIterations) ? globalThis.Number(object.maxIterations) : undefined,
      distanceThreshold: isSet(object.distanceThreshold) ? globalThis.Number(object.distanceThreshold) : undefined,
      minSamples: isSet(object.minSamples) ? globalThis.Number(object.minSamples) : undefined,
      maxTiltAngle: isSet(object.maxTiltAngle) ? globalThis.Number(object.maxTiltAngle) : undefined,
    };
  },

  toJSON(message: GeometricPlane): unknown {
    const obj: any = {};
    if (message.maxIterations !== undefined) {
      obj.maxIterations = Math.round(message.maxIterations);
    }
    if (message.distanceThreshold !== undefined) {
      obj.distanceThreshold = message.distanceThreshold;
    }
    if (message.minSamples !== undefined) {
      obj.minSamples = Math.round(message.minSamples);
    }
    if (message.maxTiltAngle !== undefined) {
      obj.maxTiltAngle = message.maxTiltAngle;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeometricPlane>, I>>(base?: I): GeometricPlane {
    return GeometricPlane.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeometricPlane>, I>>(object: I): GeometricPlane {
    const message = createBaseGeometricPlane();
    message.maxIterations = object.maxIterations ?? undefined;
    message.distanceThreshold = object.distanceThreshold ?? undefined;
    message.minSamples = object.minSamples ?? undefined;
    message.maxTiltAngle = object.maxTiltAngle ?? undefined;
    return message;
  },
};

function createBaseLearnedPlane(): LearnedPlane {
  return { modelPath: "" };
}

export const LearnedPlane: MessageFns<LearnedPlane> = {
  encode(message: LearnedPlane, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelPath !== "") {
      writer.uint32(10).string(message.modelPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LearnedPlane {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLearnedPlane();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LearnedPlane {
    return { modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : "" };
  },

  toJSON(message: LearnedPlane): unknown {
    const obj: any = {};
    if (message.modelPath !== "") {
      obj.modelPath = message.modelPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LearnedPlane>, I>>(base?: I): LearnedPlane {
    return LearnedPlane.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LearnedPlane>, I>>(object: I): LearnedPlane {
    const message = createBaseLearnedPlane();
    message.modelPath = object.modelPath ?? "";
    return message;
  },
};

function createBaseRunPlaneProjectionResponse(): RunPlaneProjectionResponse {
  return { data: undefined, error: undefined };
}

export const RunPlaneProjectionResponse: MessageFns<RunPlaneProjectionResponse> = {
  encode(message: RunPlaneProjectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      PlaneProjectionResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunPlaneProjectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunPlaneProjectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = PlaneProjectionResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunPlaneProjectionResponse {
    return {
      data: isSet(object.data) ? PlaneProjectionResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: RunPlaneProjectionResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = PlaneProjectionResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunPlaneProjectionResponse>, I>>(base?: I): RunPlaneProjectionResponse {
    return RunPlaneProjectionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunPlaneProjectionResponse>, I>>(object: I): RunPlaneProjectionResponse {
    const message = createBaseRunPlaneProjectionResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? PlaneProjectionResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBasePlaneProjectionResult(): PlaneProjectionResult {
  return { detections: [], processingTimeMs: undefined, debugVisualization: undefined };
}

export const PlaneProjectionResult: MessageFns<PlaneProjectionResult> = {
  encode(message: PlaneProjectionResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.detections) {
      Detection3D.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    if (message.debugVisualization !== undefined) {
      writer.uint32(26).bytes(message.debugVisualization);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlaneProjectionResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaneProjectionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detections.push(Detection3D.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.debugVisualization = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaneProjectionResult {
    return {
      detections: globalThis.Array.isArray(object?.detections)
        ? object.detections.map((e: any) => Detection3D.fromJSON(e))
        : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
      debugVisualization: isSet(object.debugVisualization) ? bytesFromBase64(object.debugVisualization) : undefined,
    };
  },

  toJSON(message: PlaneProjectionResult): unknown {
    const obj: any = {};
    if (message.detections?.length) {
      obj.detections = message.detections.map((e) => Detection3D.toJSON(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    if (message.debugVisualization !== undefined) {
      obj.debugVisualization = base64FromBytes(message.debugVisualization);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaneProjectionResult>, I>>(base?: I): PlaneProjectionResult {
    return PlaneProjectionResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaneProjectionResult>, I>>(object: I): PlaneProjectionResult {
    const message = createBasePlaneProjectionResult();
    message.detections = object.detections?.map((e) => Detection3D.fromPartial(e)) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    message.debugVisualization = object.debugVisualization ?? undefined;
    return message;
  },
};

function createBaseDetection3D(): Detection3D {
  return {
    blob2d: undefined,
    pose: undefined,
    surfaceNormal: undefined,
    score: 0,
    inlierRatio: undefined,
    extents: undefined,
    segment: undefined,
  };
}

export const Detection3D: MessageFns<Detection3D> = {
  encode(message: Detection3D, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.blob2d !== undefined) {
      Detection2D.encode(message.blob2d, writer.uint32(10).fork()).join();
    }
    if (message.pose !== undefined) {
      CartesianPose.encode(message.pose, writer.uint32(18).fork()).join();
    }
    if (message.surfaceNormal !== undefined) {
      Point.encode(message.surfaceNormal, writer.uint32(26).fork()).join();
    }
    if (message.score !== 0) {
      writer.uint32(37).float(message.score);
    }
    if (message.inlierRatio !== undefined) {
      writer.uint32(45).float(message.inlierRatio);
    }
    if (message.extents !== undefined) {
      Point.encode(message.extents, writer.uint32(50).fork()).join();
    }
    if (message.segment !== undefined) {
      Blob2D.encode(message.segment, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Detection3D {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetection3D();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blob2d = Detection2D.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pose = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.surfaceNormal = Point.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.score = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.inlierRatio = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.extents = Point.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.segment = Blob2D.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Detection3D {
    return {
      blob2d: isSet(object.blob2d) ? Detection2D.fromJSON(object.blob2d) : undefined,
      pose: isSet(object.pose) ? CartesianPose.fromJSON(object.pose) : undefined,
      surfaceNormal: isSet(object.surfaceNormal) ? Point.fromJSON(object.surfaceNormal) : undefined,
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      inlierRatio: isSet(object.inlierRatio) ? globalThis.Number(object.inlierRatio) : undefined,
      extents: isSet(object.extents) ? Point.fromJSON(object.extents) : undefined,
      segment: isSet(object.segment) ? Blob2D.fromJSON(object.segment) : undefined,
    };
  },

  toJSON(message: Detection3D): unknown {
    const obj: any = {};
    if (message.blob2d !== undefined) {
      obj.blob2d = Detection2D.toJSON(message.blob2d);
    }
    if (message.pose !== undefined) {
      obj.pose = CartesianPose.toJSON(message.pose);
    }
    if (message.surfaceNormal !== undefined) {
      obj.surfaceNormal = Point.toJSON(message.surfaceNormal);
    }
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.inlierRatio !== undefined) {
      obj.inlierRatio = message.inlierRatio;
    }
    if (message.extents !== undefined) {
      obj.extents = Point.toJSON(message.extents);
    }
    if (message.segment !== undefined) {
      obj.segment = Blob2D.toJSON(message.segment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Detection3D>, I>>(base?: I): Detection3D {
    return Detection3D.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Detection3D>, I>>(object: I): Detection3D {
    const message = createBaseDetection3D();
    message.blob2d = (object.blob2d !== undefined && object.blob2d !== null)
      ? Detection2D.fromPartial(object.blob2d)
      : undefined;
    message.pose = (object.pose !== undefined && object.pose !== null)
      ? CartesianPose.fromPartial(object.pose)
      : undefined;
    message.surfaceNormal = (object.surfaceNormal !== undefined && object.surfaceNormal !== null)
      ? Point.fromPartial(object.surfaceNormal)
      : undefined;
    message.score = object.score ?? 0;
    message.inlierRatio = object.inlierRatio ?? undefined;
    message.extents = (object.extents !== undefined && object.extents !== null)
      ? Point.fromPartial(object.extents)
      : undefined;
    message.segment = (object.segment !== undefined && object.segment !== null)
      ? Blob2D.fromPartial(object.segment)
      : undefined;
    return message;
  },
};

function createBaseBlobDetectionParams(): BlobDetectionParams {
  return {
    minThreshold: 0,
    maxThreshold: 0,
    minArea: 0,
    maxArea: 0,
    filterByCircularity: false,
    filterByConvexity: false,
    filterByInertia: false,
    minCircularity: 0,
    maxCircularity: 0,
    invertImage: false,
  };
}

export const BlobDetectionParams: MessageFns<BlobDetectionParams> = {
  encode(message: BlobDetectionParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minThreshold !== 0) {
      writer.uint32(9).double(message.minThreshold);
    }
    if (message.maxThreshold !== 0) {
      writer.uint32(17).double(message.maxThreshold);
    }
    if (message.minArea !== 0) {
      writer.uint32(25).double(message.minArea);
    }
    if (message.maxArea !== 0) {
      writer.uint32(33).double(message.maxArea);
    }
    if (message.filterByCircularity !== false) {
      writer.uint32(40).bool(message.filterByCircularity);
    }
    if (message.filterByConvexity !== false) {
      writer.uint32(48).bool(message.filterByConvexity);
    }
    if (message.filterByInertia !== false) {
      writer.uint32(56).bool(message.filterByInertia);
    }
    if (message.minCircularity !== 0) {
      writer.uint32(65).double(message.minCircularity);
    }
    if (message.maxCircularity !== 0) {
      writer.uint32(73).double(message.maxCircularity);
    }
    if (message.invertImage !== false) {
      writer.uint32(80).bool(message.invertImage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BlobDetectionParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlobDetectionParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.minThreshold = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maxThreshold = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.minArea = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.maxArea = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.filterByCircularity = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.filterByConvexity = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.filterByInertia = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.minCircularity = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.maxCircularity = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.invertImage = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BlobDetectionParams {
    return {
      minThreshold: isSet(object.minThreshold) ? globalThis.Number(object.minThreshold) : 0,
      maxThreshold: isSet(object.maxThreshold) ? globalThis.Number(object.maxThreshold) : 0,
      minArea: isSet(object.minArea) ? globalThis.Number(object.minArea) : 0,
      maxArea: isSet(object.maxArea) ? globalThis.Number(object.maxArea) : 0,
      filterByCircularity: isSet(object.filterByCircularity) ? globalThis.Boolean(object.filterByCircularity) : false,
      filterByConvexity: isSet(object.filterByConvexity) ? globalThis.Boolean(object.filterByConvexity) : false,
      filterByInertia: isSet(object.filterByInertia) ? globalThis.Boolean(object.filterByInertia) : false,
      minCircularity: isSet(object.minCircularity) ? globalThis.Number(object.minCircularity) : 0,
      maxCircularity: isSet(object.maxCircularity) ? globalThis.Number(object.maxCircularity) : 0,
      invertImage: isSet(object.invertImage) ? globalThis.Boolean(object.invertImage) : false,
    };
  },

  toJSON(message: BlobDetectionParams): unknown {
    const obj: any = {};
    if (message.minThreshold !== 0) {
      obj.minThreshold = message.minThreshold;
    }
    if (message.maxThreshold !== 0) {
      obj.maxThreshold = message.maxThreshold;
    }
    if (message.minArea !== 0) {
      obj.minArea = message.minArea;
    }
    if (message.maxArea !== 0) {
      obj.maxArea = message.maxArea;
    }
    if (message.filterByCircularity !== false) {
      obj.filterByCircularity = message.filterByCircularity;
    }
    if (message.filterByConvexity !== false) {
      obj.filterByConvexity = message.filterByConvexity;
    }
    if (message.filterByInertia !== false) {
      obj.filterByInertia = message.filterByInertia;
    }
    if (message.minCircularity !== 0) {
      obj.minCircularity = message.minCircularity;
    }
    if (message.maxCircularity !== 0) {
      obj.maxCircularity = message.maxCircularity;
    }
    if (message.invertImage !== false) {
      obj.invertImage = message.invertImage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BlobDetectionParams>, I>>(base?: I): BlobDetectionParams {
    return BlobDetectionParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BlobDetectionParams>, I>>(object: I): BlobDetectionParams {
    const message = createBaseBlobDetectionParams();
    message.minThreshold = object.minThreshold ?? 0;
    message.maxThreshold = object.maxThreshold ?? 0;
    message.minArea = object.minArea ?? 0;
    message.maxArea = object.maxArea ?? 0;
    message.filterByCircularity = object.filterByCircularity ?? false;
    message.filterByConvexity = object.filterByConvexity ?? false;
    message.filterByInertia = object.filterByInertia ?? false;
    message.minCircularity = object.minCircularity ?? 0;
    message.maxCircularity = object.maxCircularity ?? 0;
    message.invertImage = object.invertImage ?? false;
    return message;
  },
};

function createBaseDetectBlobsRequest(): DetectBlobsRequest {
  return { image: new Uint8Array(0), params: undefined };
}

export const DetectBlobsRequest: MessageFns<DetectBlobsRequest> = {
  encode(message: DetectBlobsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.params !== undefined) {
      BlobDetectionParams.encode(message.params, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectBlobsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectBlobsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.params = BlobDetectionParams.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectBlobsRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      params: isSet(object.params) ? BlobDetectionParams.fromJSON(object.params) : undefined,
    };
  },

  toJSON(message: DetectBlobsRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.params !== undefined) {
      obj.params = BlobDetectionParams.toJSON(message.params);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectBlobsRequest>, I>>(base?: I): DetectBlobsRequest {
    return DetectBlobsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectBlobsRequest>, I>>(object: I): DetectBlobsRequest {
    const message = createBaseDetectBlobsRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.params = (object.params !== undefined && object.params !== null)
      ? BlobDetectionParams.fromPartial(object.params)
      : undefined;
    return message;
  },
};

function createBaseDetectBlobsResponse(): DetectBlobsResponse {
  return { data: undefined, error: undefined };
}

export const DetectBlobsResponse: MessageFns<DetectBlobsResponse> = {
  encode(message: DetectBlobsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      BlobList.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectBlobsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectBlobsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = BlobList.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectBlobsResponse {
    return {
      data: isSet(object.data) ? BlobList.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: DetectBlobsResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = BlobList.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectBlobsResponse>, I>>(base?: I): DetectBlobsResponse {
    return DetectBlobsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectBlobsResponse>, I>>(object: I): DetectBlobsResponse {
    const message = createBaseDetectBlobsResponse();
    message.data = (object.data !== undefined && object.data !== null) ? BlobList.fromPartial(object.data) : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseBlobList(): BlobList {
  return { blobs: [] };
}

export const BlobList: MessageFns<BlobList> = {
  encode(message: BlobList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blobs) {
      LocateMatch.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BlobList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlobList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blobs.push(LocateMatch.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BlobList {
    return {
      blobs: globalThis.Array.isArray(object?.blobs) ? object.blobs.map((e: any) => LocateMatch.fromJSON(e)) : [],
    };
  },

  toJSON(message: BlobList): unknown {
    const obj: any = {};
    if (message.blobs?.length) {
      obj.blobs = message.blobs.map((e) => LocateMatch.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BlobList>, I>>(base?: I): BlobList {
    return BlobList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BlobList>, I>>(object: I): BlobList {
    const message = createBaseBlobList();
    message.blobs = object.blobs?.map((e) => LocateMatch.fromPartial(e)) || [];
    return message;
  },
};

function createBaseShapeDetectionParams(): ShapeDetectionParams {
  return {
    minScale: 0,
    maxScale: 0,
    maxRotation: 0,
    matchThreshold: 0,
    filterIntersections: false,
    rejectOnEdge: false,
  };
}

export const ShapeDetectionParams: MessageFns<ShapeDetectionParams> = {
  encode(message: ShapeDetectionParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minScale !== 0) {
      writer.uint32(9).double(message.minScale);
    }
    if (message.maxScale !== 0) {
      writer.uint32(17).double(message.maxScale);
    }
    if (message.maxRotation !== 0) {
      writer.uint32(25).double(message.maxRotation);
    }
    if (message.matchThreshold !== 0) {
      writer.uint32(33).double(message.matchThreshold);
    }
    if (message.filterIntersections !== false) {
      writer.uint32(40).bool(message.filterIntersections);
    }
    if (message.rejectOnEdge !== false) {
      writer.uint32(48).bool(message.rejectOnEdge);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShapeDetectionParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShapeDetectionParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.minScale = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maxScale = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.maxRotation = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.matchThreshold = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.filterIntersections = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rejectOnEdge = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShapeDetectionParams {
    return {
      minScale: isSet(object.minScale) ? globalThis.Number(object.minScale) : 0,
      maxScale: isSet(object.maxScale) ? globalThis.Number(object.maxScale) : 0,
      maxRotation: isSet(object.maxRotation) ? globalThis.Number(object.maxRotation) : 0,
      matchThreshold: isSet(object.matchThreshold) ? globalThis.Number(object.matchThreshold) : 0,
      filterIntersections: isSet(object.filterIntersections) ? globalThis.Boolean(object.filterIntersections) : false,
      rejectOnEdge: isSet(object.rejectOnEdge) ? globalThis.Boolean(object.rejectOnEdge) : false,
    };
  },

  toJSON(message: ShapeDetectionParams): unknown {
    const obj: any = {};
    if (message.minScale !== 0) {
      obj.minScale = message.minScale;
    }
    if (message.maxScale !== 0) {
      obj.maxScale = message.maxScale;
    }
    if (message.maxRotation !== 0) {
      obj.maxRotation = message.maxRotation;
    }
    if (message.matchThreshold !== 0) {
      obj.matchThreshold = message.matchThreshold;
    }
    if (message.filterIntersections !== false) {
      obj.filterIntersections = message.filterIntersections;
    }
    if (message.rejectOnEdge !== false) {
      obj.rejectOnEdge = message.rejectOnEdge;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShapeDetectionParams>, I>>(base?: I): ShapeDetectionParams {
    return ShapeDetectionParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShapeDetectionParams>, I>>(object: I): ShapeDetectionParams {
    const message = createBaseShapeDetectionParams();
    message.minScale = object.minScale ?? 0;
    message.maxScale = object.maxScale ?? 0;
    message.maxRotation = object.maxRotation ?? 0;
    message.matchThreshold = object.matchThreshold ?? 0;
    message.filterIntersections = object.filterIntersections ?? false;
    message.rejectOnEdge = object.rejectOnEdge ?? false;
    return message;
  },
};

function createBaseDetectShapesRequest(): DetectShapesRequest {
  return { templateImage: new Uint8Array(0), targetImage: new Uint8Array(0), params: undefined };
}

export const DetectShapesRequest: MessageFns<DetectShapesRequest> = {
  encode(message: DetectShapesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.templateImage.length !== 0) {
      writer.uint32(10).bytes(message.templateImage);
    }
    if (message.targetImage.length !== 0) {
      writer.uint32(18).bytes(message.targetImage);
    }
    if (message.params !== undefined) {
      ShapeDetectionParams.encode(message.params, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectShapesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectShapesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templateImage = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.targetImage = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.params = ShapeDetectionParams.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectShapesRequest {
    return {
      templateImage: isSet(object.templateImage) ? bytesFromBase64(object.templateImage) : new Uint8Array(0),
      targetImage: isSet(object.targetImage) ? bytesFromBase64(object.targetImage) : new Uint8Array(0),
      params: isSet(object.params) ? ShapeDetectionParams.fromJSON(object.params) : undefined,
    };
  },

  toJSON(message: DetectShapesRequest): unknown {
    const obj: any = {};
    if (message.templateImage.length !== 0) {
      obj.templateImage = base64FromBytes(message.templateImage);
    }
    if (message.targetImage.length !== 0) {
      obj.targetImage = base64FromBytes(message.targetImage);
    }
    if (message.params !== undefined) {
      obj.params = ShapeDetectionParams.toJSON(message.params);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectShapesRequest>, I>>(base?: I): DetectShapesRequest {
    return DetectShapesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectShapesRequest>, I>>(object: I): DetectShapesRequest {
    const message = createBaseDetectShapesRequest();
    message.templateImage = object.templateImage ?? new Uint8Array(0);
    message.targetImage = object.targetImage ?? new Uint8Array(0);
    message.params = (object.params !== undefined && object.params !== null)
      ? ShapeDetectionParams.fromPartial(object.params)
      : undefined;
    return message;
  },
};

function createBaseDetectShapesResponse(): DetectShapesResponse {
  return { data: undefined, error: undefined };
}

export const DetectShapesResponse: MessageFns<DetectShapesResponse> = {
  encode(message: DetectShapesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      BlobList.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectShapesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectShapesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = BlobList.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectShapesResponse {
    return {
      data: isSet(object.data) ? BlobList.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: DetectShapesResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = BlobList.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectShapesResponse>, I>>(base?: I): DetectShapesResponse {
    return DetectShapesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectShapesResponse>, I>>(object: I): DetectShapesResponse {
    const message = createBaseDetectShapesResponse();
    message.data = (object.data !== undefined && object.data !== null) ? BlobList.fromPartial(object.data) : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseTextPromptDetectionParams(): TextPromptDetectionParams {
  return { prompt: "", useSam: false, boxThreshold: 0, textThreshold: 0 };
}

export const TextPromptDetectionParams: MessageFns<TextPromptDetectionParams> = {
  encode(message: TextPromptDetectionParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    if (message.useSam !== false) {
      writer.uint32(16).bool(message.useSam);
    }
    if (message.boxThreshold !== 0) {
      writer.uint32(25).double(message.boxThreshold);
    }
    if (message.textThreshold !== 0) {
      writer.uint32(33).double(message.textThreshold);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextPromptDetectionParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextPromptDetectionParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.useSam = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.boxThreshold = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.textThreshold = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextPromptDetectionParams {
    return {
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      useSam: isSet(object.useSam) ? globalThis.Boolean(object.useSam) : false,
      boxThreshold: isSet(object.boxThreshold) ? globalThis.Number(object.boxThreshold) : 0,
      textThreshold: isSet(object.textThreshold) ? globalThis.Number(object.textThreshold) : 0,
    };
  },

  toJSON(message: TextPromptDetectionParams): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.useSam !== false) {
      obj.useSam = message.useSam;
    }
    if (message.boxThreshold !== 0) {
      obj.boxThreshold = message.boxThreshold;
    }
    if (message.textThreshold !== 0) {
      obj.textThreshold = message.textThreshold;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TextPromptDetectionParams>, I>>(base?: I): TextPromptDetectionParams {
    return TextPromptDetectionParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextPromptDetectionParams>, I>>(object: I): TextPromptDetectionParams {
    const message = createBaseTextPromptDetectionParams();
    message.prompt = object.prompt ?? "";
    message.useSam = object.useSam ?? false;
    message.boxThreshold = object.boxThreshold ?? 0;
    message.textThreshold = object.textThreshold ?? 0;
    return message;
  },
};

function createBaseDetectTextPromptRequest(): DetectTextPromptRequest {
  return { image: new Uint8Array(0), params: undefined };
}

export const DetectTextPromptRequest: MessageFns<DetectTextPromptRequest> = {
  encode(message: DetectTextPromptRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.params !== undefined) {
      TextPromptDetectionParams.encode(message.params, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectTextPromptRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectTextPromptRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.params = TextPromptDetectionParams.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectTextPromptRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      params: isSet(object.params) ? TextPromptDetectionParams.fromJSON(object.params) : undefined,
    };
  },

  toJSON(message: DetectTextPromptRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.params !== undefined) {
      obj.params = TextPromptDetectionParams.toJSON(message.params);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectTextPromptRequest>, I>>(base?: I): DetectTextPromptRequest {
    return DetectTextPromptRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectTextPromptRequest>, I>>(object: I): DetectTextPromptRequest {
    const message = createBaseDetectTextPromptRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.params = (object.params !== undefined && object.params !== null)
      ? TextPromptDetectionParams.fromPartial(object.params)
      : undefined;
    return message;
  },
};

function createBaseDetectTextPromptResponse(): DetectTextPromptResponse {
  return { data: undefined, error: undefined };
}

export const DetectTextPromptResponse: MessageFns<DetectTextPromptResponse> = {
  encode(message: DetectTextPromptResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      BlobList.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectTextPromptResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectTextPromptResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = BlobList.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectTextPromptResponse {
    return {
      data: isSet(object.data) ? BlobList.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: DetectTextPromptResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = BlobList.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectTextPromptResponse>, I>>(base?: I): DetectTextPromptResponse {
    return DetectTextPromptResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectTextPromptResponse>, I>>(object: I): DetectTextPromptResponse {
    const message = createBaseDetectTextPromptResponse();
    message.data = (object.data !== undefined && object.data !== null) ? BlobList.fromPartial(object.data) : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseClassifyRequest(): ClassifyRequest {
  return { encodedFrame: new Uint8Array(0), encodedTemplateImages: [] };
}

export const ClassifyRequest: MessageFns<ClassifyRequest> = {
  encode(message: ClassifyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.encodedFrame.length !== 0) {
      writer.uint32(10).bytes(message.encodedFrame);
    }
    for (const v of message.encodedTemplateImages) {
      writer.uint32(18).bytes(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClassifyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.encodedFrame = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.encodedTemplateImages.push(reader.bytes());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClassifyRequest {
    return {
      encodedFrame: isSet(object.encodedFrame) ? bytesFromBase64(object.encodedFrame) : new Uint8Array(0),
      encodedTemplateImages: globalThis.Array.isArray(object?.encodedTemplateImages)
        ? object.encodedTemplateImages.map((e: any) => bytesFromBase64(e))
        : [],
    };
  },

  toJSON(message: ClassifyRequest): unknown {
    const obj: any = {};
    if (message.encodedFrame.length !== 0) {
      obj.encodedFrame = base64FromBytes(message.encodedFrame);
    }
    if (message.encodedTemplateImages?.length) {
      obj.encodedTemplateImages = message.encodedTemplateImages.map((e) => base64FromBytes(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClassifyRequest>, I>>(base?: I): ClassifyRequest {
    return ClassifyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyRequest>, I>>(object: I): ClassifyRequest {
    const message = createBaseClassifyRequest();
    message.encodedFrame = object.encodedFrame ?? new Uint8Array(0);
    message.encodedTemplateImages = object.encodedTemplateImages?.map((e) => e) || [];
    return message;
  },
};

function createBaseClassifyResponse(): ClassifyResponse {
  return { data: undefined, error: undefined };
}

export const ClassifyResponse: MessageFns<ClassifyResponse> = {
  encode(message: ClassifyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      ClassifyResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClassifyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = ClassifyResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClassifyResponse {
    return {
      data: isSet(object.data) ? ClassifyResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: ClassifyResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = ClassifyResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClassifyResponse>, I>>(base?: I): ClassifyResponse {
    return ClassifyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyResponse>, I>>(object: I): ClassifyResponse {
    const message = createBaseClassifyResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? ClassifyResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseClassifyResult(): ClassifyResult {
  return { scores: [] };
}

export const ClassifyResult: MessageFns<ClassifyResult> = {
  encode(message: ClassifyResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.scores) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClassifyResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.scores.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.scores.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClassifyResult {
    return {
      scores: globalThis.Array.isArray(object?.scores) ? object.scores.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: ClassifyResult): unknown {
    const obj: any = {};
    if (message.scores?.length) {
      obj.scores = message.scores;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClassifyResult>, I>>(base?: I): ClassifyResult {
    return ClassifyResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyResult>, I>>(object: I): ClassifyResult {
    const message = createBaseClassifyResult();
    message.scores = object.scores?.map((e) => e) || [];
    return message;
  },
};

function createBaseChessboard(): Chessboard {
  return { kind: "", numRows: 0, numCols: 0, squareSize: 0, arucoDict: undefined, markerSize: undefined };
}

export const Chessboard: MessageFns<Chessboard> = {
  encode(message: Chessboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== "") {
      writer.uint32(10).string(message.kind);
    }
    if (message.numRows !== 0) {
      writer.uint32(16).int32(message.numRows);
    }
    if (message.numCols !== 0) {
      writer.uint32(24).int32(message.numCols);
    }
    if (message.squareSize !== 0) {
      writer.uint32(33).double(message.squareSize);
    }
    if (message.arucoDict !== undefined) {
      writer.uint32(42).string(message.arucoDict);
    }
    if (message.markerSize !== undefined) {
      writer.uint32(49).double(message.markerSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Chessboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChessboard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.numRows = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.numCols = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.squareSize = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.arucoDict = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.markerSize = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Chessboard {
    return {
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      numRows: isSet(object.numRows) ? globalThis.Number(object.numRows) : 0,
      numCols: isSet(object.numCols) ? globalThis.Number(object.numCols) : 0,
      squareSize: isSet(object.squareSize) ? globalThis.Number(object.squareSize) : 0,
      arucoDict: isSet(object.arucoDict) ? globalThis.String(object.arucoDict) : undefined,
      markerSize: isSet(object.markerSize) ? globalThis.Number(object.markerSize) : undefined,
    };
  },

  toJSON(message: Chessboard): unknown {
    const obj: any = {};
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.numRows !== 0) {
      obj.numRows = Math.round(message.numRows);
    }
    if (message.numCols !== 0) {
      obj.numCols = Math.round(message.numCols);
    }
    if (message.squareSize !== 0) {
      obj.squareSize = message.squareSize;
    }
    if (message.arucoDict !== undefined) {
      obj.arucoDict = message.arucoDict;
    }
    if (message.markerSize !== undefined) {
      obj.markerSize = message.markerSize;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Chessboard>, I>>(base?: I): Chessboard {
    return Chessboard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Chessboard>, I>>(object: I): Chessboard {
    const message = createBaseChessboard();
    message.kind = object.kind ?? "";
    message.numRows = object.numRows ?? 0;
    message.numCols = object.numCols ?? 0;
    message.squareSize = object.squareSize ?? 0;
    message.arucoDict = object.arucoDict ?? undefined;
    message.markerSize = object.markerSize ?? undefined;
    return message;
  },
};

function createBaseCameraIntrinsicsMsg(): CameraIntrinsicsMsg {
  return { fx: 0, fy: 0, ppx: 0, ppy: 0, width: 0, height: 0, error: undefined };
}

export const CameraIntrinsicsMsg: MessageFns<CameraIntrinsicsMsg> = {
  encode(message: CameraIntrinsicsMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fx !== 0) {
      writer.uint32(9).double(message.fx);
    }
    if (message.fy !== 0) {
      writer.uint32(17).double(message.fy);
    }
    if (message.ppx !== 0) {
      writer.uint32(25).double(message.ppx);
    }
    if (message.ppy !== 0) {
      writer.uint32(33).double(message.ppy);
    }
    if (message.width !== 0) {
      writer.uint32(41).double(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(49).double(message.height);
    }
    if (message.error !== undefined) {
      writer.uint32(57).double(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraIntrinsicsMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraIntrinsicsMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.fx = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.fy = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.ppx = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.ppy = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.width = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.error = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraIntrinsicsMsg {
    return {
      fx: isSet(object.fx) ? globalThis.Number(object.fx) : 0,
      fy: isSet(object.fy) ? globalThis.Number(object.fy) : 0,
      ppx: isSet(object.ppx) ? globalThis.Number(object.ppx) : 0,
      ppy: isSet(object.ppy) ? globalThis.Number(object.ppy) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      error: isSet(object.error) ? globalThis.Number(object.error) : undefined,
    };
  },

  toJSON(message: CameraIntrinsicsMsg): unknown {
    const obj: any = {};
    if (message.fx !== 0) {
      obj.fx = message.fx;
    }
    if (message.fy !== 0) {
      obj.fy = message.fy;
    }
    if (message.ppx !== 0) {
      obj.ppx = message.ppx;
    }
    if (message.ppy !== 0) {
      obj.ppy = message.ppy;
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraIntrinsicsMsg>, I>>(base?: I): CameraIntrinsicsMsg {
    return CameraIntrinsicsMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraIntrinsicsMsg>, I>>(object: I): CameraIntrinsicsMsg {
    const message = createBaseCameraIntrinsicsMsg();
    message.fx = object.fx ?? 0;
    message.fy = object.fy ?? 0;
    message.ppx = object.ppx ?? 0;
    message.ppy = object.ppy ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseCameraIntrinsicsExtendedMsg(): CameraIntrinsicsExtendedMsg {
  return {
    fx: 0,
    fy: 0,
    ppx: 0,
    ppy: 0,
    width: 0,
    height: 0,
    distortionCoefficients: [],
    distortionModel: "",
    error: undefined,
  };
}

export const CameraIntrinsicsExtendedMsg: MessageFns<CameraIntrinsicsExtendedMsg> = {
  encode(message: CameraIntrinsicsExtendedMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fx !== 0) {
      writer.uint32(9).double(message.fx);
    }
    if (message.fy !== 0) {
      writer.uint32(17).double(message.fy);
    }
    if (message.ppx !== 0) {
      writer.uint32(25).double(message.ppx);
    }
    if (message.ppy !== 0) {
      writer.uint32(33).double(message.ppy);
    }
    if (message.width !== 0) {
      writer.uint32(41).double(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(49).double(message.height);
    }
    writer.uint32(58).fork();
    for (const v of message.distortionCoefficients) {
      writer.double(v);
    }
    writer.join();
    if (message.distortionModel !== "") {
      writer.uint32(66).string(message.distortionModel);
    }
    if (message.error !== undefined) {
      writer.uint32(73).double(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraIntrinsicsExtendedMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraIntrinsicsExtendedMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.fx = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.fy = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.ppx = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.ppy = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.width = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 7: {
          if (tag === 57) {
            message.distortionCoefficients.push(reader.double());

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.distortionCoefficients.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.distortionModel = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.error = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraIntrinsicsExtendedMsg {
    return {
      fx: isSet(object.fx) ? globalThis.Number(object.fx) : 0,
      fy: isSet(object.fy) ? globalThis.Number(object.fy) : 0,
      ppx: isSet(object.ppx) ? globalThis.Number(object.ppx) : 0,
      ppy: isSet(object.ppy) ? globalThis.Number(object.ppy) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      distortionCoefficients: globalThis.Array.isArray(object?.distortionCoefficients)
        ? object.distortionCoefficients.map((e: any) => globalThis.Number(e))
        : [],
      distortionModel: isSet(object.distortionModel) ? globalThis.String(object.distortionModel) : "",
      error: isSet(object.error) ? globalThis.Number(object.error) : undefined,
    };
  },

  toJSON(message: CameraIntrinsicsExtendedMsg): unknown {
    const obj: any = {};
    if (message.fx !== 0) {
      obj.fx = message.fx;
    }
    if (message.fy !== 0) {
      obj.fy = message.fy;
    }
    if (message.ppx !== 0) {
      obj.ppx = message.ppx;
    }
    if (message.ppy !== 0) {
      obj.ppy = message.ppy;
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.distortionCoefficients?.length) {
      obj.distortionCoefficients = message.distortionCoefficients;
    }
    if (message.distortionModel !== "") {
      obj.distortionModel = message.distortionModel;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraIntrinsicsExtendedMsg>, I>>(base?: I): CameraIntrinsicsExtendedMsg {
    return CameraIntrinsicsExtendedMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraIntrinsicsExtendedMsg>, I>>(object: I): CameraIntrinsicsExtendedMsg {
    const message = createBaseCameraIntrinsicsExtendedMsg();
    message.fx = object.fx ?? 0;
    message.fy = object.fy ?? 0;
    message.ppx = object.ppx ?? 0;
    message.ppy = object.ppy ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.distortionCoefficients = object.distortionCoefficients?.map((e) => e) || [];
    message.distortionModel = object.distortionModel ?? "";
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseGetChessboardCornersRequest(): GetChessboardCornersRequest {
  return { image: new Uint8Array(0), chessboard: undefined };
}

export const GetChessboardCornersRequest: MessageFns<GetChessboardCornersRequest> = {
  encode(message: GetChessboardCornersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChessboardCornersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChessboardCornersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChessboardCornersRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
    };
  },

  toJSON(message: GetChessboardCornersRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetChessboardCornersRequest>, I>>(base?: I): GetChessboardCornersRequest {
    return GetChessboardCornersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetChessboardCornersRequest>, I>>(object: I): GetChessboardCornersRequest {
    const message = createBaseGetChessboardCornersRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    return message;
  },
};

function createBaseGetChessboardCornersResponse(): GetChessboardCornersResponse {
  return { data: undefined, error: undefined };
}

export const GetChessboardCornersResponse: MessageFns<GetChessboardCornersResponse> = {
  encode(message: GetChessboardCornersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      ChessboardCornersResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChessboardCornersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChessboardCornersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = ChessboardCornersResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChessboardCornersResponse {
    return {
      data: isSet(object.data) ? ChessboardCornersResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: GetChessboardCornersResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = ChessboardCornersResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetChessboardCornersResponse>, I>>(base?: I): GetChessboardCornersResponse {
    return GetChessboardCornersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetChessboardCornersResponse>, I>>(object: I): GetChessboardCornersResponse {
    const message = createBaseGetChessboardCornersResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? ChessboardCornersResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseChessboardCornersResult(): ChessboardCornersResult {
  return { isDetected: false, corners: [] };
}

export const ChessboardCornersResult: MessageFns<ChessboardCornersResult> = {
  encode(message: ChessboardCornersResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isDetected !== false) {
      writer.uint32(8).bool(message.isDetected);
    }
    for (const v of message.corners) {
      Point2D.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChessboardCornersResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChessboardCornersResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isDetected = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.corners.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChessboardCornersResult {
    return {
      isDetected: isSet(object.isDetected) ? globalThis.Boolean(object.isDetected) : false,
      corners: globalThis.Array.isArray(object?.corners) ? object.corners.map((e: any) => Point2D.fromJSON(e)) : [],
    };
  },

  toJSON(message: ChessboardCornersResult): unknown {
    const obj: any = {};
    if (message.isDetected !== false) {
      obj.isDetected = message.isDetected;
    }
    if (message.corners?.length) {
      obj.corners = message.corners.map((e) => Point2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChessboardCornersResult>, I>>(base?: I): ChessboardCornersResult {
    return ChessboardCornersResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChessboardCornersResult>, I>>(object: I): ChessboardCornersResult {
    const message = createBaseChessboardCornersResult();
    message.isDetected = object.isDetected ?? false;
    message.corners = object.corners?.map((e) => Point2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCameraChessboardTransformRequest(): GetCameraChessboardTransformRequest {
  return { image: new Uint8Array(0), chessboard: undefined, intrinsics: undefined };
}

export const GetCameraChessboardTransformRequest: MessageFns<GetCameraChessboardTransformRequest> = {
  encode(message: GetCameraChessboardTransformRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(18).fork()).join();
    }
    if (message.intrinsics !== undefined) {
      CameraIntrinsicsMsg.encode(message.intrinsics, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCameraChessboardTransformRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCameraChessboardTransformRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.intrinsics = CameraIntrinsicsMsg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCameraChessboardTransformRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
      intrinsics: isSet(object.intrinsics) ? CameraIntrinsicsMsg.fromJSON(object.intrinsics) : undefined,
    };
  },

  toJSON(message: GetCameraChessboardTransformRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    if (message.intrinsics !== undefined) {
      obj.intrinsics = CameraIntrinsicsMsg.toJSON(message.intrinsics);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCameraChessboardTransformRequest>, I>>(
    base?: I,
  ): GetCameraChessboardTransformRequest {
    return GetCameraChessboardTransformRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCameraChessboardTransformRequest>, I>>(
    object: I,
  ): GetCameraChessboardTransformRequest {
    const message = createBaseGetCameraChessboardTransformRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    message.intrinsics = (object.intrinsics !== undefined && object.intrinsics !== null)
      ? CameraIntrinsicsMsg.fromPartial(object.intrinsics)
      : undefined;
    return message;
  },
};

function createBaseGetCameraChessboardTransformResponse(): GetCameraChessboardTransformResponse {
  return { data: undefined, error: undefined };
}

export const GetCameraChessboardTransformResponse: MessageFns<GetCameraChessboardTransformResponse> = {
  encode(message: GetCameraChessboardTransformResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CartesianPose.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCameraChessboardTransformResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCameraChessboardTransformResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCameraChessboardTransformResponse {
    return {
      data: isSet(object.data) ? CartesianPose.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: GetCameraChessboardTransformResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CartesianPose.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCameraChessboardTransformResponse>, I>>(
    base?: I,
  ): GetCameraChessboardTransformResponse {
    return GetCameraChessboardTransformResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCameraChessboardTransformResponse>, I>>(
    object: I,
  ): GetCameraChessboardTransformResponse {
    const message = createBaseGetCameraChessboardTransformResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CartesianPose.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCalibrateCameraRequest(): CalibrateCameraRequest {
  return { images: [], chessboard: undefined, poses: [] };
}

export const CalibrateCameraRequest: MessageFns<CalibrateCameraRequest> = {
  encode(message: CalibrateCameraRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.images) {
      writer.uint32(10).bytes(v!);
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(18).fork()).join();
    }
    for (const v of message.poses) {
      CartesianPose.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.images.push(reader.bytes());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.poses.push(CartesianPose.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraRequest {
    return {
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => bytesFromBase64(e)) : [],
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
      poses: globalThis.Array.isArray(object?.poses) ? object.poses.map((e: any) => CartesianPose.fromJSON(e)) : [],
    };
  },

  toJSON(message: CalibrateCameraRequest): unknown {
    const obj: any = {};
    if (message.images?.length) {
      obj.images = message.images.map((e) => base64FromBytes(e));
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    if (message.poses?.length) {
      obj.poses = message.poses.map((e) => CartesianPose.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraRequest>, I>>(base?: I): CalibrateCameraRequest {
    return CalibrateCameraRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraRequest>, I>>(object: I): CalibrateCameraRequest {
    const message = createBaseCalibrateCameraRequest();
    message.images = object.images?.map((e) => e) || [];
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    message.poses = object.poses?.map((e) => CartesianPose.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCalibrateCameraResponse(): CalibrateCameraResponse {
  return { data: undefined, error: undefined };
}

export const CalibrateCameraResponse: MessageFns<CalibrateCameraResponse> = {
  encode(message: CalibrateCameraResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      IntrinsicCalibrationResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = IntrinsicCalibrationResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraResponse {
    return {
      data: isSet(object.data) ? IntrinsicCalibrationResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CalibrateCameraResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = IntrinsicCalibrationResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraResponse>, I>>(base?: I): CalibrateCameraResponse {
    return CalibrateCameraResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraResponse>, I>>(object: I): CalibrateCameraResponse {
    const message = createBaseCalibrateCameraResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? IntrinsicCalibrationResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseIntrinsicCalibrationResult(): IntrinsicCalibrationResult {
  return { intrinsics: undefined, gripperToCam: undefined };
}

export const IntrinsicCalibrationResult: MessageFns<IntrinsicCalibrationResult> = {
  encode(message: IntrinsicCalibrationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intrinsics !== undefined) {
      CameraIntrinsicsMsg.encode(message.intrinsics, writer.uint32(10).fork()).join();
    }
    if (message.gripperToCam !== undefined) {
      CartesianPose.encode(message.gripperToCam, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntrinsicCalibrationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntrinsicCalibrationResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intrinsics = CameraIntrinsicsMsg.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gripperToCam = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntrinsicCalibrationResult {
    return {
      intrinsics: isSet(object.intrinsics) ? CameraIntrinsicsMsg.fromJSON(object.intrinsics) : undefined,
      gripperToCam: isSet(object.gripperToCam) ? CartesianPose.fromJSON(object.gripperToCam) : undefined,
    };
  },

  toJSON(message: IntrinsicCalibrationResult): unknown {
    const obj: any = {};
    if (message.intrinsics !== undefined) {
      obj.intrinsics = CameraIntrinsicsMsg.toJSON(message.intrinsics);
    }
    if (message.gripperToCam !== undefined) {
      obj.gripperToCam = CartesianPose.toJSON(message.gripperToCam);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntrinsicCalibrationResult>, I>>(base?: I): IntrinsicCalibrationResult {
    return IntrinsicCalibrationResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntrinsicCalibrationResult>, I>>(object: I): IntrinsicCalibrationResult {
    const message = createBaseIntrinsicCalibrationResult();
    message.intrinsics = (object.intrinsics !== undefined && object.intrinsics !== null)
      ? CameraIntrinsicsMsg.fromPartial(object.intrinsics)
      : undefined;
    message.gripperToCam = (object.gripperToCam !== undefined && object.gripperToCam !== null)
      ? CartesianPose.fromPartial(object.gripperToCam)
      : undefined;
    return message;
  },
};

function createBaseCalibrateCameraIntrinsicsRequest(): CalibrateCameraIntrinsicsRequest {
  return { images: [], chessboard: undefined };
}

export const CalibrateCameraIntrinsicsRequest: MessageFns<CalibrateCameraIntrinsicsRequest> = {
  encode(message: CalibrateCameraIntrinsicsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.images) {
      writer.uint32(10).bytes(v!);
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraIntrinsicsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraIntrinsicsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.images.push(reader.bytes());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraIntrinsicsRequest {
    return {
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => bytesFromBase64(e)) : [],
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
    };
  },

  toJSON(message: CalibrateCameraIntrinsicsRequest): unknown {
    const obj: any = {};
    if (message.images?.length) {
      obj.images = message.images.map((e) => base64FromBytes(e));
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraIntrinsicsRequest>, I>>(
    base?: I,
  ): CalibrateCameraIntrinsicsRequest {
    return CalibrateCameraIntrinsicsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraIntrinsicsRequest>, I>>(
    object: I,
  ): CalibrateCameraIntrinsicsRequest {
    const message = createBaseCalibrateCameraIntrinsicsRequest();
    message.images = object.images?.map((e) => e) || [];
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    return message;
  },
};

function createBaseCalibrateCameraIntrinsicsResponse(): CalibrateCameraIntrinsicsResponse {
  return { data: undefined, error: undefined };
}

export const CalibrateCameraIntrinsicsResponse: MessageFns<CalibrateCameraIntrinsicsResponse> = {
  encode(message: CalibrateCameraIntrinsicsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraIntrinsicsExtendedMsg.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraIntrinsicsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraIntrinsicsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraIntrinsicsExtendedMsg.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraIntrinsicsResponse {
    return {
      data: isSet(object.data) ? CameraIntrinsicsExtendedMsg.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CalibrateCameraIntrinsicsResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraIntrinsicsExtendedMsg.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraIntrinsicsResponse>, I>>(
    base?: I,
  ): CalibrateCameraIntrinsicsResponse {
    return CalibrateCameraIntrinsicsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraIntrinsicsResponse>, I>>(
    object: I,
  ): CalibrateCameraIntrinsicsResponse {
    const message = createBaseCalibrateCameraIntrinsicsResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraIntrinsicsExtendedMsg.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCalibrateCameraExtrinsicsRequest(): CalibrateCameraExtrinsicsRequest {
  return { images: [], poses: [], chessboard: undefined, intrinsics: undefined, mountType: "" };
}

export const CalibrateCameraExtrinsicsRequest: MessageFns<CalibrateCameraExtrinsicsRequest> = {
  encode(message: CalibrateCameraExtrinsicsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.images) {
      writer.uint32(10).bytes(v!);
    }
    for (const v of message.poses) {
      CartesianPose.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(26).fork()).join();
    }
    if (message.intrinsics !== undefined) {
      CameraIntrinsicsExtendedMsg.encode(message.intrinsics, writer.uint32(34).fork()).join();
    }
    if (message.mountType !== "") {
      writer.uint32(42).string(message.mountType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraExtrinsicsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraExtrinsicsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.images.push(reader.bytes());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.poses.push(CartesianPose.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.intrinsics = CameraIntrinsicsExtendedMsg.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.mountType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraExtrinsicsRequest {
    return {
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => bytesFromBase64(e)) : [],
      poses: globalThis.Array.isArray(object?.poses) ? object.poses.map((e: any) => CartesianPose.fromJSON(e)) : [],
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
      intrinsics: isSet(object.intrinsics) ? CameraIntrinsicsExtendedMsg.fromJSON(object.intrinsics) : undefined,
      mountType: isSet(object.mountType) ? globalThis.String(object.mountType) : "",
    };
  },

  toJSON(message: CalibrateCameraExtrinsicsRequest): unknown {
    const obj: any = {};
    if (message.images?.length) {
      obj.images = message.images.map((e) => base64FromBytes(e));
    }
    if (message.poses?.length) {
      obj.poses = message.poses.map((e) => CartesianPose.toJSON(e));
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    if (message.intrinsics !== undefined) {
      obj.intrinsics = CameraIntrinsicsExtendedMsg.toJSON(message.intrinsics);
    }
    if (message.mountType !== "") {
      obj.mountType = message.mountType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraExtrinsicsRequest>, I>>(
    base?: I,
  ): CalibrateCameraExtrinsicsRequest {
    return CalibrateCameraExtrinsicsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraExtrinsicsRequest>, I>>(
    object: I,
  ): CalibrateCameraExtrinsicsRequest {
    const message = createBaseCalibrateCameraExtrinsicsRequest();
    message.images = object.images?.map((e) => e) || [];
    message.poses = object.poses?.map((e) => CartesianPose.fromPartial(e)) || [];
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    message.intrinsics = (object.intrinsics !== undefined && object.intrinsics !== null)
      ? CameraIntrinsicsExtendedMsg.fromPartial(object.intrinsics)
      : undefined;
    message.mountType = object.mountType ?? "";
    return message;
  },
};

function createBaseCalibrateCameraExtrinsicsResponse(): CalibrateCameraExtrinsicsResponse {
  return { data: undefined, error: undefined };
}

export const CalibrateCameraExtrinsicsResponse: MessageFns<CalibrateCameraExtrinsicsResponse> = {
  encode(message: CalibrateCameraExtrinsicsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CartesianPose.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateCameraExtrinsicsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateCameraExtrinsicsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateCameraExtrinsicsResponse {
    return {
      data: isSet(object.data) ? CartesianPose.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CalibrateCameraExtrinsicsResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CartesianPose.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateCameraExtrinsicsResponse>, I>>(
    base?: I,
  ): CalibrateCameraExtrinsicsResponse {
    return CalibrateCameraExtrinsicsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateCameraExtrinsicsResponse>, I>>(
    object: I,
  ): CalibrateCameraExtrinsicsResponse {
    const message = createBaseCalibrateCameraExtrinsicsResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CartesianPose.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseAssessCalibrationCoverageRequest(): AssessCalibrationCoverageRequest {
  return { images: [], chessboard: undefined, calibrationType: "", poses: [], intrinsics: undefined };
}

export const AssessCalibrationCoverageRequest: MessageFns<AssessCalibrationCoverageRequest> = {
  encode(message: AssessCalibrationCoverageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.images) {
      writer.uint32(10).bytes(v!);
    }
    if (message.chessboard !== undefined) {
      Chessboard.encode(message.chessboard, writer.uint32(18).fork()).join();
    }
    if (message.calibrationType !== "") {
      writer.uint32(26).string(message.calibrationType);
    }
    for (const v of message.poses) {
      CartesianPose.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.intrinsics !== undefined) {
      CameraIntrinsicsExtendedMsg.encode(message.intrinsics, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssessCalibrationCoverageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssessCalibrationCoverageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.images.push(reader.bytes());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chessboard = Chessboard.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.calibrationType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.poses.push(CartesianPose.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.intrinsics = CameraIntrinsicsExtendedMsg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssessCalibrationCoverageRequest {
    return {
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => bytesFromBase64(e)) : [],
      chessboard: isSet(object.chessboard) ? Chessboard.fromJSON(object.chessboard) : undefined,
      calibrationType: isSet(object.calibrationType) ? globalThis.String(object.calibrationType) : "",
      poses: globalThis.Array.isArray(object?.poses) ? object.poses.map((e: any) => CartesianPose.fromJSON(e)) : [],
      intrinsics: isSet(object.intrinsics) ? CameraIntrinsicsExtendedMsg.fromJSON(object.intrinsics) : undefined,
    };
  },

  toJSON(message: AssessCalibrationCoverageRequest): unknown {
    const obj: any = {};
    if (message.images?.length) {
      obj.images = message.images.map((e) => base64FromBytes(e));
    }
    if (message.chessboard !== undefined) {
      obj.chessboard = Chessboard.toJSON(message.chessboard);
    }
    if (message.calibrationType !== "") {
      obj.calibrationType = message.calibrationType;
    }
    if (message.poses?.length) {
      obj.poses = message.poses.map((e) => CartesianPose.toJSON(e));
    }
    if (message.intrinsics !== undefined) {
      obj.intrinsics = CameraIntrinsicsExtendedMsg.toJSON(message.intrinsics);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessCalibrationCoverageRequest>, I>>(
    base?: I,
  ): AssessCalibrationCoverageRequest {
    return AssessCalibrationCoverageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessCalibrationCoverageRequest>, I>>(
    object: I,
  ): AssessCalibrationCoverageRequest {
    const message = createBaseAssessCalibrationCoverageRequest();
    message.images = object.images?.map((e) => e) || [];
    message.chessboard = (object.chessboard !== undefined && object.chessboard !== null)
      ? Chessboard.fromPartial(object.chessboard)
      : undefined;
    message.calibrationType = object.calibrationType ?? "";
    message.poses = object.poses?.map((e) => CartesianPose.fromPartial(e)) || [];
    message.intrinsics = (object.intrinsics !== undefined && object.intrinsics !== null)
      ? CameraIntrinsicsExtendedMsg.fromPartial(object.intrinsics)
      : undefined;
    return message;
  },
};

function createBaseCoverageBucketMsg(): CoverageBucketMsg {
  return { key: "", filled: false };
}

export const CoverageBucketMsg: MessageFns<CoverageBucketMsg> = {
  encode(message: CoverageBucketMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.filled !== false) {
      writer.uint32(16).bool(message.filled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoverageBucketMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoverageBucketMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.filled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CoverageBucketMsg {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      filled: isSet(object.filled) ? globalThis.Boolean(object.filled) : false,
    };
  },

  toJSON(message: CoverageBucketMsg): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.filled !== false) {
      obj.filled = message.filled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CoverageBucketMsg>, I>>(base?: I): CoverageBucketMsg {
    return CoverageBucketMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CoverageBucketMsg>, I>>(object: I): CoverageBucketMsg {
    const message = createBaseCoverageBucketMsg();
    message.key = object.key ?? "";
    message.filled = object.filled ?? false;
    return message;
  },
};

function createBaseQualityIssueMsg(): QualityIssueMsg {
  return { index: 0, issue: "" };
}

export const QualityIssueMsg: MessageFns<QualityIssueMsg> = {
  encode(message: QualityIssueMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).int32(message.index);
    }
    if (message.issue !== "") {
      writer.uint32(18).string(message.issue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QualityIssueMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQualityIssueMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.index = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.issue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QualityIssueMsg {
    return {
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      issue: isSet(object.issue) ? globalThis.String(object.issue) : "",
    };
  },

  toJSON(message: QualityIssueMsg): unknown {
    const obj: any = {};
    if (message.index !== 0) {
      obj.index = Math.round(message.index);
    }
    if (message.issue !== "") {
      obj.issue = message.issue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QualityIssueMsg>, I>>(base?: I): QualityIssueMsg {
    return QualityIssueMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QualityIssueMsg>, I>>(object: I): QualityIssueMsg {
    const message = createBaseQualityIssueMsg();
    message.index = object.index ?? 0;
    message.issue = object.issue ?? "";
    return message;
  },
};

function createBaseCalibrationRecommendationMsg(): CalibrationRecommendationMsg {
  return { kind: "", detail: "" };
}

export const CalibrationRecommendationMsg: MessageFns<CalibrationRecommendationMsg> = {
  encode(message: CalibrationRecommendationMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== "") {
      writer.uint32(10).string(message.kind);
    }
    if (message.detail !== "") {
      writer.uint32(18).string(message.detail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrationRecommendationMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrationRecommendationMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrationRecommendationMsg {
    return {
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
    };
  },

  toJSON(message: CalibrationRecommendationMsg): unknown {
    const obj: any = {};
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrationRecommendationMsg>, I>>(base?: I): CalibrationRecommendationMsg {
    return CalibrationRecommendationMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrationRecommendationMsg>, I>>(object: I): CalibrationRecommendationMsg {
    const message = createBaseCalibrationRecommendationMsg();
    message.kind = object.kind ?? "";
    message.detail = object.detail ?? "";
    return message;
  },
};

function createBaseCalibrationCoverageResultMsg(): CalibrationCoverageResultMsg {
  return {
    coverageBuckets: [],
    perViewErrors: [],
    reprojectionError: undefined,
    qualityIssues: [],
    converged: false,
    recommendation: undefined,
  };
}

export const CalibrationCoverageResultMsg: MessageFns<CalibrationCoverageResultMsg> = {
  encode(message: CalibrationCoverageResultMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.coverageBuckets) {
      CoverageBucketMsg.encode(v!, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.perViewErrors) {
      writer.double(v);
    }
    writer.join();
    if (message.reprojectionError !== undefined) {
      writer.uint32(25).double(message.reprojectionError);
    }
    for (const v of message.qualityIssues) {
      QualityIssueMsg.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.converged !== false) {
      writer.uint32(40).bool(message.converged);
    }
    if (message.recommendation !== undefined) {
      CalibrationRecommendationMsg.encode(message.recommendation, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrationCoverageResultMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrationCoverageResultMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.coverageBuckets.push(CoverageBucketMsg.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 17) {
            message.perViewErrors.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.perViewErrors.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.reprojectionError = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.qualityIssues.push(QualityIssueMsg.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.converged = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.recommendation = CalibrationRecommendationMsg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrationCoverageResultMsg {
    return {
      coverageBuckets: globalThis.Array.isArray(object?.coverageBuckets)
        ? object.coverageBuckets.map((e: any) => CoverageBucketMsg.fromJSON(e))
        : [],
      perViewErrors: globalThis.Array.isArray(object?.perViewErrors)
        ? object.perViewErrors.map((e: any) => globalThis.Number(e))
        : [],
      reprojectionError: isSet(object.reprojectionError) ? globalThis.Number(object.reprojectionError) : undefined,
      qualityIssues: globalThis.Array.isArray(object?.qualityIssues)
        ? object.qualityIssues.map((e: any) => QualityIssueMsg.fromJSON(e))
        : [],
      converged: isSet(object.converged) ? globalThis.Boolean(object.converged) : false,
      recommendation: isSet(object.recommendation)
        ? CalibrationRecommendationMsg.fromJSON(object.recommendation)
        : undefined,
    };
  },

  toJSON(message: CalibrationCoverageResultMsg): unknown {
    const obj: any = {};
    if (message.coverageBuckets?.length) {
      obj.coverageBuckets = message.coverageBuckets.map((e) => CoverageBucketMsg.toJSON(e));
    }
    if (message.perViewErrors?.length) {
      obj.perViewErrors = message.perViewErrors;
    }
    if (message.reprojectionError !== undefined) {
      obj.reprojectionError = message.reprojectionError;
    }
    if (message.qualityIssues?.length) {
      obj.qualityIssues = message.qualityIssues.map((e) => QualityIssueMsg.toJSON(e));
    }
    if (message.converged !== false) {
      obj.converged = message.converged;
    }
    if (message.recommendation !== undefined) {
      obj.recommendation = CalibrationRecommendationMsg.toJSON(message.recommendation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrationCoverageResultMsg>, I>>(base?: I): CalibrationCoverageResultMsg {
    return CalibrationCoverageResultMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrationCoverageResultMsg>, I>>(object: I): CalibrationCoverageResultMsg {
    const message = createBaseCalibrationCoverageResultMsg();
    message.coverageBuckets = object.coverageBuckets?.map((e) => CoverageBucketMsg.fromPartial(e)) || [];
    message.perViewErrors = object.perViewErrors?.map((e) => e) || [];
    message.reprojectionError = object.reprojectionError ?? undefined;
    message.qualityIssues = object.qualityIssues?.map((e) => QualityIssueMsg.fromPartial(e)) || [];
    message.converged = object.converged ?? false;
    message.recommendation = (object.recommendation !== undefined && object.recommendation !== null)
      ? CalibrationRecommendationMsg.fromPartial(object.recommendation)
      : undefined;
    return message;
  },
};

function createBaseAssessCalibrationCoverageResponse(): AssessCalibrationCoverageResponse {
  return { data: undefined, error: undefined };
}

export const AssessCalibrationCoverageResponse: MessageFns<AssessCalibrationCoverageResponse> = {
  encode(message: AssessCalibrationCoverageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CalibrationCoverageResultMsg.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssessCalibrationCoverageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssessCalibrationCoverageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CalibrationCoverageResultMsg.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssessCalibrationCoverageResponse {
    return {
      data: isSet(object.data) ? CalibrationCoverageResultMsg.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: AssessCalibrationCoverageResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CalibrationCoverageResultMsg.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessCalibrationCoverageResponse>, I>>(
    base?: I,
  ): AssessCalibrationCoverageResponse {
    return AssessCalibrationCoverageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessCalibrationCoverageResponse>, I>>(
    object: I,
  ): AssessCalibrationCoverageResponse {
    const message = createBaseAssessCalibrationCoverageResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CalibrationCoverageResultMsg.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBasePrimitiveShape(): PrimitiveShape {
  return { shapeType: 0, dimX: 0, dimY: 0, dimZ: 0 };
}

export const PrimitiveShape: MessageFns<PrimitiveShape> = {
  encode(message: PrimitiveShape, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shapeType !== 0) {
      writer.uint32(8).int32(message.shapeType);
    }
    if (message.dimX !== 0) {
      writer.uint32(21).float(message.dimX);
    }
    if (message.dimY !== 0) {
      writer.uint32(29).float(message.dimY);
    }
    if (message.dimZ !== 0) {
      writer.uint32(37).float(message.dimZ);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrimitiveShape {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimitiveShape();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.shapeType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.dimX = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.dimY = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.dimZ = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrimitiveShape {
    return {
      shapeType: isSet(object.shapeType) ? primitiveShapeTypeFromJSON(object.shapeType) : 0,
      dimX: isSet(object.dimX) ? globalThis.Number(object.dimX) : 0,
      dimY: isSet(object.dimY) ? globalThis.Number(object.dimY) : 0,
      dimZ: isSet(object.dimZ) ? globalThis.Number(object.dimZ) : 0,
    };
  },

  toJSON(message: PrimitiveShape): unknown {
    const obj: any = {};
    if (message.shapeType !== 0) {
      obj.shapeType = primitiveShapeTypeToJSON(message.shapeType);
    }
    if (message.dimX !== 0) {
      obj.dimX = message.dimX;
    }
    if (message.dimY !== 0) {
      obj.dimY = message.dimY;
    }
    if (message.dimZ !== 0) {
      obj.dimZ = message.dimZ;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrimitiveShape>, I>>(base?: I): PrimitiveShape {
    return PrimitiveShape.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrimitiveShape>, I>>(object: I): PrimitiveShape {
    const message = createBasePrimitiveShape();
    message.shapeType = object.shapeType ?? 0;
    message.dimX = object.dimX ?? 0;
    message.dimY = object.dimY ?? 0;
    message.dimZ = object.dimZ ?? 0;
    return message;
  },
};

function createBaseCadModelFile(): CadModelFile {
  return { data: new Uint8Array(0), format: "", contentHash: "", units: 0 };
}

export const CadModelFile: MessageFns<CadModelFile> = {
  encode(message: CadModelFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.format !== "") {
      writer.uint32(18).string(message.format);
    }
    if (message.contentHash !== "") {
      writer.uint32(26).string(message.contentHash);
    }
    if (message.units !== 0) {
      writer.uint32(32).int32(message.units);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CadModelFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCadModelFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.format = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contentHash = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.units = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CadModelFile {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      format: isSet(object.format) ? globalThis.String(object.format) : "",
      contentHash: isSet(object.contentHash) ? globalThis.String(object.contentHash) : "",
      units: isSet(object.units) ? cadModelUnitsFromJSON(object.units) : 0,
    };
  },

  toJSON(message: CadModelFile): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.format !== "") {
      obj.format = message.format;
    }
    if (message.contentHash !== "") {
      obj.contentHash = message.contentHash;
    }
    if (message.units !== 0) {
      obj.units = cadModelUnitsToJSON(message.units);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CadModelFile>, I>>(base?: I): CadModelFile {
    return CadModelFile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CadModelFile>, I>>(object: I): CadModelFile {
    const message = createBaseCadModelFile();
    message.data = object.data ?? new Uint8Array(0);
    message.format = object.format ?? "";
    message.contentHash = object.contentHash ?? "";
    message.units = object.units ?? 0;
    return message;
  },
};

function createBaseObjectReference(): ObjectReference {
  return {
    textPrompt: undefined,
    cadModelPath: undefined,
    referenceImages: undefined,
    primitiveShape: undefined,
    cadModelFile: undefined,
  };
}

export const ObjectReference: MessageFns<ObjectReference> = {
  encode(message: ObjectReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.textPrompt !== undefined) {
      writer.uint32(10).string(message.textPrompt);
    }
    if (message.cadModelPath !== undefined) {
      writer.uint32(18).string(message.cadModelPath);
    }
    if (message.referenceImages !== undefined) {
      ReferenceImageSet.encode(message.referenceImages, writer.uint32(26).fork()).join();
    }
    if (message.primitiveShape !== undefined) {
      PrimitiveShape.encode(message.primitiveShape, writer.uint32(34).fork()).join();
    }
    if (message.cadModelFile !== undefined) {
      CadModelFile.encode(message.cadModelFile, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectReference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.textPrompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cadModelPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.referenceImages = ReferenceImageSet.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.primitiveShape = PrimitiveShape.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cadModelFile = CadModelFile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectReference {
    return {
      textPrompt: isSet(object.textPrompt) ? globalThis.String(object.textPrompt) : undefined,
      cadModelPath: isSet(object.cadModelPath) ? globalThis.String(object.cadModelPath) : undefined,
      referenceImages: isSet(object.referenceImages) ? ReferenceImageSet.fromJSON(object.referenceImages) : undefined,
      primitiveShape: isSet(object.primitiveShape) ? PrimitiveShape.fromJSON(object.primitiveShape) : undefined,
      cadModelFile: isSet(object.cadModelFile) ? CadModelFile.fromJSON(object.cadModelFile) : undefined,
    };
  },

  toJSON(message: ObjectReference): unknown {
    const obj: any = {};
    if (message.textPrompt !== undefined) {
      obj.textPrompt = message.textPrompt;
    }
    if (message.cadModelPath !== undefined) {
      obj.cadModelPath = message.cadModelPath;
    }
    if (message.referenceImages !== undefined) {
      obj.referenceImages = ReferenceImageSet.toJSON(message.referenceImages);
    }
    if (message.primitiveShape !== undefined) {
      obj.primitiveShape = PrimitiveShape.toJSON(message.primitiveShape);
    }
    if (message.cadModelFile !== undefined) {
      obj.cadModelFile = CadModelFile.toJSON(message.cadModelFile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectReference>, I>>(base?: I): ObjectReference {
    return ObjectReference.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectReference>, I>>(object: I): ObjectReference {
    const message = createBaseObjectReference();
    message.textPrompt = object.textPrompt ?? undefined;
    message.cadModelPath = object.cadModelPath ?? undefined;
    message.referenceImages = (object.referenceImages !== undefined && object.referenceImages !== null)
      ? ReferenceImageSet.fromPartial(object.referenceImages)
      : undefined;
    message.primitiveShape = (object.primitiveShape !== undefined && object.primitiveShape !== null)
      ? PrimitiveShape.fromPartial(object.primitiveShape)
      : undefined;
    message.cadModelFile = (object.cadModelFile !== undefined && object.cadModelFile !== null)
      ? CadModelFile.fromPartial(object.cadModelFile)
      : undefined;
    return message;
  },
};

function createBaseReferenceImageSet(): ReferenceImageSet {
  return { rgbImages: [], depthImages: [], cameraPoses: [] };
}

export const ReferenceImageSet: MessageFns<ReferenceImageSet> = {
  encode(message: ReferenceImageSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rgbImages) {
      writer.uint32(10).bytes(v!);
    }
    for (const v of message.depthImages) {
      writer.uint32(18).bytes(v!);
    }
    for (const v of message.cameraPoses) {
      CartesianPose.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReferenceImageSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferenceImageSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rgbImages.push(reader.bytes());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.depthImages.push(reader.bytes());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cameraPoses.push(CartesianPose.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReferenceImageSet {
    return {
      rgbImages: globalThis.Array.isArray(object?.rgbImages)
        ? object.rgbImages.map((e: any) => bytesFromBase64(e))
        : [],
      depthImages: globalThis.Array.isArray(object?.depthImages)
        ? object.depthImages.map((e: any) => bytesFromBase64(e))
        : [],
      cameraPoses: globalThis.Array.isArray(object?.cameraPoses)
        ? object.cameraPoses.map((e: any) => CartesianPose.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ReferenceImageSet): unknown {
    const obj: any = {};
    if (message.rgbImages?.length) {
      obj.rgbImages = message.rgbImages.map((e) => base64FromBytes(e));
    }
    if (message.depthImages?.length) {
      obj.depthImages = message.depthImages.map((e) => base64FromBytes(e));
    }
    if (message.cameraPoses?.length) {
      obj.cameraPoses = message.cameraPoses.map((e) => CartesianPose.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReferenceImageSet>, I>>(base?: I): ReferenceImageSet {
    return ReferenceImageSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReferenceImageSet>, I>>(object: I): ReferenceImageSet {
    const message = createBaseReferenceImageSet();
    message.rgbImages = object.rgbImages?.map((e) => e) || [];
    message.depthImages = object.depthImages?.map((e) => e) || [];
    message.cameraPoses = object.cameraPoses?.map((e) => CartesianPose.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRun3DPoseEstimationRequest(): Run3DPoseEstimationRequest {
  return {
    detections: [],
    depthImage: new Uint8Array(0),
    cameraParams: undefined,
    poseMethod: 0,
    objectReference: undefined,
    confidenceThreshold: undefined,
    maxDetections: undefined,
    includeDebugVisualization: undefined,
    depthOutlierPercentile: undefined,
    ransacRestarts: undefined,
    voxelSize: undefined,
  };
}

export const Run3DPoseEstimationRequest: MessageFns<Run3DPoseEstimationRequest> = {
  encode(message: Run3DPoseEstimationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.detections) {
      LocateMatch.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.depthImage.length !== 0) {
      writer.uint32(18).bytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      CameraParams.encode(message.cameraParams, writer.uint32(26).fork()).join();
    }
    if (message.poseMethod !== 0) {
      writer.uint32(32).int32(message.poseMethod);
    }
    if (message.objectReference !== undefined) {
      ObjectReference.encode(message.objectReference, writer.uint32(42).fork()).join();
    }
    if (message.confidenceThreshold !== undefined) {
      writer.uint32(53).float(message.confidenceThreshold);
    }
    if (message.maxDetections !== undefined) {
      writer.uint32(56).int32(message.maxDetections);
    }
    if (message.includeDebugVisualization !== undefined) {
      writer.uint32(64).bool(message.includeDebugVisualization);
    }
    if (message.depthOutlierPercentile !== undefined) {
      writer.uint32(77).float(message.depthOutlierPercentile);
    }
    if (message.ransacRestarts !== undefined) {
      writer.uint32(80).int32(message.ransacRestarts);
    }
    if (message.voxelSize !== undefined) {
      writer.uint32(93).float(message.voxelSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Run3DPoseEstimationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRun3DPoseEstimationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detections.push(LocateMatch.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.depthImage = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cameraParams = CameraParams.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.poseMethod = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.objectReference = ObjectReference.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.confidenceThreshold = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxDetections = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.includeDebugVisualization = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.depthOutlierPercentile = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ransacRestarts = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.voxelSize = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Run3DPoseEstimationRequest {
    return {
      detections: globalThis.Array.isArray(object?.detections)
        ? object.detections.map((e: any) => LocateMatch.fromJSON(e))
        : [],
      depthImage: isSet(object.depthImage) ? bytesFromBase64(object.depthImage) : new Uint8Array(0),
      cameraParams: isSet(object.cameraParams) ? CameraParams.fromJSON(object.cameraParams) : undefined,
      poseMethod: isSet(object.poseMethod) ? poseEstimationMethodFromJSON(object.poseMethod) : 0,
      objectReference: isSet(object.objectReference) ? ObjectReference.fromJSON(object.objectReference) : undefined,
      confidenceThreshold: isSet(object.confidenceThreshold)
        ? globalThis.Number(object.confidenceThreshold)
        : undefined,
      maxDetections: isSet(object.maxDetections) ? globalThis.Number(object.maxDetections) : undefined,
      includeDebugVisualization: isSet(object.includeDebugVisualization)
        ? globalThis.Boolean(object.includeDebugVisualization)
        : undefined,
      depthOutlierPercentile: isSet(object.depthOutlierPercentile)
        ? globalThis.Number(object.depthOutlierPercentile)
        : undefined,
      ransacRestarts: isSet(object.ransacRestarts) ? globalThis.Number(object.ransacRestarts) : undefined,
      voxelSize: isSet(object.voxelSize) ? globalThis.Number(object.voxelSize) : undefined,
    };
  },

  toJSON(message: Run3DPoseEstimationRequest): unknown {
    const obj: any = {};
    if (message.detections?.length) {
      obj.detections = message.detections.map((e) => LocateMatch.toJSON(e));
    }
    if (message.depthImage.length !== 0) {
      obj.depthImage = base64FromBytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      obj.cameraParams = CameraParams.toJSON(message.cameraParams);
    }
    if (message.poseMethod !== 0) {
      obj.poseMethod = poseEstimationMethodToJSON(message.poseMethod);
    }
    if (message.objectReference !== undefined) {
      obj.objectReference = ObjectReference.toJSON(message.objectReference);
    }
    if (message.confidenceThreshold !== undefined) {
      obj.confidenceThreshold = message.confidenceThreshold;
    }
    if (message.maxDetections !== undefined) {
      obj.maxDetections = Math.round(message.maxDetections);
    }
    if (message.includeDebugVisualization !== undefined) {
      obj.includeDebugVisualization = message.includeDebugVisualization;
    }
    if (message.depthOutlierPercentile !== undefined) {
      obj.depthOutlierPercentile = message.depthOutlierPercentile;
    }
    if (message.ransacRestarts !== undefined) {
      obj.ransacRestarts = Math.round(message.ransacRestarts);
    }
    if (message.voxelSize !== undefined) {
      obj.voxelSize = message.voxelSize;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Run3DPoseEstimationRequest>, I>>(base?: I): Run3DPoseEstimationRequest {
    return Run3DPoseEstimationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Run3DPoseEstimationRequest>, I>>(object: I): Run3DPoseEstimationRequest {
    const message = createBaseRun3DPoseEstimationRequest();
    message.detections = object.detections?.map((e) => LocateMatch.fromPartial(e)) || [];
    message.depthImage = object.depthImage ?? new Uint8Array(0);
    message.cameraParams = (object.cameraParams !== undefined && object.cameraParams !== null)
      ? CameraParams.fromPartial(object.cameraParams)
      : undefined;
    message.poseMethod = object.poseMethod ?? 0;
    message.objectReference = (object.objectReference !== undefined && object.objectReference !== null)
      ? ObjectReference.fromPartial(object.objectReference)
      : undefined;
    message.confidenceThreshold = object.confidenceThreshold ?? undefined;
    message.maxDetections = object.maxDetections ?? undefined;
    message.includeDebugVisualization = object.includeDebugVisualization ?? undefined;
    message.depthOutlierPercentile = object.depthOutlierPercentile ?? undefined;
    message.ransacRestarts = object.ransacRestarts ?? undefined;
    message.voxelSize = object.voxelSize ?? undefined;
    return message;
  },
};

function createBaseRun3DPoseEstimationResponse(): Run3DPoseEstimationResponse {
  return { data: undefined, error: undefined };
}

export const Run3DPoseEstimationResponse: MessageFns<Run3DPoseEstimationResponse> = {
  encode(message: Run3DPoseEstimationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      PoseEstimation3DResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Run3DPoseEstimationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRun3DPoseEstimationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = PoseEstimation3DResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Run3DPoseEstimationResponse {
    return {
      data: isSet(object.data) ? PoseEstimation3DResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: Run3DPoseEstimationResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = PoseEstimation3DResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Run3DPoseEstimationResponse>, I>>(base?: I): Run3DPoseEstimationResponse {
    return Run3DPoseEstimationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Run3DPoseEstimationResponse>, I>>(object: I): Run3DPoseEstimationResponse {
    const message = createBaseRun3DPoseEstimationResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? PoseEstimation3DResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBasePoseEstimation3DResult(): PoseEstimation3DResult {
  return { detections: [], processingTimeMs: undefined, debugVisualization: undefined };
}

export const PoseEstimation3DResult: MessageFns<PoseEstimation3DResult> = {
  encode(message: PoseEstimation3DResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.detections) {
      Detection3D.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    if (message.debugVisualization !== undefined) {
      writer.uint32(26).bytes(message.debugVisualization);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoseEstimation3DResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoseEstimation3DResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detections.push(Detection3D.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.debugVisualization = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoseEstimation3DResult {
    return {
      detections: globalThis.Array.isArray(object?.detections)
        ? object.detections.map((e: any) => Detection3D.fromJSON(e))
        : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
      debugVisualization: isSet(object.debugVisualization) ? bytesFromBase64(object.debugVisualization) : undefined,
    };
  },

  toJSON(message: PoseEstimation3DResult): unknown {
    const obj: any = {};
    if (message.detections?.length) {
      obj.detections = message.detections.map((e) => Detection3D.toJSON(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    if (message.debugVisualization !== undefined) {
      obj.debugVisualization = base64FromBytes(message.debugVisualization);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoseEstimation3DResult>, I>>(base?: I): PoseEstimation3DResult {
    return PoseEstimation3DResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoseEstimation3DResult>, I>>(object: I): PoseEstimation3DResult {
    const message = createBasePoseEstimation3DResult();
    message.detections = object.detections?.map((e) => Detection3D.fromPartial(e)) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    message.debugVisualization = object.debugVisualization ?? undefined;
    return message;
  },
};

function createBaseComputeDinoEmbeddingsRequest(): ComputeDinoEmbeddingsRequest {
  return { image: new Uint8Array(0), modelVersion: "", precision: "", locateHead: undefined, omitTensor: false };
}

export const ComputeDinoEmbeddingsRequest: MessageFns<ComputeDinoEmbeddingsRequest> = {
  encode(message: ComputeDinoEmbeddingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.modelVersion !== "") {
      writer.uint32(18).string(message.modelVersion);
    }
    if (message.precision !== "") {
      writer.uint32(26).string(message.precision);
    }
    if (message.locateHead !== undefined) {
      LocateHeadProto.encode(message.locateHead, writer.uint32(34).fork()).join();
    }
    if (message.omitTensor !== false) {
      writer.uint32(40).bool(message.omitTensor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeDinoEmbeddingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeDinoEmbeddingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.precision = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.locateHead = LocateHeadProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.omitTensor = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeDinoEmbeddingsRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
      precision: isSet(object.precision) ? globalThis.String(object.precision) : "",
      locateHead: isSet(object.locateHead) ? LocateHeadProto.fromJSON(object.locateHead) : undefined,
      omitTensor: isSet(object.omitTensor) ? globalThis.Boolean(object.omitTensor) : false,
    };
  },

  toJSON(message: ComputeDinoEmbeddingsRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    if (message.precision !== "") {
      obj.precision = message.precision;
    }
    if (message.locateHead !== undefined) {
      obj.locateHead = LocateHeadProto.toJSON(message.locateHead);
    }
    if (message.omitTensor !== false) {
      obj.omitTensor = message.omitTensor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeDinoEmbeddingsRequest>, I>>(base?: I): ComputeDinoEmbeddingsRequest {
    return ComputeDinoEmbeddingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeDinoEmbeddingsRequest>, I>>(object: I): ComputeDinoEmbeddingsRequest {
    const message = createBaseComputeDinoEmbeddingsRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.modelVersion = object.modelVersion ?? "";
    message.precision = object.precision ?? "";
    message.locateHead = (object.locateHead !== undefined && object.locateHead !== null)
      ? LocateHeadProto.fromPartial(object.locateHead)
      : undefined;
    message.omitTensor = object.omitTensor ?? false;
    return message;
  },
};

function createBaseComputeDinoEmbeddingsResponse(): ComputeDinoEmbeddingsResponse {
  return { data: undefined, error: undefined };
}

export const ComputeDinoEmbeddingsResponse: MessageFns<ComputeDinoEmbeddingsResponse> = {
  encode(message: ComputeDinoEmbeddingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      DinoEmbeddingsTensor.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeDinoEmbeddingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeDinoEmbeddingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = DinoEmbeddingsTensor.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeDinoEmbeddingsResponse {
    return {
      data: isSet(object.data) ? DinoEmbeddingsTensor.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: ComputeDinoEmbeddingsResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = DinoEmbeddingsTensor.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeDinoEmbeddingsResponse>, I>>(base?: I): ComputeDinoEmbeddingsResponse {
    return ComputeDinoEmbeddingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeDinoEmbeddingsResponse>, I>>(
    object: I,
  ): ComputeDinoEmbeddingsResponse {
    const message = createBaseComputeDinoEmbeddingsResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? DinoEmbeddingsTensor.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseDinoEmbeddingsTensor(): DinoEmbeddingsTensor {
  return {
    gridH: 0,
    gridW: 0,
    embeddingDim: 0,
    values: new Uint8Array(0),
    modelVersion: "",
    inputH: 0,
    inputW: 0,
    paddingTop: 0,
    paddingLeft: 0,
    heatmapFp16: undefined,
  };
}

export const DinoEmbeddingsTensor: MessageFns<DinoEmbeddingsTensor> = {
  encode(message: DinoEmbeddingsTensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gridH !== 0) {
      writer.uint32(8).int32(message.gridH);
    }
    if (message.gridW !== 0) {
      writer.uint32(16).int32(message.gridW);
    }
    if (message.embeddingDim !== 0) {
      writer.uint32(24).int32(message.embeddingDim);
    }
    if (message.values.length !== 0) {
      writer.uint32(34).bytes(message.values);
    }
    if (message.modelVersion !== "") {
      writer.uint32(42).string(message.modelVersion);
    }
    if (message.inputH !== 0) {
      writer.uint32(48).int32(message.inputH);
    }
    if (message.inputW !== 0) {
      writer.uint32(56).int32(message.inputW);
    }
    if (message.paddingTop !== 0) {
      writer.uint32(64).int32(message.paddingTop);
    }
    if (message.paddingLeft !== 0) {
      writer.uint32(72).int32(message.paddingLeft);
    }
    if (message.heatmapFp16 !== undefined) {
      writer.uint32(82).bytes(message.heatmapFp16);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DinoEmbeddingsTensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDinoEmbeddingsTensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.gridH = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.gridW = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.embeddingDim = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.values = reader.bytes();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.inputH = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.inputW = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.paddingTop = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.paddingLeft = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.heatmapFp16 = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DinoEmbeddingsTensor {
    return {
      gridH: isSet(object.gridH) ? globalThis.Number(object.gridH) : 0,
      gridW: isSet(object.gridW) ? globalThis.Number(object.gridW) : 0,
      embeddingDim: isSet(object.embeddingDim) ? globalThis.Number(object.embeddingDim) : 0,
      values: isSet(object.values) ? bytesFromBase64(object.values) : new Uint8Array(0),
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
      inputH: isSet(object.inputH) ? globalThis.Number(object.inputH) : 0,
      inputW: isSet(object.inputW) ? globalThis.Number(object.inputW) : 0,
      paddingTop: isSet(object.paddingTop) ? globalThis.Number(object.paddingTop) : 0,
      paddingLeft: isSet(object.paddingLeft) ? globalThis.Number(object.paddingLeft) : 0,
      heatmapFp16: isSet(object.heatmapFp16) ? bytesFromBase64(object.heatmapFp16) : undefined,
    };
  },

  toJSON(message: DinoEmbeddingsTensor): unknown {
    const obj: any = {};
    if (message.gridH !== 0) {
      obj.gridH = Math.round(message.gridH);
    }
    if (message.gridW !== 0) {
      obj.gridW = Math.round(message.gridW);
    }
    if (message.embeddingDim !== 0) {
      obj.embeddingDim = Math.round(message.embeddingDim);
    }
    if (message.values.length !== 0) {
      obj.values = base64FromBytes(message.values);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    if (message.inputH !== 0) {
      obj.inputH = Math.round(message.inputH);
    }
    if (message.inputW !== 0) {
      obj.inputW = Math.round(message.inputW);
    }
    if (message.paddingTop !== 0) {
      obj.paddingTop = Math.round(message.paddingTop);
    }
    if (message.paddingLeft !== 0) {
      obj.paddingLeft = Math.round(message.paddingLeft);
    }
    if (message.heatmapFp16 !== undefined) {
      obj.heatmapFp16 = base64FromBytes(message.heatmapFp16);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DinoEmbeddingsTensor>, I>>(base?: I): DinoEmbeddingsTensor {
    return DinoEmbeddingsTensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DinoEmbeddingsTensor>, I>>(object: I): DinoEmbeddingsTensor {
    const message = createBaseDinoEmbeddingsTensor();
    message.gridH = object.gridH ?? 0;
    message.gridW = object.gridW ?? 0;
    message.embeddingDim = object.embeddingDim ?? 0;
    message.values = object.values ?? new Uint8Array(0);
    message.modelVersion = object.modelVersion ?? "";
    message.inputH = object.inputH ?? 0;
    message.inputW = object.inputW ?? 0;
    message.paddingTop = object.paddingTop ?? 0;
    message.paddingLeft = object.paddingLeft ?? 0;
    message.heatmapFp16 = object.heatmapFp16 ?? undefined;
    return message;
  },
};

function createBaseComputeDinoImageEmbeddingRequest(): ComputeDinoImageEmbeddingRequest {
  return { image: new Uint8Array(0), modelVersion: "", precision: "" };
}

export const ComputeDinoImageEmbeddingRequest: MessageFns<ComputeDinoImageEmbeddingRequest> = {
  encode(message: ComputeDinoImageEmbeddingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.modelVersion !== "") {
      writer.uint32(18).string(message.modelVersion);
    }
    if (message.precision !== "") {
      writer.uint32(26).string(message.precision);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeDinoImageEmbeddingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeDinoImageEmbeddingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.precision = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeDinoImageEmbeddingRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
      precision: isSet(object.precision) ? globalThis.String(object.precision) : "",
    };
  },

  toJSON(message: ComputeDinoImageEmbeddingRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    if (message.precision !== "") {
      obj.precision = message.precision;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeDinoImageEmbeddingRequest>, I>>(
    base?: I,
  ): ComputeDinoImageEmbeddingRequest {
    return ComputeDinoImageEmbeddingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeDinoImageEmbeddingRequest>, I>>(
    object: I,
  ): ComputeDinoImageEmbeddingRequest {
    const message = createBaseComputeDinoImageEmbeddingRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.modelVersion = object.modelVersion ?? "";
    message.precision = object.precision ?? "";
    return message;
  },
};

function createBaseComputeDinoImageEmbeddingResponse(): ComputeDinoImageEmbeddingResponse {
  return { data: undefined, error: undefined };
}

export const ComputeDinoImageEmbeddingResponse: MessageFns<ComputeDinoImageEmbeddingResponse> = {
  encode(message: ComputeDinoImageEmbeddingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      DinoImageEmbedding.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComputeDinoImageEmbeddingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComputeDinoImageEmbeddingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = DinoImageEmbedding.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComputeDinoImageEmbeddingResponse {
    return {
      data: isSet(object.data) ? DinoImageEmbedding.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: ComputeDinoImageEmbeddingResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = DinoImageEmbedding.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComputeDinoImageEmbeddingResponse>, I>>(
    base?: I,
  ): ComputeDinoImageEmbeddingResponse {
    return ComputeDinoImageEmbeddingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComputeDinoImageEmbeddingResponse>, I>>(
    object: I,
  ): ComputeDinoImageEmbeddingResponse {
    const message = createBaseComputeDinoImageEmbeddingResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? DinoImageEmbedding.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseDinoImageEmbedding(): DinoImageEmbedding {
  return { embeddingDim: 0, values: new Uint8Array(0), modelVersion: "" };
}

export const DinoImageEmbedding: MessageFns<DinoImageEmbedding> = {
  encode(message: DinoImageEmbedding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.embeddingDim !== 0) {
      writer.uint32(8).int32(message.embeddingDim);
    }
    if (message.values.length !== 0) {
      writer.uint32(18).bytes(message.values);
    }
    if (message.modelVersion !== "") {
      writer.uint32(26).string(message.modelVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DinoImageEmbedding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDinoImageEmbedding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.embeddingDim = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.values = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DinoImageEmbedding {
    return {
      embeddingDim: isSet(object.embeddingDim) ? globalThis.Number(object.embeddingDim) : 0,
      values: isSet(object.values) ? bytesFromBase64(object.values) : new Uint8Array(0),
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
    };
  },

  toJSON(message: DinoImageEmbedding): unknown {
    const obj: any = {};
    if (message.embeddingDim !== 0) {
      obj.embeddingDim = Math.round(message.embeddingDim);
    }
    if (message.values.length !== 0) {
      obj.values = base64FromBytes(message.values);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DinoImageEmbedding>, I>>(base?: I): DinoImageEmbedding {
    return DinoImageEmbedding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DinoImageEmbedding>, I>>(object: I): DinoImageEmbedding {
    const message = createBaseDinoImageEmbedding();
    message.embeddingDim = object.embeddingDim ?? 0;
    message.values = object.values ?? new Uint8Array(0);
    message.modelVersion = object.modelVersion ?? "";
    return message;
  },
};

function createBasePointPrompt(): PointPrompt {
  return { x: 0, y: 0, positive: false };
}

export const PointPrompt: MessageFns<PointPrompt> = {
  encode(message: PointPrompt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(13).float(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(21).float(message.y);
    }
    if (message.positive !== false) {
      writer.uint32(24).bool(message.positive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointPrompt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointPrompt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.positive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointPrompt {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      positive: isSet(object.positive) ? globalThis.Boolean(object.positive) : false,
    };
  },

  toJSON(message: PointPrompt): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.positive !== false) {
      obj.positive = message.positive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointPrompt>, I>>(base?: I): PointPrompt {
    return PointPrompt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointPrompt>, I>>(object: I): PointPrompt {
    const message = createBasePointPrompt();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.positive = object.positive ?? false;
    return message;
  },
};

function createBaseBox2DXyxy(): Box2DXyxy {
  return { x1: 0, y1: 0, x2: 0, y2: 0, points: [] };
}

export const Box2DXyxy: MessageFns<Box2DXyxy> = {
  encode(message: Box2DXyxy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x1 !== 0) {
      writer.uint32(13).float(message.x1);
    }
    if (message.y1 !== 0) {
      writer.uint32(21).float(message.y1);
    }
    if (message.x2 !== 0) {
      writer.uint32(29).float(message.x2);
    }
    if (message.y2 !== 0) {
      writer.uint32(37).float(message.y2);
    }
    for (const v of message.points) {
      PointPrompt.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Box2DXyxy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBox2DXyxy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x1 = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y1 = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.x2 = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.y2 = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.points.push(PointPrompt.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Box2DXyxy {
    return {
      x1: isSet(object.x1) ? globalThis.Number(object.x1) : 0,
      y1: isSet(object.y1) ? globalThis.Number(object.y1) : 0,
      x2: isSet(object.x2) ? globalThis.Number(object.x2) : 0,
      y2: isSet(object.y2) ? globalThis.Number(object.y2) : 0,
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => PointPrompt.fromJSON(e)) : [],
    };
  },

  toJSON(message: Box2DXyxy): unknown {
    const obj: any = {};
    if (message.x1 !== 0) {
      obj.x1 = message.x1;
    }
    if (message.y1 !== 0) {
      obj.y1 = message.y1;
    }
    if (message.x2 !== 0) {
      obj.x2 = message.x2;
    }
    if (message.y2 !== 0) {
      obj.y2 = message.y2;
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => PointPrompt.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Box2DXyxy>, I>>(base?: I): Box2DXyxy {
    return Box2DXyxy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Box2DXyxy>, I>>(object: I): Box2DXyxy {
    const message = createBaseBox2DXyxy();
    message.x1 = object.x1 ?? 0;
    message.y1 = object.y1 ?? 0;
    message.x2 = object.x2 ?? 0;
    message.y2 = object.y2 ?? 0;
    message.points = object.points?.map((e) => PointPrompt.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHeatmapSample(): HeatmapSample {
  return { x: 0, y: 0, score: 0 };
}

export const HeatmapSample: MessageFns<HeatmapSample> = {
  encode(message: HeatmapSample, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(13).float(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(21).float(message.y);
    }
    if (message.score !== 0) {
      writer.uint32(29).float(message.score);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HeatmapSample {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapSample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.score = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HeatmapSample {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
    };
  },

  toJSON(message: HeatmapSample): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.score !== 0) {
      obj.score = message.score;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HeatmapSample>, I>>(base?: I): HeatmapSample {
    return HeatmapSample.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapSample>, I>>(object: I): HeatmapSample {
    const message = createBaseHeatmapSample();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.score = object.score ?? 0;
    return message;
  },
};

function createBaseSegmentMaskRequest(): SegmentMaskRequest {
  return {
    image: new Uint8Array(0),
    boxes: [],
    heatmapSamples: [],
    heatmapThreshold: 0,
    method: 0,
    heatmapDense: new Uint8Array(0),
    heatmapWidth: undefined,
    heatmapHeight: undefined,
  };
}

export const SegmentMaskRequest: MessageFns<SegmentMaskRequest> = {
  encode(message: SegmentMaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    for (const v of message.boxes) {
      Box2DXyxy.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.heatmapSamples) {
      HeatmapSample.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.heatmapThreshold !== 0) {
      writer.uint32(37).float(message.heatmapThreshold);
    }
    if (message.method !== 0) {
      writer.uint32(40).int32(message.method);
    }
    if (message.heatmapDense.length !== 0) {
      writer.uint32(50).bytes(message.heatmapDense);
    }
    if (message.heatmapWidth !== undefined) {
      writer.uint32(56).int32(message.heatmapWidth);
    }
    if (message.heatmapHeight !== undefined) {
      writer.uint32(64).int32(message.heatmapHeight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SegmentMaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSegmentMaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.boxes.push(Box2DXyxy.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.heatmapSamples.push(HeatmapSample.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.heatmapThreshold = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.method = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.heatmapDense = reader.bytes();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.heatmapWidth = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.heatmapHeight = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SegmentMaskRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      boxes: globalThis.Array.isArray(object?.boxes) ? object.boxes.map((e: any) => Box2DXyxy.fromJSON(e)) : [],
      heatmapSamples: globalThis.Array.isArray(object?.heatmapSamples)
        ? object.heatmapSamples.map((e: any) => HeatmapSample.fromJSON(e))
        : [],
      heatmapThreshold: isSet(object.heatmapThreshold) ? globalThis.Number(object.heatmapThreshold) : 0,
      method: isSet(object.method) ? segmentationMethodFromJSON(object.method) : 0,
      heatmapDense: isSet(object.heatmapDense) ? bytesFromBase64(object.heatmapDense) : new Uint8Array(0),
      heatmapWidth: isSet(object.heatmapWidth) ? globalThis.Number(object.heatmapWidth) : undefined,
      heatmapHeight: isSet(object.heatmapHeight) ? globalThis.Number(object.heatmapHeight) : undefined,
    };
  },

  toJSON(message: SegmentMaskRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.boxes?.length) {
      obj.boxes = message.boxes.map((e) => Box2DXyxy.toJSON(e));
    }
    if (message.heatmapSamples?.length) {
      obj.heatmapSamples = message.heatmapSamples.map((e) => HeatmapSample.toJSON(e));
    }
    if (message.heatmapThreshold !== 0) {
      obj.heatmapThreshold = message.heatmapThreshold;
    }
    if (message.method !== 0) {
      obj.method = segmentationMethodToJSON(message.method);
    }
    if (message.heatmapDense.length !== 0) {
      obj.heatmapDense = base64FromBytes(message.heatmapDense);
    }
    if (message.heatmapWidth !== undefined) {
      obj.heatmapWidth = Math.round(message.heatmapWidth);
    }
    if (message.heatmapHeight !== undefined) {
      obj.heatmapHeight = Math.round(message.heatmapHeight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SegmentMaskRequest>, I>>(base?: I): SegmentMaskRequest {
    return SegmentMaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SegmentMaskRequest>, I>>(object: I): SegmentMaskRequest {
    const message = createBaseSegmentMaskRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.boxes = object.boxes?.map((e) => Box2DXyxy.fromPartial(e)) || [];
    message.heatmapSamples = object.heatmapSamples?.map((e) => HeatmapSample.fromPartial(e)) || [];
    message.heatmapThreshold = object.heatmapThreshold ?? 0;
    message.method = object.method ?? 0;
    message.heatmapDense = object.heatmapDense ?? new Uint8Array(0);
    message.heatmapWidth = object.heatmapWidth ?? undefined;
    message.heatmapHeight = object.heatmapHeight ?? undefined;
    return message;
  },
};

function createBaseSegmentMaskResponse(): SegmentMaskResponse {
  return { data: undefined, error: undefined };
}

export const SegmentMaskResponse: MessageFns<SegmentMaskResponse> = {
  encode(message: SegmentMaskResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      MaskSegmentationResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SegmentMaskResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSegmentMaskResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = MaskSegmentationResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SegmentMaskResponse {
    return {
      data: isSet(object.data) ? MaskSegmentationResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: SegmentMaskResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = MaskSegmentationResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SegmentMaskResponse>, I>>(base?: I): SegmentMaskResponse {
    return SegmentMaskResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SegmentMaskResponse>, I>>(object: I): SegmentMaskResponse {
    const message = createBaseSegmentMaskResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? MaskSegmentationResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseMaskSegmentationResult(): MaskSegmentationResult {
  return { blobs: [], wasSegmented: [], processingTimeMs: undefined };
}

export const MaskSegmentationResult: MessageFns<MaskSegmentationResult> = {
  encode(message: MaskSegmentationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blobs) {
      Blob2D.encode(v!, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.wasSegmented) {
      writer.bool(v);
    }
    writer.join();
    if (message.processingTimeMs !== undefined) {
      writer.uint32(24).int32(message.processingTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MaskSegmentationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaskSegmentationResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blobs.push(Blob2D.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.wasSegmented.push(reader.bool());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.wasSegmented.push(reader.bool());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MaskSegmentationResult {
    return {
      blobs: globalThis.Array.isArray(object?.blobs) ? object.blobs.map((e: any) => Blob2D.fromJSON(e)) : [],
      wasSegmented: globalThis.Array.isArray(object?.wasSegmented)
        ? object.wasSegmented.map((e: any) => globalThis.Boolean(e))
        : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
    };
  },

  toJSON(message: MaskSegmentationResult): unknown {
    const obj: any = {};
    if (message.blobs?.length) {
      obj.blobs = message.blobs.map((e) => Blob2D.toJSON(e));
    }
    if (message.wasSegmented?.length) {
      obj.wasSegmented = message.wasSegmented;
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MaskSegmentationResult>, I>>(base?: I): MaskSegmentationResult {
    return MaskSegmentationResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MaskSegmentationResult>, I>>(object: I): MaskSegmentationResult {
    const message = createBaseMaskSegmentationResult();
    message.blobs = object.blobs?.map((e) => Blob2D.fromPartial(e)) || [];
    message.wasSegmented = object.wasSegmented?.map((e) => e) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    return message;
  },
};

function createBaseLocateClick(): LocateClick {
  return { nx: 0, ny: 0, positive: false };
}

export const LocateClick: MessageFns<LocateClick> = {
  encode(message: LocateClick, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nx !== 0) {
      writer.uint32(13).float(message.nx);
    }
    if (message.ny !== 0) {
      writer.uint32(21).float(message.ny);
    }
    if (message.positive !== false) {
      writer.uint32(24).bool(message.positive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocateClick {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocateClick();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.nx = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.ny = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.positive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocateClick {
    return {
      nx: isSet(object.nx) ? globalThis.Number(object.nx) : 0,
      ny: isSet(object.ny) ? globalThis.Number(object.ny) : 0,
      positive: isSet(object.positive) ? globalThis.Boolean(object.positive) : false,
    };
  },

  toJSON(message: LocateClick): unknown {
    const obj: any = {};
    if (message.nx !== 0) {
      obj.nx = message.nx;
    }
    if (message.ny !== 0) {
      obj.ny = message.ny;
    }
    if (message.positive !== false) {
      obj.positive = message.positive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocateClick>, I>>(base?: I): LocateClick {
    return LocateClick.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocateClick>, I>>(object: I): LocateClick {
    const message = createBaseLocateClick();
    message.nx = object.nx ?? 0;
    message.ny = object.ny ?? 0;
    message.positive = object.positive ?? false;
    return message;
  },
};

function createBaseReferenceVector(): ReferenceVector {
  return { values: [] };
}

export const ReferenceVector: MessageFns<ReferenceVector> = {
  encode(message: ReferenceVector, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.values) {
      writer.float(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReferenceVector {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferenceVector();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 13) {
            message.values.push(reader.float());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.float());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReferenceVector {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: ReferenceVector): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReferenceVector>, I>>(base?: I): ReferenceVector {
    return ReferenceVector.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReferenceVector>, I>>(object: I): ReferenceVector {
    const message = createBaseReferenceVector();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseMlpLocateHeadProto(): MlpLocateHeadProto {
  return { inputDim: 0, hidden: 0, w1: [], b1: [], w2: [], b2: 0 };
}

export const MlpLocateHeadProto: MessageFns<MlpLocateHeadProto> = {
  encode(message: MlpLocateHeadProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inputDim !== 0) {
      writer.uint32(8).int32(message.inputDim);
    }
    if (message.hidden !== 0) {
      writer.uint32(16).int32(message.hidden);
    }
    writer.uint32(26).fork();
    for (const v of message.w1) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.b1) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.w2) {
      writer.float(v);
    }
    writer.join();
    if (message.b2 !== 0) {
      writer.uint32(53).float(message.b2);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MlpLocateHeadProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMlpLocateHeadProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.inputDim = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hidden = reader.int32();
          continue;
        }
        case 3: {
          if (tag === 29) {
            message.w1.push(reader.float());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.w1.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 37) {
            message.b1.push(reader.float());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.b1.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 45) {
            message.w2.push(reader.float());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.w2.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.b2 = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MlpLocateHeadProto {
    return {
      inputDim: isSet(object.inputDim) ? globalThis.Number(object.inputDim) : 0,
      hidden: isSet(object.hidden) ? globalThis.Number(object.hidden) : 0,
      w1: globalThis.Array.isArray(object?.w1) ? object.w1.map((e: any) => globalThis.Number(e)) : [],
      b1: globalThis.Array.isArray(object?.b1) ? object.b1.map((e: any) => globalThis.Number(e)) : [],
      w2: globalThis.Array.isArray(object?.w2) ? object.w2.map((e: any) => globalThis.Number(e)) : [],
      b2: isSet(object.b2) ? globalThis.Number(object.b2) : 0,
    };
  },

  toJSON(message: MlpLocateHeadProto): unknown {
    const obj: any = {};
    if (message.inputDim !== 0) {
      obj.inputDim = Math.round(message.inputDim);
    }
    if (message.hidden !== 0) {
      obj.hidden = Math.round(message.hidden);
    }
    if (message.w1?.length) {
      obj.w1 = message.w1;
    }
    if (message.b1?.length) {
      obj.b1 = message.b1;
    }
    if (message.w2?.length) {
      obj.w2 = message.w2;
    }
    if (message.b2 !== 0) {
      obj.b2 = message.b2;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MlpLocateHeadProto>, I>>(base?: I): MlpLocateHeadProto {
    return MlpLocateHeadProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MlpLocateHeadProto>, I>>(object: I): MlpLocateHeadProto {
    const message = createBaseMlpLocateHeadProto();
    message.inputDim = object.inputDim ?? 0;
    message.hidden = object.hidden ?? 0;
    message.w1 = object.w1?.map((e) => e) || [];
    message.b1 = object.b1?.map((e) => e) || [];
    message.w2 = object.w2?.map((e) => e) || [];
    message.b2 = object.b2 ?? 0;
    return message;
  },
};

function createBaseLogisticLocateHeadProto(): LogisticLocateHeadProto {
  return { inputDim: 0, w: [], b: 0 };
}

export const LogisticLocateHeadProto: MessageFns<LogisticLocateHeadProto> = {
  encode(message: LogisticLocateHeadProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inputDim !== 0) {
      writer.uint32(8).int32(message.inputDim);
    }
    writer.uint32(18).fork();
    for (const v of message.w) {
      writer.float(v);
    }
    writer.join();
    if (message.b !== 0) {
      writer.uint32(29).float(message.b);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogisticLocateHeadProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLogisticLocateHeadProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.inputDim = reader.int32();
          continue;
        }
        case 2: {
          if (tag === 21) {
            message.w.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.w.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.b = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LogisticLocateHeadProto {
    return {
      inputDim: isSet(object.inputDim) ? globalThis.Number(object.inputDim) : 0,
      w: globalThis.Array.isArray(object?.w) ? object.w.map((e: any) => globalThis.Number(e)) : [],
      b: isSet(object.b) ? globalThis.Number(object.b) : 0,
    };
  },

  toJSON(message: LogisticLocateHeadProto): unknown {
    const obj: any = {};
    if (message.inputDim !== 0) {
      obj.inputDim = Math.round(message.inputDim);
    }
    if (message.w?.length) {
      obj.w = message.w;
    }
    if (message.b !== 0) {
      obj.b = message.b;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LogisticLocateHeadProto>, I>>(base?: I): LogisticLocateHeadProto {
    return LogisticLocateHeadProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LogisticLocateHeadProto>, I>>(object: I): LogisticLocateHeadProto {
    const message = createBaseLogisticLocateHeadProto();
    message.inputDim = object.inputDim ?? 0;
    message.w = object.w?.map((e) => e) || [];
    message.b = object.b ?? 0;
    return message;
  },
};

function createBaseLocateHeadProto(): LocateHeadProto {
  return { mlp: undefined, logistic: undefined };
}

export const LocateHeadProto: MessageFns<LocateHeadProto> = {
  encode(message: LocateHeadProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mlp !== undefined) {
      MlpLocateHeadProto.encode(message.mlp, writer.uint32(10).fork()).join();
    }
    if (message.logistic !== undefined) {
      LogisticLocateHeadProto.encode(message.logistic, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocateHeadProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocateHeadProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mlp = MlpLocateHeadProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.logistic = LogisticLocateHeadProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocateHeadProto {
    return {
      mlp: isSet(object.mlp) ? MlpLocateHeadProto.fromJSON(object.mlp) : undefined,
      logistic: isSet(object.logistic) ? LogisticLocateHeadProto.fromJSON(object.logistic) : undefined,
    };
  },

  toJSON(message: LocateHeadProto): unknown {
    const obj: any = {};
    if (message.mlp !== undefined) {
      obj.mlp = MlpLocateHeadProto.toJSON(message.mlp);
    }
    if (message.logistic !== undefined) {
      obj.logistic = LogisticLocateHeadProto.toJSON(message.logistic);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocateHeadProto>, I>>(base?: I): LocateHeadProto {
    return LocateHeadProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocateHeadProto>, I>>(object: I): LocateHeadProto {
    const message = createBaseLocateHeadProto();
    message.mlp = (object.mlp !== undefined && object.mlp !== null)
      ? MlpLocateHeadProto.fromPartial(object.mlp)
      : undefined;
    message.logistic = (object.logistic !== undefined && object.logistic !== null)
      ? LogisticLocateHeadProto.fromPartial(object.logistic)
      : undefined;
    return message;
  },
};

function createBaseTrainLocateHeadRequest(): TrainLocateHeadRequest {
  return {
    sessionId: "",
    seq: 0,
    image: new Uint8Array(0),
    modelVersion: "",
    precision: "",
    clicks: [],
    committedPositives: [],
    committedNegatives: [],
    headKind: 0,
  };
}

export const TrainLocateHeadRequest: MessageFns<TrainLocateHeadRequest> = {
  encode(message: TrainLocateHeadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== "") {
      writer.uint32(10).string(message.sessionId);
    }
    if (message.seq !== 0) {
      writer.uint32(16).uint64(message.seq);
    }
    if (message.image.length !== 0) {
      writer.uint32(26).bytes(message.image);
    }
    if (message.modelVersion !== "") {
      writer.uint32(34).string(message.modelVersion);
    }
    if (message.precision !== "") {
      writer.uint32(42).string(message.precision);
    }
    for (const v of message.clicks) {
      LocateClick.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.committedPositives) {
      ReferenceVector.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.committedNegatives) {
      ReferenceVector.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.headKind !== 0) {
      writer.uint32(72).int32(message.headKind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrainLocateHeadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrainLocateHeadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.seq = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.precision = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.clicks.push(LocateClick.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.committedPositives.push(ReferenceVector.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.committedNegatives.push(ReferenceVector.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.headKind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrainLocateHeadRequest {
    return {
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
      precision: isSet(object.precision) ? globalThis.String(object.precision) : "",
      clicks: globalThis.Array.isArray(object?.clicks) ? object.clicks.map((e: any) => LocateClick.fromJSON(e)) : [],
      committedPositives: globalThis.Array.isArray(object?.committedPositives)
        ? object.committedPositives.map((e: any) => ReferenceVector.fromJSON(e))
        : [],
      committedNegatives: globalThis.Array.isArray(object?.committedNegatives)
        ? object.committedNegatives.map((e: any) => ReferenceVector.fromJSON(e))
        : [],
      headKind: isSet(object.headKind) ? locateHeadKindFromJSON(object.headKind) : 0,
    };
  },

  toJSON(message: TrainLocateHeadRequest): unknown {
    const obj: any = {};
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq);
    }
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    if (message.precision !== "") {
      obj.precision = message.precision;
    }
    if (message.clicks?.length) {
      obj.clicks = message.clicks.map((e) => LocateClick.toJSON(e));
    }
    if (message.committedPositives?.length) {
      obj.committedPositives = message.committedPositives.map((e) => ReferenceVector.toJSON(e));
    }
    if (message.committedNegatives?.length) {
      obj.committedNegatives = message.committedNegatives.map((e) => ReferenceVector.toJSON(e));
    }
    if (message.headKind !== 0) {
      obj.headKind = locateHeadKindToJSON(message.headKind);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrainLocateHeadRequest>, I>>(base?: I): TrainLocateHeadRequest {
    return TrainLocateHeadRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrainLocateHeadRequest>, I>>(object: I): TrainLocateHeadRequest {
    const message = createBaseTrainLocateHeadRequest();
    message.sessionId = object.sessionId ?? "";
    message.seq = object.seq ?? 0;
    message.image = object.image ?? new Uint8Array(0);
    message.modelVersion = object.modelVersion ?? "";
    message.precision = object.precision ?? "";
    message.clicks = object.clicks?.map((e) => LocateClick.fromPartial(e)) || [];
    message.committedPositives = object.committedPositives?.map((e) => ReferenceVector.fromPartial(e)) || [];
    message.committedNegatives = object.committedNegatives?.map((e) => ReferenceVector.fromPartial(e)) || [];
    message.headKind = object.headKind ?? 0;
    return message;
  },
};

function createBaseLocateHeatmap(): LocateHeatmap {
  return {
    gridH: 0,
    gridW: 0,
    values: new Uint8Array(0),
    inputH: 0,
    inputW: 0,
    paddingTop: 0,
    paddingLeft: 0,
    modelVersion: "",
  };
}

export const LocateHeatmap: MessageFns<LocateHeatmap> = {
  encode(message: LocateHeatmap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gridH !== 0) {
      writer.uint32(8).int32(message.gridH);
    }
    if (message.gridW !== 0) {
      writer.uint32(16).int32(message.gridW);
    }
    if (message.values.length !== 0) {
      writer.uint32(26).bytes(message.values);
    }
    if (message.inputH !== 0) {
      writer.uint32(32).int32(message.inputH);
    }
    if (message.inputW !== 0) {
      writer.uint32(40).int32(message.inputW);
    }
    if (message.paddingTop !== 0) {
      writer.uint32(48).int32(message.paddingTop);
    }
    if (message.paddingLeft !== 0) {
      writer.uint32(56).int32(message.paddingLeft);
    }
    if (message.modelVersion !== "") {
      writer.uint32(66).string(message.modelVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocateHeatmap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocateHeatmap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.gridH = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.gridW = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.values = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.inputH = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.inputW = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.paddingTop = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.paddingLeft = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.modelVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocateHeatmap {
    return {
      gridH: isSet(object.gridH) ? globalThis.Number(object.gridH) : 0,
      gridW: isSet(object.gridW) ? globalThis.Number(object.gridW) : 0,
      values: isSet(object.values) ? bytesFromBase64(object.values) : new Uint8Array(0),
      inputH: isSet(object.inputH) ? globalThis.Number(object.inputH) : 0,
      inputW: isSet(object.inputW) ? globalThis.Number(object.inputW) : 0,
      paddingTop: isSet(object.paddingTop) ? globalThis.Number(object.paddingTop) : 0,
      paddingLeft: isSet(object.paddingLeft) ? globalThis.Number(object.paddingLeft) : 0,
      modelVersion: isSet(object.modelVersion) ? globalThis.String(object.modelVersion) : "",
    };
  },

  toJSON(message: LocateHeatmap): unknown {
    const obj: any = {};
    if (message.gridH !== 0) {
      obj.gridH = Math.round(message.gridH);
    }
    if (message.gridW !== 0) {
      obj.gridW = Math.round(message.gridW);
    }
    if (message.values.length !== 0) {
      obj.values = base64FromBytes(message.values);
    }
    if (message.inputH !== 0) {
      obj.inputH = Math.round(message.inputH);
    }
    if (message.inputW !== 0) {
      obj.inputW = Math.round(message.inputW);
    }
    if (message.paddingTop !== 0) {
      obj.paddingTop = Math.round(message.paddingTop);
    }
    if (message.paddingLeft !== 0) {
      obj.paddingLeft = Math.round(message.paddingLeft);
    }
    if (message.modelVersion !== "") {
      obj.modelVersion = message.modelVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocateHeatmap>, I>>(base?: I): LocateHeatmap {
    return LocateHeatmap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocateHeatmap>, I>>(object: I): LocateHeatmap {
    const message = createBaseLocateHeatmap();
    message.gridH = object.gridH ?? 0;
    message.gridW = object.gridW ?? 0;
    message.values = object.values ?? new Uint8Array(0);
    message.inputH = object.inputH ?? 0;
    message.inputW = object.inputW ?? 0;
    message.paddingTop = object.paddingTop ?? 0;
    message.paddingLeft = object.paddingLeft ?? 0;
    message.modelVersion = object.modelVersion ?? "";
    return message;
  },
};

function createBaseTrainLocateHeadResult(): TrainLocateHeadResult {
  return { seq: 0, superseded: false, head: undefined, heatmap: undefined, clickEmbeddings: [] };
}

export const TrainLocateHeadResult: MessageFns<TrainLocateHeadResult> = {
  encode(message: TrainLocateHeadResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seq !== 0) {
      writer.uint32(8).uint64(message.seq);
    }
    if (message.superseded !== false) {
      writer.uint32(16).bool(message.superseded);
    }
    if (message.head !== undefined) {
      LocateHeadProto.encode(message.head, writer.uint32(26).fork()).join();
    }
    if (message.heatmap !== undefined) {
      LocateHeatmap.encode(message.heatmap, writer.uint32(34).fork()).join();
    }
    for (const v of message.clickEmbeddings) {
      ReferenceVector.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrainLocateHeadResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrainLocateHeadResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.seq = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.superseded = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.head = LocateHeadProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.heatmap = LocateHeatmap.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.clickEmbeddings.push(ReferenceVector.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrainLocateHeadResult {
    return {
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      superseded: isSet(object.superseded) ? globalThis.Boolean(object.superseded) : false,
      head: isSet(object.head) ? LocateHeadProto.fromJSON(object.head) : undefined,
      heatmap: isSet(object.heatmap) ? LocateHeatmap.fromJSON(object.heatmap) : undefined,
      clickEmbeddings: globalThis.Array.isArray(object?.clickEmbeddings)
        ? object.clickEmbeddings.map((e: any) => ReferenceVector.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TrainLocateHeadResult): unknown {
    const obj: any = {};
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq);
    }
    if (message.superseded !== false) {
      obj.superseded = message.superseded;
    }
    if (message.head !== undefined) {
      obj.head = LocateHeadProto.toJSON(message.head);
    }
    if (message.heatmap !== undefined) {
      obj.heatmap = LocateHeatmap.toJSON(message.heatmap);
    }
    if (message.clickEmbeddings?.length) {
      obj.clickEmbeddings = message.clickEmbeddings.map((e) => ReferenceVector.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrainLocateHeadResult>, I>>(base?: I): TrainLocateHeadResult {
    return TrainLocateHeadResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrainLocateHeadResult>, I>>(object: I): TrainLocateHeadResult {
    const message = createBaseTrainLocateHeadResult();
    message.seq = object.seq ?? 0;
    message.superseded = object.superseded ?? false;
    message.head = (object.head !== undefined && object.head !== null)
      ? LocateHeadProto.fromPartial(object.head)
      : undefined;
    message.heatmap = (object.heatmap !== undefined && object.heatmap !== null)
      ? LocateHeatmap.fromPartial(object.heatmap)
      : undefined;
    message.clickEmbeddings = object.clickEmbeddings?.map((e) => ReferenceVector.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrainLocateHeadResponse(): TrainLocateHeadResponse {
  return { data: undefined, error: undefined };
}

export const TrainLocateHeadResponse: MessageFns<TrainLocateHeadResponse> = {
  encode(message: TrainLocateHeadResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      TrainLocateHeadResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrainLocateHeadResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrainLocateHeadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = TrainLocateHeadResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrainLocateHeadResponse {
    return {
      data: isSet(object.data) ? TrainLocateHeadResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: TrainLocateHeadResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = TrainLocateHeadResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrainLocateHeadResponse>, I>>(base?: I): TrainLocateHeadResponse {
    return TrainLocateHeadResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrainLocateHeadResponse>, I>>(object: I): TrainLocateHeadResponse {
    const message = createBaseTrainLocateHeadResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? TrainLocateHeadResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseDetectScenePlaneRequest(): DetectScenePlaneRequest {
  return {
    depthImage: new Uint8Array(0),
    cameraParams: undefined,
    ransac: undefined,
    fixedThreshold: undefined,
    region: undefined,
    seedPoints: [],
    downsampleStride: undefined,
    minDepthM: undefined,
    maxDepthM: undefined,
    maxCandidates: undefined,
    includeInlierMask: undefined,
  };
}

export const DetectScenePlaneRequest: MessageFns<DetectScenePlaneRequest> = {
  encode(message: DetectScenePlaneRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depthImage.length !== 0) {
      writer.uint32(10).bytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      CameraParams.encode(message.cameraParams, writer.uint32(18).fork()).join();
    }
    if (message.ransac !== undefined) {
      GeometricPlane.encode(message.ransac, writer.uint32(26).fork()).join();
    }
    if (message.fixedThreshold !== undefined) {
      writer.uint32(32).bool(message.fixedThreshold);
    }
    if (message.region !== undefined) {
      Blob2D.encode(message.region, writer.uint32(42).fork()).join();
    }
    for (const v of message.seedPoints) {
      Point2D.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.downsampleStride !== undefined) {
      writer.uint32(56).int32(message.downsampleStride);
    }
    if (message.minDepthM !== undefined) {
      writer.uint32(69).float(message.minDepthM);
    }
    if (message.maxDepthM !== undefined) {
      writer.uint32(77).float(message.maxDepthM);
    }
    if (message.maxCandidates !== undefined) {
      writer.uint32(80).int32(message.maxCandidates);
    }
    if (message.includeInlierMask !== undefined) {
      writer.uint32(88).bool(message.includeInlierMask);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectScenePlaneRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectScenePlaneRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.depthImage = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cameraParams = CameraParams.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ransac = GeometricPlane.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fixedThreshold = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.region = Blob2D.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.seedPoints.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.downsampleStride = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.minDepthM = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.maxDepthM = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maxCandidates = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.includeInlierMask = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectScenePlaneRequest {
    return {
      depthImage: isSet(object.depthImage) ? bytesFromBase64(object.depthImage) : new Uint8Array(0),
      cameraParams: isSet(object.cameraParams) ? CameraParams.fromJSON(object.cameraParams) : undefined,
      ransac: isSet(object.ransac) ? GeometricPlane.fromJSON(object.ransac) : undefined,
      fixedThreshold: isSet(object.fixedThreshold) ? globalThis.Boolean(object.fixedThreshold) : undefined,
      region: isSet(object.region) ? Blob2D.fromJSON(object.region) : undefined,
      seedPoints: globalThis.Array.isArray(object?.seedPoints)
        ? object.seedPoints.map((e: any) => Point2D.fromJSON(e))
        : [],
      downsampleStride: isSet(object.downsampleStride) ? globalThis.Number(object.downsampleStride) : undefined,
      minDepthM: isSet(object.minDepthM) ? globalThis.Number(object.minDepthM) : undefined,
      maxDepthM: isSet(object.maxDepthM) ? globalThis.Number(object.maxDepthM) : undefined,
      maxCandidates: isSet(object.maxCandidates) ? globalThis.Number(object.maxCandidates) : undefined,
      includeInlierMask: isSet(object.includeInlierMask) ? globalThis.Boolean(object.includeInlierMask) : undefined,
    };
  },

  toJSON(message: DetectScenePlaneRequest): unknown {
    const obj: any = {};
    if (message.depthImage.length !== 0) {
      obj.depthImage = base64FromBytes(message.depthImage);
    }
    if (message.cameraParams !== undefined) {
      obj.cameraParams = CameraParams.toJSON(message.cameraParams);
    }
    if (message.ransac !== undefined) {
      obj.ransac = GeometricPlane.toJSON(message.ransac);
    }
    if (message.fixedThreshold !== undefined) {
      obj.fixedThreshold = message.fixedThreshold;
    }
    if (message.region !== undefined) {
      obj.region = Blob2D.toJSON(message.region);
    }
    if (message.seedPoints?.length) {
      obj.seedPoints = message.seedPoints.map((e) => Point2D.toJSON(e));
    }
    if (message.downsampleStride !== undefined) {
      obj.downsampleStride = Math.round(message.downsampleStride);
    }
    if (message.minDepthM !== undefined) {
      obj.minDepthM = message.minDepthM;
    }
    if (message.maxDepthM !== undefined) {
      obj.maxDepthM = message.maxDepthM;
    }
    if (message.maxCandidates !== undefined) {
      obj.maxCandidates = Math.round(message.maxCandidates);
    }
    if (message.includeInlierMask !== undefined) {
      obj.includeInlierMask = message.includeInlierMask;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectScenePlaneRequest>, I>>(base?: I): DetectScenePlaneRequest {
    return DetectScenePlaneRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectScenePlaneRequest>, I>>(object: I): DetectScenePlaneRequest {
    const message = createBaseDetectScenePlaneRequest();
    message.depthImage = object.depthImage ?? new Uint8Array(0);
    message.cameraParams = (object.cameraParams !== undefined && object.cameraParams !== null)
      ? CameraParams.fromPartial(object.cameraParams)
      : undefined;
    message.ransac = (object.ransac !== undefined && object.ransac !== null)
      ? GeometricPlane.fromPartial(object.ransac)
      : undefined;
    message.fixedThreshold = object.fixedThreshold ?? undefined;
    message.region = (object.region !== undefined && object.region !== null)
      ? Blob2D.fromPartial(object.region)
      : undefined;
    message.seedPoints = object.seedPoints?.map((e) => Point2D.fromPartial(e)) || [];
    message.downsampleStride = object.downsampleStride ?? undefined;
    message.minDepthM = object.minDepthM ?? undefined;
    message.maxDepthM = object.maxDepthM ?? undefined;
    message.maxCandidates = object.maxCandidates ?? undefined;
    message.includeInlierMask = object.includeInlierMask ?? undefined;
    return message;
  },
};

function createBaseScenePlane(): ScenePlane {
  return {
    planePose: undefined,
    surfaceNormal: undefined,
    inlierRatio: 0,
    inlierCount: 0,
    rmsErrorM: 0,
    tiltAngleDeg: 0,
    medianDepthM: undefined,
    inlierMaskRle: undefined,
    maskWidth: undefined,
    maskHeight: undefined,
  };
}

export const ScenePlane: MessageFns<ScenePlane> = {
  encode(message: ScenePlane, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.planePose !== undefined) {
      CartesianPose.encode(message.planePose, writer.uint32(10).fork()).join();
    }
    if (message.surfaceNormal !== undefined) {
      Point.encode(message.surfaceNormal, writer.uint32(18).fork()).join();
    }
    if (message.inlierRatio !== 0) {
      writer.uint32(29).float(message.inlierRatio);
    }
    if (message.inlierCount !== 0) {
      writer.uint32(32).int32(message.inlierCount);
    }
    if (message.rmsErrorM !== 0) {
      writer.uint32(45).float(message.rmsErrorM);
    }
    if (message.tiltAngleDeg !== 0) {
      writer.uint32(53).float(message.tiltAngleDeg);
    }
    if (message.medianDepthM !== undefined) {
      writer.uint32(61).float(message.medianDepthM);
    }
    if (message.inlierMaskRle !== undefined) {
      writer.uint32(66).bytes(message.inlierMaskRle);
    }
    if (message.maskWidth !== undefined) {
      writer.uint32(72).int32(message.maskWidth);
    }
    if (message.maskHeight !== undefined) {
      writer.uint32(80).int32(message.maskHeight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenePlane {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenePlane();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.planePose = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.surfaceNormal = Point.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.inlierRatio = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.inlierCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rmsErrorM = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.tiltAngleDeg = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.medianDepthM = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.inlierMaskRle = reader.bytes();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maskWidth = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maskHeight = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenePlane {
    return {
      planePose: isSet(object.planePose) ? CartesianPose.fromJSON(object.planePose) : undefined,
      surfaceNormal: isSet(object.surfaceNormal) ? Point.fromJSON(object.surfaceNormal) : undefined,
      inlierRatio: isSet(object.inlierRatio) ? globalThis.Number(object.inlierRatio) : 0,
      inlierCount: isSet(object.inlierCount) ? globalThis.Number(object.inlierCount) : 0,
      rmsErrorM: isSet(object.rmsErrorM) ? globalThis.Number(object.rmsErrorM) : 0,
      tiltAngleDeg: isSet(object.tiltAngleDeg) ? globalThis.Number(object.tiltAngleDeg) : 0,
      medianDepthM: isSet(object.medianDepthM) ? globalThis.Number(object.medianDepthM) : undefined,
      inlierMaskRle: isSet(object.inlierMaskRle) ? bytesFromBase64(object.inlierMaskRle) : undefined,
      maskWidth: isSet(object.maskWidth) ? globalThis.Number(object.maskWidth) : undefined,
      maskHeight: isSet(object.maskHeight) ? globalThis.Number(object.maskHeight) : undefined,
    };
  },

  toJSON(message: ScenePlane): unknown {
    const obj: any = {};
    if (message.planePose !== undefined) {
      obj.planePose = CartesianPose.toJSON(message.planePose);
    }
    if (message.surfaceNormal !== undefined) {
      obj.surfaceNormal = Point.toJSON(message.surfaceNormal);
    }
    if (message.inlierRatio !== 0) {
      obj.inlierRatio = message.inlierRatio;
    }
    if (message.inlierCount !== 0) {
      obj.inlierCount = Math.round(message.inlierCount);
    }
    if (message.rmsErrorM !== 0) {
      obj.rmsErrorM = message.rmsErrorM;
    }
    if (message.tiltAngleDeg !== 0) {
      obj.tiltAngleDeg = message.tiltAngleDeg;
    }
    if (message.medianDepthM !== undefined) {
      obj.medianDepthM = message.medianDepthM;
    }
    if (message.inlierMaskRle !== undefined) {
      obj.inlierMaskRle = base64FromBytes(message.inlierMaskRle);
    }
    if (message.maskWidth !== undefined) {
      obj.maskWidth = Math.round(message.maskWidth);
    }
    if (message.maskHeight !== undefined) {
      obj.maskHeight = Math.round(message.maskHeight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenePlane>, I>>(base?: I): ScenePlane {
    return ScenePlane.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenePlane>, I>>(object: I): ScenePlane {
    const message = createBaseScenePlane();
    message.planePose = (object.planePose !== undefined && object.planePose !== null)
      ? CartesianPose.fromPartial(object.planePose)
      : undefined;
    message.surfaceNormal = (object.surfaceNormal !== undefined && object.surfaceNormal !== null)
      ? Point.fromPartial(object.surfaceNormal)
      : undefined;
    message.inlierRatio = object.inlierRatio ?? 0;
    message.inlierCount = object.inlierCount ?? 0;
    message.rmsErrorM = object.rmsErrorM ?? 0;
    message.tiltAngleDeg = object.tiltAngleDeg ?? 0;
    message.medianDepthM = object.medianDepthM ?? undefined;
    message.inlierMaskRle = object.inlierMaskRle ?? undefined;
    message.maskWidth = object.maskWidth ?? undefined;
    message.maskHeight = object.maskHeight ?? undefined;
    return message;
  },
};

function createBaseSeedWindow(): SeedWindow {
  return { seedIndex: 0, contourPoints: [] };
}

export const SeedWindow: MessageFns<SeedWindow> = {
  encode(message: SeedWindow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seedIndex !== 0) {
      writer.uint32(8).int32(message.seedIndex);
    }
    for (const v of message.contourPoints) {
      Point2D.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeedWindow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeedWindow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.seedIndex = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contourPoints.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SeedWindow {
    return {
      seedIndex: isSet(object.seedIndex) ? globalThis.Number(object.seedIndex) : 0,
      contourPoints: globalThis.Array.isArray(object?.contourPoints)
        ? object.contourPoints.map((e: any) => Point2D.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SeedWindow): unknown {
    const obj: any = {};
    if (message.seedIndex !== 0) {
      obj.seedIndex = Math.round(message.seedIndex);
    }
    if (message.contourPoints?.length) {
      obj.contourPoints = message.contourPoints.map((e) => Point2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SeedWindow>, I>>(base?: I): SeedWindow {
    return SeedWindow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeedWindow>, I>>(object: I): SeedWindow {
    const message = createBaseSeedWindow();
    message.seedIndex = object.seedIndex ?? 0;
    message.contourPoints = object.contourPoints?.map((e) => Point2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScenePlaneResult(): ScenePlaneResult {
  return { candidates: [], ignoredSeedIndices: [], processingTimeMs: undefined, seedWindows: [] };
}

export const ScenePlaneResult: MessageFns<ScenePlaneResult> = {
  encode(message: ScenePlaneResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.candidates) {
      ScenePlane.encode(v!, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.ignoredSeedIndices) {
      writer.int32(v);
    }
    writer.join();
    if (message.processingTimeMs !== undefined) {
      writer.uint32(24).int32(message.processingTimeMs);
    }
    for (const v of message.seedWindows) {
      SeedWindow.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenePlaneResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenePlaneResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidates.push(ScenePlane.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.ignoredSeedIndices.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ignoredSeedIndices.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.seedWindows.push(SeedWindow.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenePlaneResult {
    return {
      candidates: globalThis.Array.isArray(object?.candidates)
        ? object.candidates.map((e: any) => ScenePlane.fromJSON(e))
        : [],
      ignoredSeedIndices: globalThis.Array.isArray(object?.ignoredSeedIndices)
        ? object.ignoredSeedIndices.map((e: any) => globalThis.Number(e))
        : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
      seedWindows: globalThis.Array.isArray(object?.seedWindows)
        ? object.seedWindows.map((e: any) => SeedWindow.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScenePlaneResult): unknown {
    const obj: any = {};
    if (message.candidates?.length) {
      obj.candidates = message.candidates.map((e) => ScenePlane.toJSON(e));
    }
    if (message.ignoredSeedIndices?.length) {
      obj.ignoredSeedIndices = message.ignoredSeedIndices.map((e) => Math.round(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    if (message.seedWindows?.length) {
      obj.seedWindows = message.seedWindows.map((e) => SeedWindow.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenePlaneResult>, I>>(base?: I): ScenePlaneResult {
    return ScenePlaneResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenePlaneResult>, I>>(object: I): ScenePlaneResult {
    const message = createBaseScenePlaneResult();
    message.candidates = object.candidates?.map((e) => ScenePlane.fromPartial(e)) || [];
    message.ignoredSeedIndices = object.ignoredSeedIndices?.map((e) => e) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    message.seedWindows = object.seedWindows?.map((e) => SeedWindow.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDetectScenePlaneResponse(): DetectScenePlaneResponse {
  return { data: undefined, error: undefined };
}

export const DetectScenePlaneResponse: MessageFns<DetectScenePlaneResponse> = {
  encode(message: DetectScenePlaneResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      ScenePlaneResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetectScenePlaneResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetectScenePlaneResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = ScenePlaneResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetectScenePlaneResponse {
    return {
      data: isSet(object.data) ? ScenePlaneResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: DetectScenePlaneResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = ScenePlaneResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetectScenePlaneResponse>, I>>(base?: I): DetectScenePlaneResponse {
    return DetectScenePlaneResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetectScenePlaneResponse>, I>>(object: I): DetectScenePlaneResponse {
    const message = createBaseDetectScenePlaneResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? ScenePlaneResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBasePreloadRoboflowModelRequest(): PreloadRoboflowModelRequest {
  return { modelId: "", apiKey: "" };
}

export const PreloadRoboflowModelRequest: MessageFns<PreloadRoboflowModelRequest> = {
  encode(message: PreloadRoboflowModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.apiKey !== "") {
      writer.uint32(18).string(message.apiKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowModelRequest {
    return {
      modelId: isSet(object.modelId) ? globalThis.String(object.modelId) : "",
      apiKey: isSet(object.apiKey) ? globalThis.String(object.apiKey) : "",
    };
  },

  toJSON(message: PreloadRoboflowModelRequest): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowModelRequest>, I>>(base?: I): PreloadRoboflowModelRequest {
    return PreloadRoboflowModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowModelRequest>, I>>(object: I): PreloadRoboflowModelRequest {
    const message = createBasePreloadRoboflowModelRequest();
    message.modelId = object.modelId ?? "";
    message.apiKey = object.apiKey ?? "";
    return message;
  },
};

function createBasePreloadRoboflowModelResult(): PreloadRoboflowModelResult {
  return { modelId: "", loadTimeMs: undefined };
}

export const PreloadRoboflowModelResult: MessageFns<PreloadRoboflowModelResult> = {
  encode(message: PreloadRoboflowModelResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.loadTimeMs !== undefined) {
      writer.uint32(16).int32(message.loadTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowModelResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowModelResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.loadTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowModelResult {
    return {
      modelId: isSet(object.modelId) ? globalThis.String(object.modelId) : "",
      loadTimeMs: isSet(object.loadTimeMs) ? globalThis.Number(object.loadTimeMs) : undefined,
    };
  },

  toJSON(message: PreloadRoboflowModelResult): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.loadTimeMs !== undefined) {
      obj.loadTimeMs = Math.round(message.loadTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowModelResult>, I>>(base?: I): PreloadRoboflowModelResult {
    return PreloadRoboflowModelResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowModelResult>, I>>(object: I): PreloadRoboflowModelResult {
    const message = createBasePreloadRoboflowModelResult();
    message.modelId = object.modelId ?? "";
    message.loadTimeMs = object.loadTimeMs ?? undefined;
    return message;
  },
};

function createBasePreloadRoboflowModelResponse(): PreloadRoboflowModelResponse {
  return { data: undefined, error: undefined };
}

export const PreloadRoboflowModelResponse: MessageFns<PreloadRoboflowModelResponse> = {
  encode(message: PreloadRoboflowModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      PreloadRoboflowModelResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = PreloadRoboflowModelResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowModelResponse {
    return {
      data: isSet(object.data) ? PreloadRoboflowModelResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: PreloadRoboflowModelResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = PreloadRoboflowModelResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowModelResponse>, I>>(base?: I): PreloadRoboflowModelResponse {
    return PreloadRoboflowModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowModelResponse>, I>>(object: I): PreloadRoboflowModelResponse {
    const message = createBasePreloadRoboflowModelResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? PreloadRoboflowModelResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBasePreloadRoboflowWorkflowRequest(): PreloadRoboflowWorkflowRequest {
  return { workspaceName: "", workflowId: "", apiKey: "" };
}

export const PreloadRoboflowWorkflowRequest: MessageFns<PreloadRoboflowWorkflowRequest> = {
  encode(message: PreloadRoboflowWorkflowRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspaceName !== "") {
      writer.uint32(10).string(message.workspaceName);
    }
    if (message.workflowId !== "") {
      writer.uint32(18).string(message.workflowId);
    }
    if (message.apiKey !== "") {
      writer.uint32(26).string(message.apiKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowWorkflowRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowWorkflowRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workflowId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowWorkflowRequest {
    return {
      workspaceName: isSet(object.workspaceName) ? globalThis.String(object.workspaceName) : "",
      workflowId: isSet(object.workflowId) ? globalThis.String(object.workflowId) : "",
      apiKey: isSet(object.apiKey) ? globalThis.String(object.apiKey) : "",
    };
  },

  toJSON(message: PreloadRoboflowWorkflowRequest): unknown {
    const obj: any = {};
    if (message.workspaceName !== "") {
      obj.workspaceName = message.workspaceName;
    }
    if (message.workflowId !== "") {
      obj.workflowId = message.workflowId;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowWorkflowRequest>, I>>(base?: I): PreloadRoboflowWorkflowRequest {
    return PreloadRoboflowWorkflowRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowWorkflowRequest>, I>>(
    object: I,
  ): PreloadRoboflowWorkflowRequest {
    const message = createBasePreloadRoboflowWorkflowRequest();
    message.workspaceName = object.workspaceName ?? "";
    message.workflowId = object.workflowId ?? "";
    message.apiKey = object.apiKey ?? "";
    return message;
  },
};

function createBasePreloadRoboflowWorkflowResult(): PreloadRoboflowWorkflowResult {
  return { workspaceName: "", workflowId: "", loadTimeMs: undefined };
}

export const PreloadRoboflowWorkflowResult: MessageFns<PreloadRoboflowWorkflowResult> = {
  encode(message: PreloadRoboflowWorkflowResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspaceName !== "") {
      writer.uint32(10).string(message.workspaceName);
    }
    if (message.workflowId !== "") {
      writer.uint32(18).string(message.workflowId);
    }
    if (message.loadTimeMs !== undefined) {
      writer.uint32(24).int32(message.loadTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowWorkflowResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowWorkflowResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workflowId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.loadTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowWorkflowResult {
    return {
      workspaceName: isSet(object.workspaceName) ? globalThis.String(object.workspaceName) : "",
      workflowId: isSet(object.workflowId) ? globalThis.String(object.workflowId) : "",
      loadTimeMs: isSet(object.loadTimeMs) ? globalThis.Number(object.loadTimeMs) : undefined,
    };
  },

  toJSON(message: PreloadRoboflowWorkflowResult): unknown {
    const obj: any = {};
    if (message.workspaceName !== "") {
      obj.workspaceName = message.workspaceName;
    }
    if (message.workflowId !== "") {
      obj.workflowId = message.workflowId;
    }
    if (message.loadTimeMs !== undefined) {
      obj.loadTimeMs = Math.round(message.loadTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowWorkflowResult>, I>>(base?: I): PreloadRoboflowWorkflowResult {
    return PreloadRoboflowWorkflowResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowWorkflowResult>, I>>(
    object: I,
  ): PreloadRoboflowWorkflowResult {
    const message = createBasePreloadRoboflowWorkflowResult();
    message.workspaceName = object.workspaceName ?? "";
    message.workflowId = object.workflowId ?? "";
    message.loadTimeMs = object.loadTimeMs ?? undefined;
    return message;
  },
};

function createBasePreloadRoboflowWorkflowResponse(): PreloadRoboflowWorkflowResponse {
  return { data: undefined, error: undefined };
}

export const PreloadRoboflowWorkflowResponse: MessageFns<PreloadRoboflowWorkflowResponse> = {
  encode(message: PreloadRoboflowWorkflowResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      PreloadRoboflowWorkflowResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreloadRoboflowWorkflowResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreloadRoboflowWorkflowResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = PreloadRoboflowWorkflowResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreloadRoboflowWorkflowResponse {
    return {
      data: isSet(object.data) ? PreloadRoboflowWorkflowResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: PreloadRoboflowWorkflowResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = PreloadRoboflowWorkflowResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreloadRoboflowWorkflowResponse>, I>>(base?: I): PreloadRoboflowWorkflowResponse {
    return PreloadRoboflowWorkflowResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreloadRoboflowWorkflowResponse>, I>>(
    object: I,
  ): PreloadRoboflowWorkflowResponse {
    const message = createBasePreloadRoboflowWorkflowResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? PreloadRoboflowWorkflowResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseRunRoboflowDetectionRequest(): RunRoboflowDetectionRequest {
  return { modelId: "", apiKey: "", image: new Uint8Array(0), thresholdingParams: {} };
}

export const RunRoboflowDetectionRequest: MessageFns<RunRoboflowDetectionRequest> = {
  encode(message: RunRoboflowDetectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.apiKey !== "") {
      writer.uint32(18).string(message.apiKey);
    }
    if (message.image.length !== 0) {
      writer.uint32(26).bytes(message.image);
    }
    Object.entries(message.thresholdingParams).forEach(([key, value]) => {
      RunRoboflowDetectionRequest_ThresholdingParamsEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowDetectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowDetectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = RunRoboflowDetectionRequest_ThresholdingParamsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.thresholdingParams[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowDetectionRequest {
    return {
      modelId: isSet(object.modelId) ? globalThis.String(object.modelId) : "",
      apiKey: isSet(object.apiKey) ? globalThis.String(object.apiKey) : "",
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      thresholdingParams: isObject(object.thresholdingParams)
        ? Object.entries(object.thresholdingParams).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: RunRoboflowDetectionRequest): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.thresholdingParams) {
      const entries = Object.entries(message.thresholdingParams);
      if (entries.length > 0) {
        obj.thresholdingParams = {};
        entries.forEach(([k, v]) => {
          obj.thresholdingParams[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowDetectionRequest>, I>>(base?: I): RunRoboflowDetectionRequest {
    return RunRoboflowDetectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowDetectionRequest>, I>>(object: I): RunRoboflowDetectionRequest {
    const message = createBaseRunRoboflowDetectionRequest();
    message.modelId = object.modelId ?? "";
    message.apiKey = object.apiKey ?? "";
    message.image = object.image ?? new Uint8Array(0);
    message.thresholdingParams = Object.entries(object.thresholdingParams ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRunRoboflowDetectionRequest_ThresholdingParamsEntry(): RunRoboflowDetectionRequest_ThresholdingParamsEntry {
  return { key: "", value: "" };
}

export const RunRoboflowDetectionRequest_ThresholdingParamsEntry: MessageFns<
  RunRoboflowDetectionRequest_ThresholdingParamsEntry
> = {
  encode(
    message: RunRoboflowDetectionRequest_ThresholdingParamsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowDetectionRequest_ThresholdingParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowDetectionRequest_ThresholdingParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowDetectionRequest_ThresholdingParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: RunRoboflowDetectionRequest_ThresholdingParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowDetectionRequest_ThresholdingParamsEntry>, I>>(
    base?: I,
  ): RunRoboflowDetectionRequest_ThresholdingParamsEntry {
    return RunRoboflowDetectionRequest_ThresholdingParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowDetectionRequest_ThresholdingParamsEntry>, I>>(
    object: I,
  ): RunRoboflowDetectionRequest_ThresholdingParamsEntry {
    const message = createBaseRunRoboflowDetectionRequest_ThresholdingParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseRunRoboflowDetectionResult(): RunRoboflowDetectionResult {
  return { blobs: [], processingTimeMs: undefined };
}

export const RunRoboflowDetectionResult: MessageFns<RunRoboflowDetectionResult> = {
  encode(message: RunRoboflowDetectionResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blobs) {
      LocateMatch.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowDetectionResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowDetectionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blobs.push(LocateMatch.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowDetectionResult {
    return {
      blobs: globalThis.Array.isArray(object?.blobs) ? object.blobs.map((e: any) => LocateMatch.fromJSON(e)) : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
    };
  },

  toJSON(message: RunRoboflowDetectionResult): unknown {
    const obj: any = {};
    if (message.blobs?.length) {
      obj.blobs = message.blobs.map((e) => LocateMatch.toJSON(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowDetectionResult>, I>>(base?: I): RunRoboflowDetectionResult {
    return RunRoboflowDetectionResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowDetectionResult>, I>>(object: I): RunRoboflowDetectionResult {
    const message = createBaseRunRoboflowDetectionResult();
    message.blobs = object.blobs?.map((e) => LocateMatch.fromPartial(e)) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    return message;
  },
};

function createBaseRunRoboflowDetectionResponse(): RunRoboflowDetectionResponse {
  return { data: undefined, error: undefined };
}

export const RunRoboflowDetectionResponse: MessageFns<RunRoboflowDetectionResponse> = {
  encode(message: RunRoboflowDetectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      RunRoboflowDetectionResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowDetectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowDetectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = RunRoboflowDetectionResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowDetectionResponse {
    return {
      data: isSet(object.data) ? RunRoboflowDetectionResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: RunRoboflowDetectionResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = RunRoboflowDetectionResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowDetectionResponse>, I>>(base?: I): RunRoboflowDetectionResponse {
    return RunRoboflowDetectionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowDetectionResponse>, I>>(object: I): RunRoboflowDetectionResponse {
    const message = createBaseRunRoboflowDetectionResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? RunRoboflowDetectionResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseRunRoboflowWorkflowRequest(): RunRoboflowWorkflowRequest {
  return { workspaceName: "", workflowId: "", apiKey: "", image: new Uint8Array(0) };
}

export const RunRoboflowWorkflowRequest: MessageFns<RunRoboflowWorkflowRequest> = {
  encode(message: RunRoboflowWorkflowRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspaceName !== "") {
      writer.uint32(10).string(message.workspaceName);
    }
    if (message.workflowId !== "") {
      writer.uint32(18).string(message.workflowId);
    }
    if (message.apiKey !== "") {
      writer.uint32(26).string(message.apiKey);
    }
    if (message.image.length !== 0) {
      writer.uint32(34).bytes(message.image);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowWorkflowRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowWorkflowRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workflowId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowWorkflowRequest {
    return {
      workspaceName: isSet(object.workspaceName) ? globalThis.String(object.workspaceName) : "",
      workflowId: isSet(object.workflowId) ? globalThis.String(object.workflowId) : "",
      apiKey: isSet(object.apiKey) ? globalThis.String(object.apiKey) : "",
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
    };
  },

  toJSON(message: RunRoboflowWorkflowRequest): unknown {
    const obj: any = {};
    if (message.workspaceName !== "") {
      obj.workspaceName = message.workspaceName;
    }
    if (message.workflowId !== "") {
      obj.workflowId = message.workflowId;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowWorkflowRequest>, I>>(base?: I): RunRoboflowWorkflowRequest {
    return RunRoboflowWorkflowRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowWorkflowRequest>, I>>(object: I): RunRoboflowWorkflowRequest {
    const message = createBaseRunRoboflowWorkflowRequest();
    message.workspaceName = object.workspaceName ?? "";
    message.workflowId = object.workflowId ?? "";
    message.apiKey = object.apiKey ?? "";
    message.image = object.image ?? new Uint8Array(0);
    return message;
  },
};

function createBaseRunRoboflowWorkflowResult(): RunRoboflowWorkflowResult {
  return { outputsJson: "", processingTimeMs: undefined };
}

export const RunRoboflowWorkflowResult: MessageFns<RunRoboflowWorkflowResult> = {
  encode(message: RunRoboflowWorkflowResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outputsJson !== "") {
      writer.uint32(10).string(message.outputsJson);
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowWorkflowResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowWorkflowResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.outputsJson = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowWorkflowResult {
    return {
      outputsJson: isSet(object.outputsJson) ? globalThis.String(object.outputsJson) : "",
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
    };
  },

  toJSON(message: RunRoboflowWorkflowResult): unknown {
    const obj: any = {};
    if (message.outputsJson !== "") {
      obj.outputsJson = message.outputsJson;
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowWorkflowResult>, I>>(base?: I): RunRoboflowWorkflowResult {
    return RunRoboflowWorkflowResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowWorkflowResult>, I>>(object: I): RunRoboflowWorkflowResult {
    const message = createBaseRunRoboflowWorkflowResult();
    message.outputsJson = object.outputsJson ?? "";
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    return message;
  },
};

function createBaseRunRoboflowWorkflowResponse(): RunRoboflowWorkflowResponse {
  return { data: undefined, error: undefined };
}

export const RunRoboflowWorkflowResponse: MessageFns<RunRoboflowWorkflowResponse> = {
  encode(message: RunRoboflowWorkflowResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      RunRoboflowWorkflowResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRoboflowWorkflowResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRoboflowWorkflowResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = RunRoboflowWorkflowResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRoboflowWorkflowResponse {
    return {
      data: isSet(object.data) ? RunRoboflowWorkflowResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: RunRoboflowWorkflowResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = RunRoboflowWorkflowResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunRoboflowWorkflowResponse>, I>>(base?: I): RunRoboflowWorkflowResponse {
    return RunRoboflowWorkflowResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunRoboflowWorkflowResponse>, I>>(object: I): RunRoboflowWorkflowResponse {
    const message = createBaseRunRoboflowWorkflowResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? RunRoboflowWorkflowResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

/** @language: python */
export interface VisionBotService {
  GetModels(request: Empty): Promise<ModelList>;
  RunCheckpointBasedInference(
    request: RunCheckpointBasedInferenceRequest,
  ): Promise<RunCheckpointBasedInferenceResponse>;
  RunPlaneProjection(request: RunPlaneProjectionRequest): Promise<RunPlaneProjectionResponse>;
  DetectBlobs(request: DetectBlobsRequest): Promise<DetectBlobsResponse>;
  DetectShapes(request: DetectShapesRequest): Promise<DetectShapesResponse>;
  DetectTextPrompt(request: DetectTextPromptRequest): Promise<DetectTextPromptResponse>;
  Classify(request: ClassifyRequest): Promise<ClassifyResponse>;
  GetChessboardCorners(request: GetChessboardCornersRequest): Promise<GetChessboardCornersResponse>;
  GetCameraChessboardTransform(
    request: GetCameraChessboardTransformRequest,
  ): Promise<GetCameraChessboardTransformResponse>;
  CalibrateCamera(request: CalibrateCameraRequest): Promise<CalibrateCameraResponse>;
  CalibrateCameraIntrinsics(request: CalibrateCameraIntrinsicsRequest): Promise<CalibrateCameraIntrinsicsResponse>;
  CalibrateCameraExtrinsics(request: CalibrateCameraExtrinsicsRequest): Promise<CalibrateCameraExtrinsicsResponse>;
  AssessCalibrationCoverage(request: AssessCalibrationCoverageRequest): Promise<AssessCalibrationCoverageResponse>;
  Run3DPoseEstimation(request: Run3DPoseEstimationRequest): Promise<Run3DPoseEstimationResponse>;
  ComputeDinoEmbeddings(request: ComputeDinoEmbeddingsRequest): Promise<ComputeDinoEmbeddingsResponse>;
  ComputeDinoImageEmbedding(request: ComputeDinoImageEmbeddingRequest): Promise<ComputeDinoImageEmbeddingResponse>;
  TrainLocateHead(request: TrainLocateHeadRequest): Promise<TrainLocateHeadResponse>;
  SegmentMask(request: SegmentMaskRequest): Promise<SegmentMaskResponse>;
  ComputeOrientationReference(
    request: ComputeOrientationReferenceRequest,
  ): Promise<ComputeOrientationReferenceResponse>;
  DetectScenePlane(request: DetectScenePlaneRequest): Promise<DetectScenePlaneResponse>;
  /** ── Roboflow local-container inference ── */
  PreloadRoboflowModel(request: PreloadRoboflowModelRequest): Promise<PreloadRoboflowModelResponse>;
  PreloadRoboflowWorkflow(request: PreloadRoboflowWorkflowRequest): Promise<PreloadRoboflowWorkflowResponse>;
  RunRoboflowDetection(request: RunRoboflowDetectionRequest): Promise<RunRoboflowDetectionResponse>;
  RunRoboflowWorkflow(request: RunRoboflowWorkflowRequest): Promise<RunRoboflowWorkflowResponse>;
}

export const VisionBotServiceServiceName = "visionbot.VisionBotService";
export class VisionBotServiceClientImpl implements VisionBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || VisionBotServiceServiceName;
    this.rpc = rpc;
    this.GetModels = this.GetModels.bind(this);
    this.RunCheckpointBasedInference = this.RunCheckpointBasedInference.bind(this);
    this.RunPlaneProjection = this.RunPlaneProjection.bind(this);
    this.DetectBlobs = this.DetectBlobs.bind(this);
    this.DetectShapes = this.DetectShapes.bind(this);
    this.DetectTextPrompt = this.DetectTextPrompt.bind(this);
    this.Classify = this.Classify.bind(this);
    this.GetChessboardCorners = this.GetChessboardCorners.bind(this);
    this.GetCameraChessboardTransform = this.GetCameraChessboardTransform.bind(this);
    this.CalibrateCamera = this.CalibrateCamera.bind(this);
    this.CalibrateCameraIntrinsics = this.CalibrateCameraIntrinsics.bind(this);
    this.CalibrateCameraExtrinsics = this.CalibrateCameraExtrinsics.bind(this);
    this.AssessCalibrationCoverage = this.AssessCalibrationCoverage.bind(this);
    this.Run3DPoseEstimation = this.Run3DPoseEstimation.bind(this);
    this.ComputeDinoEmbeddings = this.ComputeDinoEmbeddings.bind(this);
    this.ComputeDinoImageEmbedding = this.ComputeDinoImageEmbedding.bind(this);
    this.TrainLocateHead = this.TrainLocateHead.bind(this);
    this.SegmentMask = this.SegmentMask.bind(this);
    this.ComputeOrientationReference = this.ComputeOrientationReference.bind(this);
    this.DetectScenePlane = this.DetectScenePlane.bind(this);
    this.PreloadRoboflowModel = this.PreloadRoboflowModel.bind(this);
    this.PreloadRoboflowWorkflow = this.PreloadRoboflowWorkflow.bind(this);
    this.RunRoboflowDetection = this.RunRoboflowDetection.bind(this);
    this.RunRoboflowWorkflow = this.RunRoboflowWorkflow.bind(this);
  }
  GetModels(request: Empty): Promise<ModelList> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetModels", data);
    return promise.then((data) => ModelList.decode(new BinaryReader(data)));
  }

  RunCheckpointBasedInference(
    request: RunCheckpointBasedInferenceRequest,
  ): Promise<RunCheckpointBasedInferenceResponse> {
    const data = RunCheckpointBasedInferenceRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RunCheckpointBasedInference", data);
    return promise.then((data) => RunCheckpointBasedInferenceResponse.decode(new BinaryReader(data)));
  }

  RunPlaneProjection(request: RunPlaneProjectionRequest): Promise<RunPlaneProjectionResponse> {
    const data = RunPlaneProjectionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RunPlaneProjection", data);
    return promise.then((data) => RunPlaneProjectionResponse.decode(new BinaryReader(data)));
  }

  DetectBlobs(request: DetectBlobsRequest): Promise<DetectBlobsResponse> {
    const data = DetectBlobsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DetectBlobs", data);
    return promise.then((data) => DetectBlobsResponse.decode(new BinaryReader(data)));
  }

  DetectShapes(request: DetectShapesRequest): Promise<DetectShapesResponse> {
    const data = DetectShapesRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DetectShapes", data);
    return promise.then((data) => DetectShapesResponse.decode(new BinaryReader(data)));
  }

  DetectTextPrompt(request: DetectTextPromptRequest): Promise<DetectTextPromptResponse> {
    const data = DetectTextPromptRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DetectTextPrompt", data);
    return promise.then((data) => DetectTextPromptResponse.decode(new BinaryReader(data)));
  }

  Classify(request: ClassifyRequest): Promise<ClassifyResponse> {
    const data = ClassifyRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "Classify", data);
    return promise.then((data) => ClassifyResponse.decode(new BinaryReader(data)));
  }

  GetChessboardCorners(request: GetChessboardCornersRequest): Promise<GetChessboardCornersResponse> {
    const data = GetChessboardCornersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetChessboardCorners", data);
    return promise.then((data) => GetChessboardCornersResponse.decode(new BinaryReader(data)));
  }

  GetCameraChessboardTransform(
    request: GetCameraChessboardTransformRequest,
  ): Promise<GetCameraChessboardTransformResponse> {
    const data = GetCameraChessboardTransformRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetCameraChessboardTransform", data);
    return promise.then((data) => GetCameraChessboardTransformResponse.decode(new BinaryReader(data)));
  }

  CalibrateCamera(request: CalibrateCameraRequest): Promise<CalibrateCameraResponse> {
    const data = CalibrateCameraRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalibrateCamera", data);
    return promise.then((data) => CalibrateCameraResponse.decode(new BinaryReader(data)));
  }

  CalibrateCameraIntrinsics(request: CalibrateCameraIntrinsicsRequest): Promise<CalibrateCameraIntrinsicsResponse> {
    const data = CalibrateCameraIntrinsicsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalibrateCameraIntrinsics", data);
    return promise.then((data) => CalibrateCameraIntrinsicsResponse.decode(new BinaryReader(data)));
  }

  CalibrateCameraExtrinsics(request: CalibrateCameraExtrinsicsRequest): Promise<CalibrateCameraExtrinsicsResponse> {
    const data = CalibrateCameraExtrinsicsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalibrateCameraExtrinsics", data);
    return promise.then((data) => CalibrateCameraExtrinsicsResponse.decode(new BinaryReader(data)));
  }

  AssessCalibrationCoverage(request: AssessCalibrationCoverageRequest): Promise<AssessCalibrationCoverageResponse> {
    const data = AssessCalibrationCoverageRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "AssessCalibrationCoverage", data);
    return promise.then((data) => AssessCalibrationCoverageResponse.decode(new BinaryReader(data)));
  }

  Run3DPoseEstimation(request: Run3DPoseEstimationRequest): Promise<Run3DPoseEstimationResponse> {
    const data = Run3DPoseEstimationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "Run3DPoseEstimation", data);
    return promise.then((data) => Run3DPoseEstimationResponse.decode(new BinaryReader(data)));
  }

  ComputeDinoEmbeddings(request: ComputeDinoEmbeddingsRequest): Promise<ComputeDinoEmbeddingsResponse> {
    const data = ComputeDinoEmbeddingsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ComputeDinoEmbeddings", data);
    return promise.then((data) => ComputeDinoEmbeddingsResponse.decode(new BinaryReader(data)));
  }

  ComputeDinoImageEmbedding(request: ComputeDinoImageEmbeddingRequest): Promise<ComputeDinoImageEmbeddingResponse> {
    const data = ComputeDinoImageEmbeddingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ComputeDinoImageEmbedding", data);
    return promise.then((data) => ComputeDinoImageEmbeddingResponse.decode(new BinaryReader(data)));
  }

  TrainLocateHead(request: TrainLocateHeadRequest): Promise<TrainLocateHeadResponse> {
    const data = TrainLocateHeadRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "TrainLocateHead", data);
    return promise.then((data) => TrainLocateHeadResponse.decode(new BinaryReader(data)));
  }

  SegmentMask(request: SegmentMaskRequest): Promise<SegmentMaskResponse> {
    const data = SegmentMaskRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SegmentMask", data);
    return promise.then((data) => SegmentMaskResponse.decode(new BinaryReader(data)));
  }

  ComputeOrientationReference(
    request: ComputeOrientationReferenceRequest,
  ): Promise<ComputeOrientationReferenceResponse> {
    const data = ComputeOrientationReferenceRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ComputeOrientationReference", data);
    return promise.then((data) => ComputeOrientationReferenceResponse.decode(new BinaryReader(data)));
  }

  DetectScenePlane(request: DetectScenePlaneRequest): Promise<DetectScenePlaneResponse> {
    const data = DetectScenePlaneRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DetectScenePlane", data);
    return promise.then((data) => DetectScenePlaneResponse.decode(new BinaryReader(data)));
  }

  PreloadRoboflowModel(request: PreloadRoboflowModelRequest): Promise<PreloadRoboflowModelResponse> {
    const data = PreloadRoboflowModelRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "PreloadRoboflowModel", data);
    return promise.then((data) => PreloadRoboflowModelResponse.decode(new BinaryReader(data)));
  }

  PreloadRoboflowWorkflow(request: PreloadRoboflowWorkflowRequest): Promise<PreloadRoboflowWorkflowResponse> {
    const data = PreloadRoboflowWorkflowRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "PreloadRoboflowWorkflow", data);
    return promise.then((data) => PreloadRoboflowWorkflowResponse.decode(new BinaryReader(data)));
  }

  RunRoboflowDetection(request: RunRoboflowDetectionRequest): Promise<RunRoboflowDetectionResponse> {
    const data = RunRoboflowDetectionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RunRoboflowDetection", data);
    return promise.then((data) => RunRoboflowDetectionResponse.decode(new BinaryReader(data)));
  }

  RunRoboflowWorkflow(request: RunRoboflowWorkflowRequest): Promise<RunRoboflowWorkflowResponse> {
    const data = RunRoboflowWorkflowRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RunRoboflowWorkflow", data);
    return promise.then((data) => RunRoboflowWorkflowResponse.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/vision_bot_service.proto",
    "package": "visionbot",
    "dependency": [
      "google/protobuf/empty.proto",
      "messenger/geometry.proto",
      "messenger/camera_bot_service.proto",
      "messenger/teleop_bot_service.proto",
    ],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Blob2D",
      "field": [{
        "name": "score",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "score",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "contour",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "contour",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "area",
        "number": 8,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "area",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "class_id",
        "number": 9,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "classId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "class_name",
        "number": 10,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "className",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mask_rle",
        "number": 11,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "maskRle",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mask_width",
        "number": 12,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "maskWidth",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mask_height",
        "number": 13,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "maskHeight",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_area", "options": undefined },
        { "name": "_class_id", "options": undefined },
        { "name": "_class_name", "options": undefined },
        { "name": "_mask_rle", "options": undefined },
        { "name": "_mask_width", "options": undefined },
        { "name": "_mask_height", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Detection2D",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "width",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "width",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "height",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "height",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rotation",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rotation",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "score",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "score",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "class_id",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "classId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "class_name",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "className",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_class_id", "options": undefined }, { "name": "_class_name", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LocateMatch",
      "field": [{
        "name": "detection",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Detection2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detection",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "segment",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Blob2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "segment",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_segment", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "OrientationReference",
      "field": [{
        "name": "reference_contour",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "referenceContour",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Contour2D",
      "field": [{
        "name": "points",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "points",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeOrientationReferenceRequest",
      "field": [{
        "name": "contour",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "contour",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sibling_contours",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Contour2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "siblingContours",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeOrientationReferenceData",
      "field": [{
        "name": "is_reliable",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isReliable",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.OrientationReference",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rejection",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.OrientationReferenceRejection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rejection",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeOrientationReferenceResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ComputeOrientationReferenceData",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Model",
      "field": [{
        "name": "model_path",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ModelList",
      "field": [{
        "name": "models",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Model",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "models",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunCheckpointBasedInferenceRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_path",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_type",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "thresholding_params",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.RunCheckpointBasedInferenceRequest.ThresholdingParamsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "thresholdingParams",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "include_masks",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "includeMasks",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [{
        "name": "ThresholdingParamsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_include_masks", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunCheckpointBasedInferenceResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CheckpointBasedInferenceResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CheckpointBasedInferenceResult",
      "field": [{
        "name": "blobs",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateMatch",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blobs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "model_path",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }, {
        "name": "_model_path",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Error",
      "field": [{
        "name": "code",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.ErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunPlaneProjectionRequest",
      "field": [{
        "name": "detections",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateMatch",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detections",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "image",
        "number": 2,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "depth_image",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "depthImage",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "camera_params",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraParams",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "plane_method",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PlaneDetectionMethod",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "planeMethod",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "include_debug_visualization",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "includeDebugVisualization",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "grasp_frame",
        "number": 7,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.GraspFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "graspFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "orientation_reference",
        "number": 8,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.OrientationReference",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "orientationReference",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_depth_image", "options": undefined }, {
        "name": "_include_debug_visualization",
        "options": undefined,
      }, { "name": "_orientation_reference", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraParams",
      "field": [{
        "name": "intrinsics",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraIntrinsics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intrinsics",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "extrinsics",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "extrinsics",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "extrinsics_kind",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.ExtrinsicsKind",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "extrinsicsKind",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "robot_pose",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "robotPose",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_robot_pose", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PlaneDetectionMethod",
      "field": [{
        "name": "manual",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ManualPlane",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "manual",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "geometric",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.GeometricPlane",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "geometric",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "learned",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.LearnedPlane",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "learned",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "method", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ManualPlane",
      "field": [{
        "name": "origin",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "origin",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "plus_x",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "plusX",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "plus_y",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "plusY",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "object_height",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "objectHeight",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_object_height", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GeometricPlane",
      "field": [{
        "name": "max_iterations",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxIterations",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "distance_threshold",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "distanceThreshold",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "min_samples",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "minSamples",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "max_tilt_angle",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "maxTiltAngle",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_max_iterations", "options": undefined },
        { "name": "_distance_threshold", "options": undefined },
        { "name": "_min_samples", "options": undefined },
        { "name": "_max_tilt_angle", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LearnedPlane",
      "field": [{
        "name": "model_path",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunPlaneProjectionResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PlaneProjectionResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PlaneProjectionResult",
      "field": [{
        "name": "detections",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Detection3D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detections",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "debug_visualization",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "debugVisualization",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }, {
        "name": "_debug_visualization",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Detection3D",
      "field": [{
        "name": "blob_2d",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Detection2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blob2d",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "pose",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "surface_normal",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "surfaceNormal",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "score",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "score",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "inlier_ratio",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inlierRatio",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "extents",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "extents",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "segment",
        "number": 7,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Blob2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "segment",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_inlier_ratio", "options": undefined }, { "name": "_extents", "options": undefined }, {
        "name": "_segment",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "BlobDetectionParams",
      "field": [{
        "name": "min_threshold",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "minThreshold",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max_threshold",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxThreshold",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "min_area",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "minArea",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max_area",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxArea",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_by_circularity",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filterByCircularity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_by_convexity",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filterByConvexity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_by_inertia",
        "number": 7,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filterByInertia",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "min_circularity",
        "number": 8,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "minCircularity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max_circularity",
        "number": 9,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxCircularity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "invert_image",
        "number": 10,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "invertImage",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectBlobsRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "params",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.BlobDetectionParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "params",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectBlobsResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.BlobList",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "BlobList",
      "field": [{
        "name": "blobs",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateMatch",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blobs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ShapeDetectionParams",
      "field": [{
        "name": "min_scale",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "minScale",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max_scale",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxScale",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max_rotation",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "maxRotation",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "match_threshold",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "matchThreshold",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_intersections",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filterIntersections",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reject_on_edge",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rejectOnEdge",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectShapesRequest",
      "field": [{
        "name": "template_image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "templateImage",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "target_image",
        "number": 2,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetImage",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "params",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ShapeDetectionParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "params",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectShapesResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.BlobList",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TextPromptDetectionParams",
      "field": [{
        "name": "prompt",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "prompt",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "use_sam",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "useSam",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "box_threshold",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "boxThreshold",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "text_threshold",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "textThreshold",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectTextPromptRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "params",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.TextPromptDetectionParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "params",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectTextPromptResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.BlobList",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClassifyRequest",
      "field": [{
        "name": "encoded_frame",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "encodedFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "encoded_template_images",
        "number": 2,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "encodedTemplateImages",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClassifyResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ClassifyResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClassifyResult",
      "field": [{
        "name": "scores",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "scores",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Chessboard",
      "field": [{
        "name": "kind",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "kind",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "num_rows",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "numRows",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "num_cols",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "numCols",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "square_size",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "squareSize",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "aruco_dict",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "arucoDict",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "marker_size",
        "number": 6,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "markerSize",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_aruco_dict", "options": undefined }, { "name": "_marker_size", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraIntrinsicsMsg",
      "field": [{
        "name": "fx",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "fy",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppx",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppy",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "width",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "width",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "height",
        "number": 6,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "height",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 7,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraIntrinsicsExtendedMsg",
      "field": [{
        "name": "fx",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "fy",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppx",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppy",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "width",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "width",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "height",
        "number": 6,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "height",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "distortion_coefficients",
        "number": 7,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "distortionCoefficients",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "distortion_model",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "distortionModel",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 9,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetChessboardCornersRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetChessboardCornersResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ChessboardCornersResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ChessboardCornersResult",
      "field": [{
        "name": "is_detected",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isDetected",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "corners",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "corners",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetCameraChessboardTransformRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "intrinsics",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraIntrinsicsMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intrinsics",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetCameraChessboardTransformResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraRequest",
      "field": [{
        "name": "images",
        "number": 1,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "images",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "poses",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poses",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.IntrinsicCalibrationResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "IntrinsicCalibrationResult",
      "field": [{
        "name": "intrinsics",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraIntrinsicsMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intrinsics",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "gripper_to_cam",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gripperToCam",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_gripper_to_cam", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraIntrinsicsRequest",
      "field": [{
        "name": "images",
        "number": 1,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "images",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraIntrinsicsResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraIntrinsicsExtendedMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraExtrinsicsRequest",
      "field": [{
        "name": "images",
        "number": 1,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "images",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "poses",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poses",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "intrinsics",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraIntrinsicsExtendedMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intrinsics",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "mount_type",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "mountType",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrateCameraExtrinsicsResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "AssessCalibrationCoverageRequest",
      "field": [{
        "name": "images",
        "number": 1,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "images",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "chessboard",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Chessboard",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "chessboard",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "calibration_type",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "calibrationType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "poses",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poses",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "intrinsics",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraIntrinsicsExtendedMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intrinsics",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CoverageBucketMsg",
      "field": [{
        "name": "key",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "key",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filled",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filled",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "QualityIssueMsg",
      "field": [{
        "name": "index",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "index",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "issue",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "issue",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrationRecommendationMsg",
      "field": [{
        "name": "kind",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "kind",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "detail",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detail",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CalibrationCoverageResultMsg",
      "field": [{
        "name": "coverage_buckets",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.CoverageBucketMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "coverageBuckets",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "per_view_errors",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "perViewErrors",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reprojection_error",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reprojectionError",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "quality_issues",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.QualityIssueMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "qualityIssues",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "converged",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "converged",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "recommendation",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CalibrationRecommendationMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recommendation",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_reprojection_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "AssessCalibrationCoverageResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CalibrationCoverageResultMsg",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveShape",
      "field": [{
        "name": "shape_type",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.PrimitiveShapeType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "shapeType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dim_x",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "dimX",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dim_y",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "dimY",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dim_z",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "dimZ",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CadModelFile",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "format",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "format",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "content_hash",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "contentHash",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "units",
        "number": 4,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.CadModelUnits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "units",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ObjectReference",
      "field": [{
        "name": "text_prompt",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "textPrompt",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "cad_model_path",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cadModelPath",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference_images",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ReferenceImageSet",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "referenceImages",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "primitive_shape",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PrimitiveShape",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "primitiveShape",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "cad_model_file",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CadModelFile",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cadModelFile",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "reference", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ReferenceImageSet",
      "field": [{
        "name": "rgb_images",
        "number": 1,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rgbImages",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "depth_images",
        "number": 2,
        "label": 3,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "depthImages",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "camera_poses",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraPoses",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Run3DPoseEstimationRequest",
      "field": [{
        "name": "detections",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateMatch",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detections",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "depth_image",
        "number": 2,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "depthImage",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "camera_params",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraParams",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "pose_method",
        "number": 4,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.PoseEstimationMethod",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poseMethod",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "object_reference",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ObjectReference",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "objectReference",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "confidence_threshold",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "confidenceThreshold",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "max_detections",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "maxDetections",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "include_debug_visualization",
        "number": 8,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "includeDebugVisualization",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "depth_outlier_percentile",
        "number": 9,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "depthOutlierPercentile",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "ransac_restarts",
        "number": 10,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "ransacRestarts",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "voxel_size",
        "number": 11,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 6,
        "jsonName": "voxelSize",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_object_reference", "options": undefined },
        { "name": "_confidence_threshold", "options": undefined },
        { "name": "_max_detections", "options": undefined },
        { "name": "_include_debug_visualization", "options": undefined },
        { "name": "_depth_outlier_percentile", "options": undefined },
        { "name": "_ransac_restarts", "options": undefined },
        { "name": "_voxel_size", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Run3DPoseEstimationResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PoseEstimation3DResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PoseEstimation3DResult",
      "field": [{
        "name": "detections",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Detection3D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detections",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "debug_visualization",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "debugVisualization",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }, {
        "name": "_debug_visualization",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeDinoEmbeddingsRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "precision",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "precision",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "locate_head",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.LocateHeadProto",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "locateHead",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "omit_tensor",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "omitTensor",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_locate_head", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeDinoEmbeddingsResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.DinoEmbeddingsTensor",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DinoEmbeddingsTensor",
      "field": [{
        "name": "grid_h",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gridH",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "grid_w",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gridW",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "embedding_dim",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "embeddingDim",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "values",
        "number": 4,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "values",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "input_h",
        "number": 6,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputH",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "input_w",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputW",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "padding_top",
        "number": 8,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paddingTop",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "padding_left",
        "number": 9,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paddingLeft",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap_fp16",
        "number": 10,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmapFp16",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_heatmap_fp16", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeDinoImageEmbeddingRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "precision",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "precision",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ComputeDinoImageEmbeddingResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.DinoImageEmbedding",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DinoImageEmbedding",
      "field": [{
        "name": "embedding_dim",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "embeddingDim",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "values",
        "number": 2,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "values",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PointPrompt",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "positive",
        "number": 3,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "positive",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Box2DXyxy",
      "field": [{
        "name": "x1",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x1",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y1",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y1",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "x2",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x2",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y2",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y2",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "points",
        "number": 5,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.PointPrompt",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "points",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "HeatmapSample",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "score",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "score",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SegmentMaskRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "boxes",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Box2DXyxy",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "boxes",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap_samples",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.HeatmapSample",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmapSamples",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap_threshold",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmapThreshold",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "method",
        "number": 5,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.SegmentationMethod",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "method",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap_dense",
        "number": 6,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmapDense",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap_width",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmapWidth",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "heatmap_height",
        "number": 8,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "heatmapHeight",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_heatmap_width", "options": undefined }, {
        "name": "_heatmap_height",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SegmentMaskResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.MaskSegmentationResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "MaskSegmentationResult",
      "field": [{
        "name": "blobs",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Blob2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blobs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "was_segmented",
        "number": 2,
        "label": 3,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "wasSegmented",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LocateClick",
      "field": [{
        "name": "nx",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "nx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ny",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ny",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "positive",
        "number": 3,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "positive",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ReferenceVector",
      "field": [{
        "name": "values",
        "number": 1,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "values",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "MlpLocateHeadProto",
      "field": [{
        "name": "input_dim",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputDim",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "hidden",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "hidden",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w1",
        "number": 3,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w1",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "b1",
        "number": 4,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "b1",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w2",
        "number": 5,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w2",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "b2",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "b2",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LogisticLocateHeadProto",
      "field": [{
        "name": "input_dim",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputDim",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w",
        "number": 2,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "b",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "b",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LocateHeadProto",
      "field": [{
        "name": "mlp",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.MlpLocateHeadProto",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "mlp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "logistic",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.LogisticLocateHeadProto",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "logistic",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "head", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TrainLocateHeadRequest",
      "field": [{
        "name": "session_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sessionId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "seq",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seq",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "image",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "precision",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "precision",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "clicks",
        "number": 6,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateClick",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clicks",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "committed_positives",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.ReferenceVector",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "committedPositives",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "committed_negatives",
        "number": 8,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.ReferenceVector",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "committedNegatives",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "head_kind",
        "number": 9,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.LocateHeadKind",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "headKind",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LocateHeatmap",
      "field": [{
        "name": "grid_h",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gridH",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "grid_w",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gridW",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "values",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "values",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "input_h",
        "number": 4,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputH",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "input_w",
        "number": 5,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inputW",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "padding_top",
        "number": 6,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paddingTop",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "padding_left",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paddingLeft",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_version",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelVersion",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TrainLocateHeadResult",
      "field": [{
        "name": "seq",
        "number": 1,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seq",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "superseded",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "superseded",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "head",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.LocateHeadProto",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "head",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "heatmap",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.LocateHeatmap",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "heatmap",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "click_embeddings",
        "number": 5,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.ReferenceVector",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clickEmbeddings",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TrainLocateHeadResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.TrainLocateHeadResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectScenePlaneRequest",
      "field": [{
        "name": "depth_image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "depthImage",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "camera_params",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CameraParams",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraParams",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ransac",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.GeometricPlane",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ransac",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "fixed_threshold",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fixedThreshold",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "region",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Blob2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "region",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "seed_points",
        "number": 6,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seedPoints",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "downsample_stride",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "downsampleStride",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "min_depth_m",
        "number": 8,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "minDepthM",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "max_depth_m",
        "number": 9,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "maxDepthM",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "max_candidates",
        "number": 10,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "maxCandidates",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "include_inlier_mask",
        "number": 11,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 6,
        "jsonName": "includeInlierMask",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_fixed_threshold", "options": undefined },
        { "name": "_region", "options": undefined },
        { "name": "_downsample_stride", "options": undefined },
        { "name": "_min_depth_m", "options": undefined },
        { "name": "_max_depth_m", "options": undefined },
        { "name": "_max_candidates", "options": undefined },
        { "name": "_include_inlier_mask", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ScenePlane",
      "field": [{
        "name": "plane_pose",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "planePose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "surface_normal",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Point",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "surfaceNormal",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "inlier_ratio",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inlierRatio",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "inlier_count",
        "number": 4,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "inlierCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rms_error_m",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rmsErrorM",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tilt_angle_deg",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tiltAngleDeg",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "median_depth_m",
        "number": 7,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "medianDepthM",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "inlier_mask_rle",
        "number": 8,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "inlierMaskRle",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mask_width",
        "number": 9,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "maskWidth",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mask_height",
        "number": 10,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "maskHeight",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_median_depth_m", "options": undefined },
        { "name": "_inlier_mask_rle", "options": undefined },
        { "name": "_mask_width", "options": undefined },
        { "name": "_mask_height", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SeedWindow",
      "field": [{
        "name": "seed_index",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seedIndex",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "contour_points",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "contourPoints",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ScenePlaneResult",
      "field": [{
        "name": "candidates",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.ScenePlane",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "candidates",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ignored_seed_indices",
        "number": 2,
        "label": 3,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ignoredSeedIndices",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "seed_windows",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.SeedWindow",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seedWindows",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DetectScenePlaneResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.ScenePlaneResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowModelRequest",
      "field": [{
        "name": "model_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "api_key",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "apiKey",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowModelResult",
      "field": [{
        "name": "model_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "load_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "loadTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_load_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowModelResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PreloadRoboflowModelResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowWorkflowRequest",
      "field": [{
        "name": "workspace_name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workspaceName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "workflow_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workflowId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "api_key",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "apiKey",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowWorkflowResult",
      "field": [{
        "name": "workspace_name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workspaceName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "workflow_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workflowId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "load_time_ms",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "loadTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_load_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PreloadRoboflowWorkflowResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.PreloadRoboflowWorkflowResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowDetectionRequest",
      "field": [{
        "name": "model_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "api_key",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "apiKey",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "image",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "thresholding_params",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.RunRoboflowDetectionRequest.ThresholdingParamsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "thresholdingParams",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [{
        "name": "ThresholdingParamsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowDetectionResult",
      "field": [{
        "name": "blobs",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.LocateMatch",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blobs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowDetectionResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.RunRoboflowDetectionResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowWorkflowRequest",
      "field": [{
        "name": "workspace_name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workspaceName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "workflow_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "workflowId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "api_key",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "apiKey",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "image",
        "number": 4,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowWorkflowResult",
      "field": [{
        "name": "outputs_json",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "outputsJson",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunRoboflowWorkflowResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.RunRoboflowWorkflowResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "OrientationReferenceRejection",
      "value": [{ "name": "ORIENTATION_REFERENCE_REJECTION_UNSPECIFIED", "number": 0, "options": undefined }, {
        "name": "ORIENTATION_REFERENCE_REJECTION_SYMMETRIC",
        "number": 1,
        "options": undefined,
      }, { "name": "ORIENTATION_REFERENCE_REJECTION_SCENE_INCONSISTENT", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ErrorCode",
      "value": [
        { "name": "UNKNOWN_ERROR", "number": 0, "options": undefined },
        { "name": "MODEL_NOT_FOUND", "number": 1, "options": undefined },
        { "name": "INVALID_IMAGE", "number": 2, "options": undefined },
        { "name": "INFERENCE_FAILED", "number": 3, "options": undefined },
        { "name": "INVALID_MODEL_TYPE", "number": 4, "options": undefined },
        { "name": "INVALID_THRESHOLDING_PARAMS", "number": 5, "options": undefined },
        { "name": "MISSING_DEPTH_IMAGE", "number": 6, "options": undefined },
        { "name": "PLANE_ESTIMATION_FAILED", "number": 7, "options": undefined },
        { "name": "INVALID_CAMERA_PARAMS", "number": 8, "options": undefined },
        { "name": "NOT_IMPLEMENTED", "number": 9, "options": undefined },
        { "name": "TEMPLATE_TOO_SMALL", "number": 10, "options": undefined },
        { "name": "INVALID_BLOB_DETECTION_PARAMS", "number": 11, "options": undefined },
        { "name": "CALIBRATION_FAILED", "number": 12, "options": undefined },
        { "name": "INVALID_OBJECT_REFERENCE", "number": 13, "options": undefined },
        { "name": "POSE_ESTIMATION_FAILED", "number": 14, "options": undefined },
        { "name": "SCENE_PLANE_NOT_FOUND", "number": 15, "options": undefined },
        { "name": "INVALID_REGION_MASK", "number": 16, "options": undefined },
        { "name": "ROBOFLOW_UNAVAILABLE", "number": 17, "options": undefined },
        { "name": "ROBOFLOW_NOT_PRELOADED", "number": 18, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GraspFrame",
      "value": [{ "name": "OBJECT", "number": 0, "options": undefined }, {
        "name": "PLANE",
        "number": 1,
        "options": undefined,
      }, { "name": "WORLD", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ExtrinsicsKind",
      "value": [{ "name": "BASE", "number": 0, "options": undefined }, {
        "name": "TCP",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PoseEstimationMethod",
      "value": [
        { "name": "OBB_DEPTH", "number": 0, "options": undefined },
        { "name": "ICP", "number": 1, "options": undefined },
        { "name": "FOUNDATION_POSE", "number": 2, "options": undefined },
        { "name": "OBB_ICP", "number": 3, "options": undefined },
        { "name": "FPFH_ICP", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveShapeType",
      "value": [{ "name": "BOX", "number": 0, "options": undefined }, {
        "name": "CYLINDER",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CadModelUnits",
      "value": [
        { "name": "CAD_MODEL_UNITS_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "CAD_MODEL_UNITS_METERS", "number": 1, "options": undefined },
        { "name": "CAD_MODEL_UNITS_MILLIMETERS", "number": 2, "options": undefined },
        { "name": "CAD_MODEL_UNITS_CENTIMETERS", "number": 3, "options": undefined },
        { "name": "CAD_MODEL_UNITS_INCHES", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SegmentationMethod",
      "value": [
        { "name": "SEGMENTATION_METHOD_SAM2", "number": 0, "options": undefined },
        { "name": "SEGMENTATION_METHOD_GUIDED_FILTER", "number": 1, "options": undefined },
        { "name": "SEGMENTATION_METHOD_BILATERAL_SOLVER", "number": 2, "options": undefined },
        { "name": "SEGMENTATION_METHOD_HEATMAP_THRESHOLD", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "LocateHeadKind",
      "value": [{ "name": "LOCATE_HEAD_KIND_UNSPECIFIED", "number": 0, "options": undefined }, {
        "name": "LOCATE_HEAD_KIND_MLP",
        "number": 1,
        "options": undefined,
      }, { "name": "LOCATE_HEAD_KIND_LOGISTIC", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "VisionBotService",
      "method": [{
        "name": "GetModels",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".visionbot.ModelList",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RunCheckpointBasedInference",
        "inputType": ".visionbot.RunCheckpointBasedInferenceRequest",
        "outputType": ".visionbot.RunCheckpointBasedInferenceResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RunPlaneProjection",
        "inputType": ".visionbot.RunPlaneProjectionRequest",
        "outputType": ".visionbot.RunPlaneProjectionResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "DetectBlobs",
        "inputType": ".visionbot.DetectBlobsRequest",
        "outputType": ".visionbot.DetectBlobsResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "DetectShapes",
        "inputType": ".visionbot.DetectShapesRequest",
        "outputType": ".visionbot.DetectShapesResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "DetectTextPrompt",
        "inputType": ".visionbot.DetectTextPromptRequest",
        "outputType": ".visionbot.DetectTextPromptResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Classify",
        "inputType": ".visionbot.ClassifyRequest",
        "outputType": ".visionbot.ClassifyResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetChessboardCorners",
        "inputType": ".visionbot.GetChessboardCornersRequest",
        "outputType": ".visionbot.GetChessboardCornersResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetCameraChessboardTransform",
        "inputType": ".visionbot.GetCameraChessboardTransformRequest",
        "outputType": ".visionbot.GetCameraChessboardTransformResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CalibrateCamera",
        "inputType": ".visionbot.CalibrateCameraRequest",
        "outputType": ".visionbot.CalibrateCameraResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CalibrateCameraIntrinsics",
        "inputType": ".visionbot.CalibrateCameraIntrinsicsRequest",
        "outputType": ".visionbot.CalibrateCameraIntrinsicsResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CalibrateCameraExtrinsics",
        "inputType": ".visionbot.CalibrateCameraExtrinsicsRequest",
        "outputType": ".visionbot.CalibrateCameraExtrinsicsResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "AssessCalibrationCoverage",
        "inputType": ".visionbot.AssessCalibrationCoverageRequest",
        "outputType": ".visionbot.AssessCalibrationCoverageResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Run3DPoseEstimation",
        "inputType": ".visionbot.Run3DPoseEstimationRequest",
        "outputType": ".visionbot.Run3DPoseEstimationResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ComputeDinoEmbeddings",
        "inputType": ".visionbot.ComputeDinoEmbeddingsRequest",
        "outputType": ".visionbot.ComputeDinoEmbeddingsResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ComputeDinoImageEmbedding",
        "inputType": ".visionbot.ComputeDinoImageEmbeddingRequest",
        "outputType": ".visionbot.ComputeDinoImageEmbeddingResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "TrainLocateHead",
        "inputType": ".visionbot.TrainLocateHeadRequest",
        "outputType": ".visionbot.TrainLocateHeadResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SegmentMask",
        "inputType": ".visionbot.SegmentMaskRequest",
        "outputType": ".visionbot.SegmentMaskResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ComputeOrientationReference",
        "inputType": ".visionbot.ComputeOrientationReferenceRequest",
        "outputType": ".visionbot.ComputeOrientationReferenceResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "DetectScenePlane",
        "inputType": ".visionbot.DetectScenePlaneRequest",
        "outputType": ".visionbot.DetectScenePlaneResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "PreloadRoboflowModel",
        "inputType": ".visionbot.PreloadRoboflowModelRequest",
        "outputType": ".visionbot.PreloadRoboflowModelResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "PreloadRoboflowWorkflow",
        "inputType": ".visionbot.PreloadRoboflowWorkflowRequest",
        "outputType": ".visionbot.PreloadRoboflowWorkflowResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RunRoboflowDetection",
        "inputType": ".visionbot.RunRoboflowDetectionRequest",
        "outputType": ".visionbot.RunRoboflowDetectionResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RunRoboflowWorkflow",
        "inputType": ".visionbot.RunRoboflowWorkflowRequest",
        "outputType": ".visionbot.RunRoboflowWorkflowResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/visionbot",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [6, 0],
        "span": [10, 0, 45, 1],
        "leadingComments": " @language: python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0, 2, 20],
        "span": [40, 2, 95],
        "leadingComments": " ── Roboflow local-container inference ──\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0],
        "span": [50, 0, 59, 1],
        "leadingComments":
          " A post-segmentation instance: precise contour + mask. No bounding box —\n center/extents are derived from the contour by consumers. See Detection2D\n for the pre-segmentation detector box.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 5],
        "span": [56, 2, 31],
        "leadingComments": "",
        "trailingComments": " RLE-encoded dense segmentation mask (from SAM2)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 6],
        "span": [57, 2, 33],
        "leadingComments": "",
        "trailingComments": " mask dimensions (matches source image dimensions)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1],
        "span": [64, 0, 73, 1],
        "leadingComments":
          " A pre-segmentation detector result: the coarse (optionally oriented) box a\n detector emits. Used as the SAM2 prompt and as the fallback shape when\n segmentation is off or produces no contour.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 4],
        "span": [69, 2, 21],
        "leadingComments": "",
        "trailingComments": " radians\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2],
        "span": [77, 0, 80, 1],
        "leadingComments":
          " Pairs a detector result with its optional segmentation. `segment` is unset\n when segmentation is disabled or returns no contour.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3],
        "span": [86, 0, 88, 1],
        "leadingComments":
          " A persisted canonical orientation frame for a taught locate target. The\n reference_contour is normalized (centroid-centered, sqrt(area)-scaled,\n PCA-rotated, arc-length-resampled to a fixed point count). Its pose encodes\n the canonical frame; inference registers detected contours against it.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0],
        "span": [98, 0, 104, 1],
        "leadingComments":
          " Why a taught contour did not yield a usable orientation frame. The two\n failures have different remedies, so the UI must be able to tell them apart:\n a symmetric part can never work, while an inconsistent scene usually means\n the segmentation needs better lighting or a tighter ROI before re-teaching.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0, 2, 1],
        "span": [101, 2, 48],
        "leadingComments": " The shape is rotationally ambiguous (near-square, circular).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0, 2, 2],
        "span": [103, 2, 57],
        "leadingComments": " The teach scene's own matches could not be registered to the primary.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 0],
        "span": [108, 2, 40],
        "leadingComments": " Taught-instance contour in image-pixel space (the primary match segment).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 1],
        "span": [114, 2, 42],
        "leadingComments":
          " The teach scene's OTHER matches, same space as `contour`. The primary is\n accepted as a reference only if every one of these registers to it, which\n is how a too-noisy segmentation gets caught at teach time instead of\n flapping at inference. Empty (a single-match scene, or an older client)\n reproduces the previous behaviour exactly.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 0],
        "span": [119, 2, 23],
        "leadingComments": " True when the taught shape supports a stable, non-symmetric frame.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 1],
        "span": [121, 2, 37],
        "leadingComments": " Present (populated) only when is_reliable is true.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 2],
        "span": [123, 2, 46],
        "leadingComments": " Set only when is_reliable is false.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 8],
        "span": [134, 0, 136, 1],
        "leadingComments": " Available model information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10],
        "span": [143, 0, 154, 1],
        "leadingComments": " Request to run inference on an image\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 0],
        "span": [145, 2, 18],
        "leadingComments": " Image data as bytes\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 1],
        "span": [147, 2, 24],
        "leadingComments": " Path to the model checkpoint file\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 2],
        "span": [149, 2, 24],
        "leadingComments": " Type of model to determine preprocessing/postprocessing\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 3],
        "span": [151, 2, 46],
        "leadingComments": " Model-specific thresholding parameters\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 4],
        "span": [153, 2, 34],
        "leadingComments": " When true, include RLE-encoded SAM2 segmentation masks in each Blob2D\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11],
        "span": [157, 0, 164, 1],
        "leadingComments": " Response from inference\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 0],
        "span": [160, 4, 44],
        "leadingComments": " Successful inference result\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 1],
        "span": [162, 4, 20],
        "leadingComments": " Error information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12],
        "span": [167, 0, 174, 1],
        "leadingComments": " Successful inference result\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12, 2, 0],
        "span": [169, 2, 33],
        "leadingComments": " Detected matches (detector box + contour, optionally a mask)\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12, 2, 1],
        "span": [171, 2, 40],
        "leadingComments": " Processing time in milliseconds\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12, 2, 2],
        "span": [173, 2, 33],
        "leadingComments": " Model path\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13],
        "span": [177, 0, 180, 1],
        "leadingComments": " Error information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 17],
        "span": [200, 2, 28],
        "leadingComments": "",
        "trailingComments": " inference container not reachable\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 18],
        "span": [201, 2, 30],
        "leadingComments": "",
        "trailingComments": " not cached and no network to fetch (offline miss)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2],
        "span": [210, 0, 214, 1],
        "leadingComments":
          " In-plane grasp orientation reference for plane projection. OBJECT aligns the\n grasp X to the detection's principal axis (with a square-deadband fallback to\n plane X); PLANE aligns to the plane's X axis; WORLD aligns to base-frame X\n projected onto the plane. Approach (Z) is always the plane normal.\n",
        "trailingComments": "",
        "leadingDetachedComments": [" ── RunPlaneProjection ──────────────────────────────────────\n"],
      }, {
        "path": [4, 14],
        "span": [217, 0, 230, 1],
        "leadingComments": " Request to compute 3D poses from 2D detections\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 0],
        "span": [218, 2, 219, 8],
        "leadingComments": "",
        "trailingComments": " from any detection method (YOLO, text prompt, manual, etc)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 1],
        "span": [220, 2, 18],
        "leadingComments": "",
        "trailingComments": " RGB image\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 2],
        "span": [221, 2, 33],
        "leadingComments": "",
        "trailingComments": " required for GeometricPlane, optional for ManualPlane\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 3],
        "span": [222, 2, 33],
        "leadingComments": "",
        "trailingComments": " extrinsics/intrinsics\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 4],
        "span": [223, 2, 40],
        "leadingComments": "",
        "trailingComments": " ManualPlane, GeometricPlane, LearnedPlane\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 6],
        "span": [225, 2, 29],
        "leadingComments": "",
        "trailingComments": " in-plane grasp orientation reference (default OBJECT)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14, 2, 7],
        "span": [229, 2, 58],
        "leadingComments":
          " Canonical orientation frame from teach time (when reliable). When present\n and grasp_frame == OBJECT, ManualPlane registers each detected contour\n against this instead of bare PCA, resolving the 180° flip.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15],
        "span": [233, 0, 238, 1],
        "leadingComments": " Camera intrinsics/extrinsics needed for 2D→3D conversion\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15, 2, 3],
        "span": [237, 2, 50],
        "leadingComments": "",
        "trailingComments": " robot ee pose in base frame\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17],
        "span": [256, 0, 261, 1],
        "leadingComments": " Fixed plane defined by three points\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17, 2, 3],
        "span": [260, 2, 35],
        "leadingComments": "",
        "trailingComments": " Offset along plane normal (meters)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18],
        "span": [264, 0, 270, 1],
        "leadingComments": " RANSAC plane fitting on local depth within each detection's bounding box\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18, 2, 0],
        "span": [265, 2, 36],
        "leadingComments": "",
        "trailingComments": " RANSAC iterations (default: 1000)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18, 2, 1],
        "span": [266, 2, 40],
        "leadingComments": "",
        "trailingComments": " Inlier distance threshold in meters (default: 0.01)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18, 2, 2],
        "span": [267, 2, 33],
        "leadingComments": "",
        "trailingComments": " Minimum points for plane fit (default: 3)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 18, 2, 3],
        "span": [268, 2, 269, 8],
        "leadingComments": "",
        "trailingComments": " Max tilt from base-frame Z-axis in degrees (default: no filtering)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 19],
        "span": [273, 0, 275, 1],
        "leadingComments": " Learned surface normal estimation (M2 placeholder)\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21, 2, 0],
        "span": [287, 2, 38],
        "leadingComments": "",
        "trailingComments": " 3D detections with 6D poses\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 21, 2, 2],
        "span": [289, 2, 41],
        "leadingComments": "",
        "trailingComments": " colorized depth map with overlays\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 0],
        "span": [293, 2, 26],
        "leadingComments": "",
        "trailingComments": " original 2D detection for debugging\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 1],
        "span": [294, 2, 35],
        "leadingComments": "",
        "trailingComments": " 6D pose in base frame\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 2],
        "span": [295, 2, 36],
        "leadingComments": "",
        "trailingComments": " Surface normal at detection point (in base frame)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 3],
        "span": [296, 2, 18],
        "leadingComments": "",
        "trailingComments": " 2D detection confidence score\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 4],
        "span": [297, 2, 34],
        "leadingComments": "",
        "trailingComments": " RANSAC plane fit quality, GeometricPlane only\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 5],
        "span": [298, 2, 299, 8],
        "leadingComments": "",
        "trailingComments": " OBB half-extents in meters (x=largest, y=medium, z=smallest)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 22, 2, 6],
        "span": [303, 2, 30],
        "leadingComments":
          " SAM2 segmentation echoed back from the input LocateMatch.segment so callers\n can render the contour (not just the detector box). Unset when the input\n match had no segment.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 0],
        "span": [334, 2, 33],
        "leadingComments": "",
        "trailingComments": " OpenCV/template/text-prompt: detector box + contour\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4, 2, 0],
        "span": [555, 2, 16],
        "leadingComments": "",
        "trailingComments": " oriented bounding box from depth point cloud (no CAD, zero-config)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4, 2, 1],
        "span": [556, 2, 10],
        "leadingComments": "",
        "trailingComments": " point cloud registration against CAD model\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4, 2, 2],
        "span": [557, 2, 22],
        "leadingComments": "",
        "trailingComments": " (M2) FoundationPose 6DoF pose estimation\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4, 2, 3],
        "span": [558, 2, 14],
        "leadingComments": "",
        "trailingComments": " OBB initial guess + ICP refinement against primitive mesh or CAD\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4, 2, 4],
        "span": [559, 2, 15],
        "leadingComments": "",
        "trailingComments": " FPFH feature-based global registration + ICP refinement (no initial guess;\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 57, 2, 1],
        "span": [570, 2, 18],
        "leadingComments": "",
        "trailingComments": " box: length (m), cylinder: diameter (m)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 57, 2, 2],
        "span": [571, 2, 18],
        "leadingComments": "",
        "trailingComments": " box: width (m), cylinder: unused\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 57, 2, 3],
        "span": [572, 2, 18],
        "leadingComments": "",
        "trailingComments": " box: height (m), cylinder: height (m)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 58],
        "span": [577, 0, 585, 1],
        "leadingComments":
          " CAD model shipped inline as bytes (matches encoded_template_images pattern).\n Vision-bot writes to a temp file, loads via Open3D, and caches by content_hash.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 58, 2, 0],
        "span": [578, 2, 17],
        "leadingComments": "",
        "trailingComments": " raw file bytes\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 58, 2, 1],
        "span": [579, 2, 20],
        "leadingComments": "",
        "trailingComments": ' "stl" | "obj" | "ply"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 58, 2, 2],
        "span": [580, 2, 26],
        "leadingComments": "",
        "trailingComments": " sha256 of data; vision-bot cache key\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 58, 2, 3],
        "span": [584, 2, 26],
        "leadingComments":
          " Native units of the mesh — STL/OBJ don't encode units, so the user\n tells us at upload time. Vision-bot rescales to meters before ICP\n fitting; the visualizer applies the same factor when rendering.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 59, 2, 0],
        "span": [597, 4, 27],
        "leadingComments": "",
        "trailingComments": " context (not used for detection — that's done in step 1)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 59, 2, 1],
        "span": [598, 4, 30],
        "leadingComments": "",
        "trailingComments": " filesystem path (dev/debug only)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 59, 2, 2],
        "span": [599, 4, 43],
        "leadingComments": "",
        "trailingComments": " for FoundationPose model-free\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 59, 2, 3],
        "span": [600, 4, 39],
        "leadingComments": "",
        "trailingComments": " server generates mesh from primitive dims\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 59, 2, 4],
        "span": [601, 4, 36],
        "leadingComments": "",
        "trailingComments": " user-uploaded CAD shipped inline\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 0],
        "span": [612, 2, 38],
        "leadingComments": "",
        "trailingComments": " pre-detected matches (box + optional mask) from 2D step\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 1],
        "span": [613, 2, 24],
        "leadingComments": "",
        "trailingComments": " uint16 depth (mm), full frame\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 3],
        "span": [615, 2, 39],
        "leadingComments": "",
        "trailingComments": " how to estimate 6DoF per detection\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 4],
        "span": [616, 2, 48],
        "leadingComments": "",
        "trailingComments": " CAD model path / context\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 5],
        "span": [617, 2, 42],
        "leadingComments": "",
        "trailingComments": " min score (default: 0.5)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 6],
        "span": [618, 2, 36],
        "leadingComments": "",
        "trailingComments": " limit results (default: 10)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 8],
        "span": [620, 2, 621, 8],
        "leadingComments": "",
        "trailingComments": " percentile to clip from each end of depth projections (default: 2 → 2nd/98th)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 9],
        "span": [622, 2, 623, 9],
        "leadingComments": "",
        "trailingComments": " FPFH_ICP: RANSAC+ICP attempts; keep best ICP fit (default: 4)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 61, 2, 10],
        "span": [624, 2, 625, 9],
        "leadingComments": "",
        "trailingComments": " FPFH_ICP: downsampling + FPFH feature voxel size in meters (default: 0.003)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 64, 2, 2],
        "span": [650, 2, 23],
        "leadingComments": "",
        "trailingComments": ' "fast" | "standard" | "fine"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 64, 2, 3],
        "span": [654, 2, 43],
        "leadingComments":
          " When set, vision-bot forward-scores the patch grid with this head and\n returns DinoEmbeddingsTensor.heatmap_fp16. The learned locate path\n never needs the raw tensor — set omit_tensor to skip the ~1MB payload.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 66, 2, 3],
        "span": [669, 2, 19],
        "leadingComments": "",
        "trailingComments": " float16 row-major, L2-normalized per patch; empty when\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 66, 2, 4],
        "span": [671, 2, 27],
        "leadingComments": " the request set omit_tensor\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 66, 2, 5],
        "span": [672, 2, 20],
        "leadingComments": "",
        "trailingComments": " letterboxed dims fed to the model, for un-letterboxing\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 66, 2, 9],
        "span": [678, 2, 35],
        "leadingComments":
          " Sigmoid scores per grid cell, float16 row-major, grid_h*grid_w entries.\n Present iff the request carried locate_head.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 67, 2, 2],
        "span": [692, 2, 23],
        "leadingComments": "",
        "trailingComments": ' "fast" | "standard" | "fine"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 69, 2, 1],
        "span": [704, 2, 19],
        "leadingComments": "",
        "trailingComments": " float16, L2-normalized\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 69, 2, 2],
        "span": [708, 2, 27],
        "leadingComments":
          " Model version string carries an \"-img\" suffix relative to the patch\n RPC's version so stored embeddings can't accidentally cross between\n the two RPCs' embedding spaces.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 70],
        "span": [737, 0, 741, 1],
        "leadingComments": " A single SAM2 point prompt, in the same pixel space as the enclosing box.\n",
        "trailingComments": "",
        "leadingDetachedComments": [
          ' ── SegmentMask ──────────────────────────────────────────────\n Segment objects in an image given axis-aligned box prompts. Mirrors the\n SAM2 step in text_prompt_backend.GroundingDinoSam2Backend._run_sam2; used\n by DinoFast at fine ("High") precision to refine OBBs from patch-grid\n approximations into pixel-accurate masks.\n\n The handler runs SAM2 image-encoding once (single set_image), then predicts\n per box so each box can carry its own point prompts. For each input box it\n returns the largest contour from the SAM2 mask as a Blob2D, plus the\n RLE-encoded mask. One Blob2D per input box, in input order. When SAM2 returns\n no contour for a given box, the corresponding entry in `was_segmented` is\n false and the matching Blob2D is an empty-contour placeholder.\n\n When `heatmap_samples` is supplied, the handler instead runs SAM2 with\n multimask_output=True and, per box, picks the candidate mask whose interior\n best matches the DINO heatmap — maximizing net above-threshold mass (sum of\n `score - heatmap_threshold` over samples inside the mask). This rejects the\n over-inclusive whole-object mask that grabs adjacent low-activation\n structure such as a cast shadow. Empty `heatmap_samples` ⇒ legacy\n single-mask behavior (multimask_output=False).\n\n When `method` is a filter (GUIDED_FILTER or BILATERAL_SOLVER), the handler\n ignores `heatmap_samples` and instead refines `heatmap_dense` with the\n cropped RGB as edge guidance. `boxes` is still used to crop the ROI.\n',
        ],
      }, {
        "path": [4, 70, 2, 2],
        "span": [740, 2, 20],
        "leadingComments": "",
        "trailingComments": " true = object (label 1), false = exclude (label 0)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 71, 2, 4],
        "span": [750, 2, 34],
        "leadingComments":
          " SAM2-only: optional point prompts for this box. Empty = box-only prompt.\n Ignored when method is GUIDED_FILTER or BILATERAL_SOLVER.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 72],
        "span": [756, 0, 760, 1],
        "leadingComments":
          " A DINO heatmap sample in the same cropped-image pixel space as the boxes:\n the patch-grid similarity score at a patch center. Used to score SAM2\n multimask candidates (see SegmentMaskRequest).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 7],
        "span": [766, 0, 775, 1],
        "leadingComments":
          " Segmentation/refinement backend used to turn box prompts + the DINO heatmap\n into a pixel mask. SAM2 is the prompt-based zero-shot segmenter; the two\n filters are CPU-only edge-aware refiners that sharpen the dense heatmap to\n image edges (no GPU, no model download).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 7, 2, 0],
        "span": [767, 2, 31],
        "leadingComments": "",
        "trailingComments": " default == existing behavior\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 7, 2, 3],
        "span": [774, 2, 44],
        "leadingComments":
          " Model-free: trace the object contour directly where the dense DINO heatmap\n crosses `heatmap_threshold` (cv2.findContours on the binarized heatmap).\n Requires `heatmap_dense` like the filter methods; ignores `heatmap_samples`\n and per-box `points`.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 73, 2, 2],
        "span": [781, 2, 45],
        "leadingComments": " SAM2-only: multimask candidate selection (see SegmentMask docstring).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 73, 2, 3],
        "span": [784, 2, 30],
        "leadingComments":
          " DINO score threshold separating object from background. Used by every\n method to binarize the refined map / score multimask candidates.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 73, 2, 4],
        "span": [786, 2, 32],
        "leadingComments": " Which backend to run. Default 0 = SAM2.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 73, 2, 5],
        "span": [791, 2, 26],
        "leadingComments":
          " Dense DINO heatmap, float16 row-major, at the SAME resolution and pixel\n space as `image` (cropped-ROI). Required for the filter methods (it is\n their input); optional for SAM2, which when present gates masks back to\n the heatmap's foreground support (excising cast-shadow bleed).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 76, 2, 0],
        "span": [819, 2, 15],
        "leadingComments": "",
        "trailingComments": " normalized [0,1] in source-image space\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 77, 2, 0],
        "span": [825, 2, 28],
        "leadingComments": "",
        "trailingComments": " embedding_dim floats\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 78, 2, 2],
        "span": [831, 2, 24],
        "leadingComments": "",
        "trailingComments": " hidden * input_dim, row-major\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 78, 2, 3],
        "span": [832, 2, 24],
        "leadingComments": "",
        "trailingComments": " hidden\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 78, 2, 4],
        "span": [833, 2, 24],
        "leadingComments": "",
        "trailingComments": " hidden\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 79, 2, 1],
        "span": [839, 2, 23],
        "leadingComments": "",
        "trailingComments": " input_dim\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 81, 2, 0],
        "span": [857, 2, 24],
        "leadingComments": "",
        "trailingComments": " one per teach session; new id on GPU-runner switch\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 81, 2, 1],
        "span": [858, 2, 17],
        "leadingComments": "",
        "trailingComments": " monotonic per session\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 81, 2, 4],
        "span": [861, 2, 23],
        "leadingComments": "",
        "trailingComments": ' "fast" | "standard" | "fine"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 81, 2, 5],
        "span": [862, 2, 34],
        "leadingComments": "",
        "trailingComments": " pending session clicks, on this frame\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 81, 2, 6],
        "span": [865, 2, 51],
        "leadingComments":
          " Reference embeddings from clicks committed in prior teach sessions\n (persisted in the skill by the client; their source frames are gone).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 82, 2, 2],
        "span": [873, 2, 19],
        "leadingComments": "",
        "trailingComments": " float16 row-major sigmoid scores, grid_h*grid_w entries\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 82, 2, 3],
        "span": [874, 2, 20],
        "leadingComments": "",
        "trailingComments": " letterbox meta for client-side rasterization\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 83, 2, 1],
        "span": [883, 2, 22],
        "leadingComments": "",
        "trailingComments": " true ⇒ no other fields set; a newer seq already arrived\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 83, 2, 4],
        "span": [888, 2, 48],
        "leadingComments":
          " Parallel to request.clicks: the embedding under each click, for the\n client to persist as committed references on save.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 0],
        "span": [901, 2, 24],
        "leadingComments": "",
        "trailingComments": " uint16 mm, aligned to color\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 2],
        "span": [903, 2, 28],
        "leadingComments": "",
        "trailingComments": " distance_threshold = threshold at 1 m\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 3],
        "span": [904, 2, 36],
        "leadingComments": "",
        "trailingComments": " disable depth-adaptive scaling\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 4],
        "span": [905, 2, 29],
        "leadingComments": "",
        "trailingComments": " reserved for future text-prompt mode\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 5],
        "span": [906, 2, 44],
        "leadingComments": "",
        "trailingComments": " clicked points, color-frame px\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 6],
        "span": [907, 2, 39],
        "leadingComments": "",
        "trailingComments": " default 4; preview uses 8\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 7],
        "span": [908, 2, 33],
        "leadingComments": "",
        "trailingComments": " camera-Z band, default 0.25\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 8],
        "span": [909, 2, 33],
        "leadingComments": "",
        "trailingComments": " default 2.5\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 85, 2, 9],
        "span": [910, 2, 37],
        "leadingComments": "",
        "trailingComments": " default 1\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 86, 2, 0],
        "span": [915, 2, 41],
        "leadingComments": "",
        "trailingComments": " base frame, canonical axes\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 86, 2, 1],
        "span": [916, 2, 36],
        "leadingComments": "",
        "trailingComments": " base frame, toward camera\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 86, 2, 5],
        "span": [920, 2, 27],
        "leadingComments": "",
        "trailingComments": " vs base +Z\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 86, 2, 7],
        "span": [922, 2, 37],
        "leadingComments": "",
        "trailingComments": " RLE at strided resolution\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 87],
        "span": [931, 0, 935, 1],
        "leadingComments":
          " Per-click outline of the valid-depth pixels sampled in that click's window.\n Lets the UI show users exactly which pixels each click contributes to the\n fit (so a click straddling a border/object is visible). One per accepted\n seed; clicks with no usable depth (see ignored_seed_indices) have none.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 87, 2, 0],
        "span": [932, 2, 23],
        "leadingComments": "",
        "trailingComments": " indexes into request seed_points\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 87, 2, 1],
        "span": [933, 2, 934, 8],
        "leadingComments": "",
        "trailingComments": " boundary tracing the sampled pixels, full-res color-frame px\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 88, 2, 0],
        "span": [938, 2, 37],
        "leadingComments": "",
        "trailingComments": " quality-ordered\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 88, 2, 1],
        "span": [939, 2, 42],
        "leadingComments": "",
        "trailingComments": " clicks with no usable depth\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 88, 2, 3],
        "span": [941, 2, 39],
        "leadingComments": "",
        "trailingComments": " per-click sampled-pixel outlines\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 90, 2, 0],
        "span": [959, 2, 22],
        "leadingComments": "",
        "trailingComments": ' "<project>/<version>", e.g. "adient-seat-inspection/16"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 90, 2, 1],
        "span": [960, 2, 21],
        "leadingComments": "",
        "trailingComments": " Roboflow workspace/enterprise key (per-request)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 96, 2, 2],
        "span": [997, 2, 18],
        "leadingComments": "",
        "trailingComments": " encoded image bytes (png/jpg)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 96, 2, 3],
        "span": [1001, 2, 46],
        "leadingComments":
          " Applied by vision-bot AFTER a raw (unfiltered) inference so filtering matches\n the checkpoint path (confidence / nms_threshold / max_detections) rather than\n the Roboflow model's built-in thresholds.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 97],
        "span": [1008, 0, 1011, 1],
        "leadingComments":
          " Object-detection run: each prediction is mapped to a LocateMatch (detector\n box, segment unset) so the result feeds the locate pipeline exactly like\n CheckpointBasedInferenceResult. Non-detection models are rejected (guarded)\n rather than producing degenerate boxes.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 99, 2, 3],
        "span": [1024, 2, 18],
        "leadingComments": "",
        "trailingComments": " encoded image bytes; bound to the workflow's image input\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 100, 2, 0],
        "span": [1029, 2, 26],
        "leadingComments": " Workflow outputs vary per workflow, so return them as a JSON string in v1.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".visionbot.OrientationReferenceRejection": OrientationReferenceRejection,
    ".visionbot.ErrorCode": ErrorCode,
    ".visionbot.GraspFrame": GraspFrame,
    ".visionbot.ExtrinsicsKind": ExtrinsicsKind,
    ".visionbot.PoseEstimationMethod": PoseEstimationMethod,
    ".visionbot.PrimitiveShapeType": PrimitiveShapeType,
    ".visionbot.CadModelUnits": CadModelUnits,
    ".visionbot.SegmentationMethod": SegmentationMethod,
    ".visionbot.LocateHeadKind": LocateHeadKind,
    ".visionbot.Blob2D": Blob2D,
    ".visionbot.Detection2D": Detection2D,
    ".visionbot.LocateMatch": LocateMatch,
    ".visionbot.OrientationReference": OrientationReference,
    ".visionbot.Contour2D": Contour2D,
    ".visionbot.ComputeOrientationReferenceRequest": ComputeOrientationReferenceRequest,
    ".visionbot.ComputeOrientationReferenceData": ComputeOrientationReferenceData,
    ".visionbot.ComputeOrientationReferenceResponse": ComputeOrientationReferenceResponse,
    ".visionbot.Model": Model,
    ".visionbot.ModelList": ModelList,
    ".visionbot.RunCheckpointBasedInferenceRequest": RunCheckpointBasedInferenceRequest,
    ".visionbot.RunCheckpointBasedInferenceRequest.ThresholdingParamsEntry":
      RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry,
    ".visionbot.RunCheckpointBasedInferenceResponse": RunCheckpointBasedInferenceResponse,
    ".visionbot.CheckpointBasedInferenceResult": CheckpointBasedInferenceResult,
    ".visionbot.Error": Error,
    ".visionbot.RunPlaneProjectionRequest": RunPlaneProjectionRequest,
    ".visionbot.CameraParams": CameraParams,
    ".visionbot.PlaneDetectionMethod": PlaneDetectionMethod,
    ".visionbot.ManualPlane": ManualPlane,
    ".visionbot.GeometricPlane": GeometricPlane,
    ".visionbot.LearnedPlane": LearnedPlane,
    ".visionbot.RunPlaneProjectionResponse": RunPlaneProjectionResponse,
    ".visionbot.PlaneProjectionResult": PlaneProjectionResult,
    ".visionbot.Detection3D": Detection3D,
    ".visionbot.BlobDetectionParams": BlobDetectionParams,
    ".visionbot.DetectBlobsRequest": DetectBlobsRequest,
    ".visionbot.DetectBlobsResponse": DetectBlobsResponse,
    ".visionbot.BlobList": BlobList,
    ".visionbot.ShapeDetectionParams": ShapeDetectionParams,
    ".visionbot.DetectShapesRequest": DetectShapesRequest,
    ".visionbot.DetectShapesResponse": DetectShapesResponse,
    ".visionbot.TextPromptDetectionParams": TextPromptDetectionParams,
    ".visionbot.DetectTextPromptRequest": DetectTextPromptRequest,
    ".visionbot.DetectTextPromptResponse": DetectTextPromptResponse,
    ".visionbot.ClassifyRequest": ClassifyRequest,
    ".visionbot.ClassifyResponse": ClassifyResponse,
    ".visionbot.ClassifyResult": ClassifyResult,
    ".visionbot.Chessboard": Chessboard,
    ".visionbot.CameraIntrinsicsMsg": CameraIntrinsicsMsg,
    ".visionbot.CameraIntrinsicsExtendedMsg": CameraIntrinsicsExtendedMsg,
    ".visionbot.GetChessboardCornersRequest": GetChessboardCornersRequest,
    ".visionbot.GetChessboardCornersResponse": GetChessboardCornersResponse,
    ".visionbot.ChessboardCornersResult": ChessboardCornersResult,
    ".visionbot.GetCameraChessboardTransformRequest": GetCameraChessboardTransformRequest,
    ".visionbot.GetCameraChessboardTransformResponse": GetCameraChessboardTransformResponse,
    ".visionbot.CalibrateCameraRequest": CalibrateCameraRequest,
    ".visionbot.CalibrateCameraResponse": CalibrateCameraResponse,
    ".visionbot.IntrinsicCalibrationResult": IntrinsicCalibrationResult,
    ".visionbot.CalibrateCameraIntrinsicsRequest": CalibrateCameraIntrinsicsRequest,
    ".visionbot.CalibrateCameraIntrinsicsResponse": CalibrateCameraIntrinsicsResponse,
    ".visionbot.CalibrateCameraExtrinsicsRequest": CalibrateCameraExtrinsicsRequest,
    ".visionbot.CalibrateCameraExtrinsicsResponse": CalibrateCameraExtrinsicsResponse,
    ".visionbot.AssessCalibrationCoverageRequest": AssessCalibrationCoverageRequest,
    ".visionbot.CoverageBucketMsg": CoverageBucketMsg,
    ".visionbot.QualityIssueMsg": QualityIssueMsg,
    ".visionbot.CalibrationRecommendationMsg": CalibrationRecommendationMsg,
    ".visionbot.CalibrationCoverageResultMsg": CalibrationCoverageResultMsg,
    ".visionbot.AssessCalibrationCoverageResponse": AssessCalibrationCoverageResponse,
    ".visionbot.PrimitiveShape": PrimitiveShape,
    ".visionbot.CadModelFile": CadModelFile,
    ".visionbot.ObjectReference": ObjectReference,
    ".visionbot.ReferenceImageSet": ReferenceImageSet,
    ".visionbot.Run3DPoseEstimationRequest": Run3DPoseEstimationRequest,
    ".visionbot.Run3DPoseEstimationResponse": Run3DPoseEstimationResponse,
    ".visionbot.PoseEstimation3DResult": PoseEstimation3DResult,
    ".visionbot.ComputeDinoEmbeddingsRequest": ComputeDinoEmbeddingsRequest,
    ".visionbot.ComputeDinoEmbeddingsResponse": ComputeDinoEmbeddingsResponse,
    ".visionbot.DinoEmbeddingsTensor": DinoEmbeddingsTensor,
    ".visionbot.ComputeDinoImageEmbeddingRequest": ComputeDinoImageEmbeddingRequest,
    ".visionbot.ComputeDinoImageEmbeddingResponse": ComputeDinoImageEmbeddingResponse,
    ".visionbot.DinoImageEmbedding": DinoImageEmbedding,
    ".visionbot.PointPrompt": PointPrompt,
    ".visionbot.Box2DXyxy": Box2DXyxy,
    ".visionbot.HeatmapSample": HeatmapSample,
    ".visionbot.SegmentMaskRequest": SegmentMaskRequest,
    ".visionbot.SegmentMaskResponse": SegmentMaskResponse,
    ".visionbot.MaskSegmentationResult": MaskSegmentationResult,
    ".visionbot.LocateClick": LocateClick,
    ".visionbot.ReferenceVector": ReferenceVector,
    ".visionbot.MlpLocateHeadProto": MlpLocateHeadProto,
    ".visionbot.LogisticLocateHeadProto": LogisticLocateHeadProto,
    ".visionbot.LocateHeadProto": LocateHeadProto,
    ".visionbot.TrainLocateHeadRequest": TrainLocateHeadRequest,
    ".visionbot.LocateHeatmap": LocateHeatmap,
    ".visionbot.TrainLocateHeadResult": TrainLocateHeadResult,
    ".visionbot.TrainLocateHeadResponse": TrainLocateHeadResponse,
    ".visionbot.DetectScenePlaneRequest": DetectScenePlaneRequest,
    ".visionbot.ScenePlane": ScenePlane,
    ".visionbot.SeedWindow": SeedWindow,
    ".visionbot.ScenePlaneResult": ScenePlaneResult,
    ".visionbot.DetectScenePlaneResponse": DetectScenePlaneResponse,
    ".visionbot.PreloadRoboflowModelRequest": PreloadRoboflowModelRequest,
    ".visionbot.PreloadRoboflowModelResult": PreloadRoboflowModelResult,
    ".visionbot.PreloadRoboflowModelResponse": PreloadRoboflowModelResponse,
    ".visionbot.PreloadRoboflowWorkflowRequest": PreloadRoboflowWorkflowRequest,
    ".visionbot.PreloadRoboflowWorkflowResult": PreloadRoboflowWorkflowResult,
    ".visionbot.PreloadRoboflowWorkflowResponse": PreloadRoboflowWorkflowResponse,
    ".visionbot.RunRoboflowDetectionRequest": RunRoboflowDetectionRequest,
    ".visionbot.RunRoboflowDetectionRequest.ThresholdingParamsEntry":
      RunRoboflowDetectionRequest_ThresholdingParamsEntry,
    ".visionbot.RunRoboflowDetectionResult": RunRoboflowDetectionResult,
    ".visionbot.RunRoboflowDetectionResponse": RunRoboflowDetectionResponse,
    ".visionbot.RunRoboflowWorkflowRequest": RunRoboflowWorkflowRequest,
    ".visionbot.RunRoboflowWorkflowResult": RunRoboflowWorkflowResult,
    ".visionbot.RunRoboflowWorkflowResponse": RunRoboflowWorkflowResponse,
    ".visionbot.VisionBotService": VisionBotServiceClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2, protoMetadata3, protoMetadata4],
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
